
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Button } from '../../Components/UI/button';
import { SmallButton } from '../../Components/UI/small-button';
import { Input } from '../../Components/UI/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../Components/UI/table';
import { Card, CardContent } from '../../Components/UI/card';
import { Search, Plus, Settings, User, Loader2, Filter, Calendar, CheckCircle, LayoutList, CalendarRange, Clock, Folder, AlertCircle, X, Pencil, Check, Building2, ArrowUp, ArrowDown, ArrowUpLeft, ArrowDownRight, ChevronUp, ChevronDown, ArrowDownWideNarrow, Trash2, ArrowLeft, Phone, BellRing, MapPin, Users, Mail, FileText, PhoneOutgoing, PhoneMissed, ListTodo, MessageSquare, CalendarHeart, Calendar1, CheckSquare, ClipboardList, Bell, ClockFading, History, RotateCcw, RotateCw, CircleCheckBig, SlidersHorizontal, UserRound, Palette, XCircle, Ban, RefreshCcw, SquareCheckBig, GitFork, ShieldCheck, Layers, ChevronRight } from 'lucide-react';
import { Checkbox } from '../../Components/UI/checkbox';
import { AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from '../../Components/UI/alert-dialog';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '../../Components/UI/tooltip';
import Pagination from '../../Components/Common/Pagination';
import { canEditTask, getColorClass, getCurrentUser, getDateRangeOptions, getFinYearOptions, getOtherMonthOptions, getOtherQuarterOptions, getOtherYearOptions, getRelativeDateText, getTaskColor, getThreadTypeMeta, isRecordInDateRange, months, getMyAgenciesMappedIDs, getTaskCategoryIDForUser, getTaskPriorityForUser, getTaskTitleForUser, getAgencyNameByID, isIOSDevice, openInExternalBrowser, extractObserverUserIDs, findUserByIDOrMobile, calculateSuggestedReminder, getTaskCompletionWhatsAppMessage, getTaskActionWhatsAppMessage, playTaskSuccessSound } from '../../Utils/Utilities';
import { format, addMonths } from 'date-fns';
import { getTableDateOrWeekday } from '../../Utils/DateTime';
import useIsMobile from '../../Hooks/useIsMobile';
import usePullToRefresh from '../../Hooks/usePullToRefresh';
import { useModalBackButton } from '../../Hooks/useModalBackButton';
import { triggerHaptic } from '../../Hooks/useHaptics';
import DrawerFilter from '../../Components/Common/DrawerFilter';
import MobileFullScreenDropdown from '../../Components/Common/MobileDropdown';
import { Drawer, DrawerClose, DrawerContent, DrawerFooter } from '../../Components/UI/drawer';
import { RiResetLeftFill } from 'react-icons/ri';
import { BsBellFill, BsHourglassBottom, BsHourglassTop, BsWhatsapp } from 'react-icons/bs';
import { useLocation, useNavigate } from 'react-router-dom';
import { CommonFilter } from '../../Components/Common/CommonFilter';
import { connect, useSelector, useDispatch } from "react-redux";
import { checkIfInqOnlyMode, getActiveThreadTypesArr, getThreadTypesArr, getUsersArr, getAllUsersArr, getAgencyDetails, isSmartSellerMode, getUserConfig, updateHeaderConfig } from "../../Store/Reducers";
import { cancelTaskAPI, rejectTaskAPI, completeTaskAPI, remindTaskAPI, reopenTaskAPI, bulkTaskActionAPI, manageTaskAPI, getTaskHistoryAPI /*, markAsDoneAPI */ } from './TasksAPI';
import { setGlobalLoading } from '../../Store/Actions';
import { getAuthData } from '../../Utils/AuthUtils';
import apiService from '../../Services/APIService';
import TaskEntry from './TaskEntry';
import UserEntry from '../Users/UserEntry';
import TaskTimesManager from '../../Components/Common/TaskTimesManager';
import { TimePickerDialog, TimeInputWithDialog } from '../../Components/Common/TimePickerWatch';
import { cn } from "../../Lib/Cn";
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../../Components/UI/hover-card';
import { Tabs, TabsContent, TabsList, TabsTrigger, TabsTriggerCondensed } from '../../Components/UI/tabs';
import { Calendar as UICalendar } from '../../Components/UI/calendar';
import ThreadSahiIcon from '../../Components/Common/ThreadSahiIcon';
import { Badge } from '../../Components/UI/badge';
import { toast } from 'sonner';
import { AlertBox } from '../../Components/Common/AlertBox';
import { TaskCompleteDialog } from '../../Components/Common/TaskCompleteDialog';
import RecordEntry from '../Records/RecordsEntry';
import { getThreadModeTitle } from '../../Utils/Utilities';
import TaskDetailDialog from '../Connections/Tabs/TaskDetails';
import TaskCategoryManager from '../../Components/Common/TaskCategoryManager';
import TaskDetails from './TaskDetails';
import { getPriorityDetails } from '../../Utils/Constants';
import { handlePhoneClickAction } from '../../Utils/ContactLogUtils';
import taskClassConfig from '../../Config/taskClassConfig.json';
import { MdPhone } from 'react-icons/md';
import TemplateDialog from '../../Components/Common/TemplateDialog';
import CustomSearchableDropdown from '../../Components/Common/CustomSearchableDD';
import PriorityBadge from '../../Components/Common/PriorityBadge';
import { useAllConnectionsFromIDB } from '../../Hooks/useConnectionData';

const badgeBase = "sahi-badge transition ease-in-out delay-150 hover:-translate-y-1 duration-200 border-foreground/10 text-foreground bg-card hover:bg-card/80"
const actionButton = "h-6 w-6 p-0 flex items-center justify-center hover:shadow-sm transform-gpu transition-colors duration-200 ease-out hover:scale-110 active:scale-95"
const loadingSpinner = "animate-spin sahi-radius border-2 border-t-transparent"

const UserRoundArrowLeft = ({ size = 12, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        <path d="m19 16-3 3" />
        <path d="M2 21a8 8 0 0 1 12.664-6.5" />
        <path d="M22 19h-6l3 3" />
        <circle cx="10" cy="8" r="5" />
    </svg>
);

const UserRoundArrowDown = ({ size = 12, className }) => (
    <span className="inline-flex items-center gap-0.5">
        <UserRound size={size} className={className} />
        <ArrowDown size={size - 2} className={className} />
    </span>
);

const UserRoundArrowUp = ({ size = 12, className }) => (
    <span className="inline-flex items-center gap-0.5">
        <UserRound size={size} className={className} />
        <ArrowUp size={size - 2} className={className} />
    </span>
);

const SwipeableTaskCard = ({
    task,
    index,
    range,
    length,
    currentUserID,
    currentUser,
    connectionData,
    taskActionLoading,
    myTaskCtgs,
    getExecutiveName,
    handleAction,
    handleItemAction,
    setTemplateDialogData,
    setTemplateDialogOpen,
    formatThreadDisplay,
    openTaskDetails,
    showTimeAlways = false,
}) => {
    const [offsetX, setOffsetX] = useState(0);
    const [isSwiping, setIsSwiping] = useState(false);
    const touchStart = useRef({ x: 0, y: 0 });
    const touchEnd = useRef({ x: 0, y: 0 });
    const isSwipeGesture = useRef(false);
    const hasVibrated = useRef(false);

    const isOverdue = task.dueDT && new Date(task.dueDT) < new Date();
    const taskID = task.tskID;
    const isLoading = taskActionLoading[taskID];
    const myUserIDs = getMyAgenciesMappedIDs('UserID');
    const isMyCreator = myUserIDs.includes(Number(task.createdUserID)) || Number(task.createdUserID) === currentUserID;
    const isMyAssignee = myUserIDs.includes(Number(task.pocUserID)) || Number(task.pocUserID) === currentUserID;
    const isTaskClosed = task.sts === 2 || task.sts === 4 || task.sts === 0 || task.sts === 3 || (task.sts === 1 && range === 'history');

    const getObserverIDs = (obs) => {
        if (!obs) return [];
        if (Array.isArray(obs)) return obs.map(Number);
        if (typeof obs === 'string') return obs.split(',').map(Number).filter(Boolean);
        return [];
    };
    const observerIDs = getObserverIDs(task.observerUserIDs);
    const isMyObserver = observerIDs.some(id => myUserIDs.includes(Number(id)) || Number(id) === currentUserID);
    const isOnlyObserver = isMyObserver && !isMyCreator && !isMyAssignee;

    const isAssignee = isMyAssignee && !isMyCreator && task.sts === 1;
    // Assignee or pure Observer declining the task/meeting is a Reject
    const canCancel = (isMyCreator || isAssignee || isOnlyObserver) && !isTaskClosed;
    const tc = Number(task.class || task.Class || task.taskClass || task.TaskClass || 1);
    const canComplete = !isOnlyObserver && (isMyCreator || (isAssignee && task.canComplete == true)) && !(tc === 4 && isMyCreator);
    const isReallyClosed = task.sts === 0 || task.sts === 2 || task.sts === 4 || task.sts === 3;
    const canReopen = !isOnlyObserver && isMyCreator && isReallyClosed && tc !== 2 && tc !== 3 && tc !== 4;

    const canSwipeLeft = (canCancel && !isLoading && !isTaskClosed) || (canReopen && !isLoading); // Cancel / Reject / Reopen
    const canSwipeRight = (canComplete && !isLoading && !isTaskClosed) || (canReopen && !isLoading); // Complete / Mark Done / Reopen

    const statusNote = task.statusNote?.trim() ||
        ((task.sts === 2 || (task.sts === 1 && range === 'history')) ? 'Completed' :
            (task.sts === 0) ? 'Cancelled' :
                (task.sts === 3) ? 'Rejected' :
                    'Not Started');

    const onTouchStart = (e) => {
        const touch = e.touches[0];
        touchStart.current = { x: touch.clientX, y: touch.clientY };
        touchEnd.current = { x: touch.clientX, y: touch.clientY };
        isSwipeGesture.current = false;
        hasVibrated.current = false;
        setIsSwiping(true);
    };

    const onTouchMove = (e) => {
        if (!isSwiping) return;
        const touch = e.touches[0];
        touchEnd.current = { x: touch.clientX, y: touch.clientY };
        const diffX = touch.clientX - touchStart.current.x;
        const diffY = touch.clientY - touchStart.current.y;

        if (!isSwipeGesture.current) {
            if (Math.abs(diffY) > Math.abs(diffX) && Math.abs(diffY) > 10) {
                setIsSwiping(false);
                return;
            }
            if (Math.abs(diffX) > 10) {
                isSwipeGesture.current = true;
            }
        }

        if (isSwipeGesture.current) {
            let limitedX = diffX;
            if (diffX > 0 && !canSwipeRight) limitedX = 0;
            if (diffX < 0 && !canSwipeLeft) limitedX = 0;

            if (Math.abs(limitedX) > 150) {
                const over = Math.abs(limitedX) - 150;
                limitedX = limitedX > 0 ? 150 + over * 0.2 : -150 - over * 0.2;
            }

            setOffsetX(limitedX);

            // Haptic vibration feedback at threshold crossing
            const threshold = 80;
            if (Math.abs(limitedX) >= threshold) {
                if (!hasVibrated.current) {
                    if (typeof navigator !== 'undefined' && navigator.vibrate) {
                        navigator.vibrate(15);
                    }
                    hasVibrated.current = true;
                }
            } else {
                hasVibrated.current = false;
            }
        }
    };

    const onTouchEnd = () => {
        if (!isSwiping) return;
        setIsSwiping(false);

        const threshold = 80;
        if (offsetX > threshold && canSwipeRight) {
            handleItemAction(canReopen ? 'REOPEN' : 'COMPLETE', task, 'task');
        } else if (offsetX < -threshold && canSwipeLeft) {
            handleItemAction(canReopen ? 'REOPEN' : 'CANCEL', task, 'task');
        }

        setOffsetX(0);
    };

    const handleClick = (e) => {
        const distance = Math.sqrt(
            Math.pow(touchEnd.current.x - touchStart.current.x, 2) +
            Math.pow(touchEnd.current.y - touchStart.current.y, 2)
        );
        if (distance > 10) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        openTaskDetails(task.tskID, isTaskClosed, task);
    };

    const isThresholdCrossed = Math.abs(offsetX) >= 80;
    const opacity = isThresholdCrossed ? 1 : 0.4 + (Math.min(Math.abs(offsetX) / 80, 1) * 0.45);
    const scaleFactor = isThresholdCrossed
        ? 1.25
        : 0.8 + (Math.min(Math.abs(offsetX) / 80, 1) * 0.35);

    const showRightAction = offsetX > 0 && canSwipeRight;
    const showLeftAction = offsetX < 0 && canSwipeLeft;

    const bgColor = canReopen
        ? ((showRightAction || showLeftAction) ? 'var(--sahi-dark-blue, #2563eb)' : 'transparent')
        : showRightAction
            ? 'var(--sahi-green, #10b981)'
            : showLeftAction
                ? 'var(--sahi-red, #ef4444)'
                : 'transparent';

    return (
        <div className="relative overflow-hidden w-full rounded-[7px] select-none">
            {/* Underlay swipe actions */}
            <div
                className="absolute inset-0 flex items-center justify-between px-8 rounded-[7px] text-white font-medium text-sm transition-all duration-200"
                style={{
                    backgroundColor: bgColor,
                    opacity: opacity
                }}
            >
                {/* Swipe Right action (Complete / Reopen) - exposes left side */}
                <div className={`flex items-center transition-opacity duration-150 ${showRightAction ? 'opacity-100' : 'opacity-0'}`}>
                    {canReopen ? (
                        <RotateCcw className="h-6 w-6 transition-transform duration-100 ease-out" style={{ transform: `scale(${scaleFactor})` }} />
                    ) : (
                        <Check className="h-6 w-6 transition-transform duration-100 ease-out" style={{ transform: `scale(${scaleFactor})` }} />
                    )}
                </div>
                {/* Swipe Left action (Cancel / Reopen) - exposes right side */}
                <div className={`flex items-center transition-opacity duration-150 ${showLeftAction ? 'opacity-100' : 'opacity-0'}`}>
                    {canReopen ? (
                        <RotateCw className="h-6 w-6 transition-transform duration-100 ease-out" style={{ transform: `scale(${scaleFactor})` }} />
                    ) : (
                        <X className="h-6 w-6 transition-transform duration-100 ease-out" style={{ transform: `scale(${scaleFactor})` }} />
                    )}
                </div>
            </div>

            {/* Card contents */}
            <div
                style={{
                    transform: `translateX(${offsetX}px)`,
                    transition: isSwiping ? 'none' : 'transform 200ms cubic-bezier(0.16, 1, 0.3, 1)',
                    userSelect: 'none'
                }}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                onClick={handleClick}
                className="bg-sahi-white rounded-[7px] shadow-sm border border-zinc-200 w-full f-col justify-between"
            >
                {/* --- Header Section (Same structure as dashboard) --- */}
                <div className="f-col gap-1 mobile-tile-header-layout-v2">
                    {/* L1: TypeIcon, Title (in bold), PriorityIcon */}
                    <div className="flex items-start gap-1.5 w-full mb-0.5 mt-1">
                        {/* ClassIcon */}
                        {!(Number(task.repeatAfter) > 0 || task.repeatDT) && (
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <span className="inline-flex items-center text-zinc-500 cursor-help shrink-0 mt-0.5">
                                            {getTaskClassIcon(task.class || task.Class || task.taskClass || task.TaskClass)}
                                        </span>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>{Number(task.class || task.Class || task.taskClass || task.TaskClass) === 2 ? "Meeting" : Number(task.class || task.Class || task.taskClass || task.TaskClass) === 3 ? "Decision" : Number(task.class || task.Class || task.taskClass || task.TaskClass) === 4 ? "Approval" : "Task"}</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        )}

                        {(Number(task.repeatAfter) > 0 || task.repeatDT) && (
                            <RefreshCcw className="h-3 w-3 text-zinc-500 shrink-0 mt-0.5" />
                        )}

                        {/* Title Text (in bold) */}
                        <span
                            className="font-semibold text-foreground leading-tight flex-1 break-words text-left -translate-y-0.5 text-sm"
                            style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                            }}
                        >
                            {task.ttl || "Untitled Task"}
                        </span>

                        {/* Right Icons: Category & Priority */}
                        <div className="flex items-center gap-1.5 shrink-0 mt-0.5">
                            {/* PriorityIcon */}
                            {task.pri && (() => {
                                const priority = getPriorityDetails(task.pri);
                                const IconComponent = priority.icon;
                                return priority.showBadge && (
                                    <span className="inline-flex items-center shrink-0" style={{ color: priority.color }}>
                                        <IconComponent className="h-3.5 w-3.5" style={{ color: priority.color }} strokeWidth={2} />
                                    </span>
                                );
                            })()}
                        </div>
                    </div>

                    {/* L2: Status (in italics) with category dot in front of it */}
                    <div className="flex items-start gap-1.5 w-full mb-0.5 text-xs text-zinc-500">
                        {/* Category dot */}
                        {(() => {
                            const usrCID = getTaskCategoryIDForUser(task, currentUserID) || null;
                            // Read-only display of a task's already-assigned category - show it even if
                            // the category itself was since deleted (IsD), only pickers exclude those.
                            const cat = usrCID ? myTaskCtgs.find(c => c.CID === usrCID) : null;
                            const dotColor = cat ? cat.Clr : '#e4e4e7'; // very light gray
                            const dotTitle = cat ? cat.CNm : 'No Category';
                            return (
                                <span className="mt-1 w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: dotColor }} title={dotTitle} />
                            );
                        })()}

                        <span className="italic line-clamp-2 leading-snug flex-1 text-left">
                            {statusNote}
                        </span>
                    </div>

                    {/* Thread Display (if any) */}
                    {task.threadNames?.trim() && (
                        <div className="overflow-hidden transition-all duration-300 ease-in-out max-h-96 opacity-100">
                            {formatThreadDisplay(task)}
                        </div>
                    )}

                    {/* L3: FactoryIcon BizName | PersonIcon AssignedTo (if not self) ... (bottom right) Bell/BellRing/HrGlass etc icon TargetDate/Time */}
                    <div className="flex justify-between items-end text-xs mt-0.5 mb-1 w-full gap-2">
                        {/* Left side: Business/Factory and AssignedTo */}
                        <div className="flex items-center gap-1.5 min-w-0 flex-1 text-zinc-500">
                            {task.bizName && (
                                <span className="flex items-center gap-1 min-w-0 max-w-[120px] xs:max-w-[140px] sm:max-w-[180px] shrink-1">
                                    <Building2 size={12} className="text-zinc-400 shrink-0" />
                                    <span className="truncate" title={task.bizName}>{task.bizName}</span>
                                </span>
                            )}
                            {task.bizName && (
                                (isMyCreator && !isMyAssignee && task.uID) ||
                                (!isMyCreator && (isMyAssignee || isMyObserver) && task.createdUserID)
                            ) && (
                                    <span className="text-zinc-300 mx-0.5 shrink-0">|</span>
                                )}
                            {isMyCreator && !isMyAssignee && task.uID && (
                                <span className="flex items-center gap-1 min-w-0 max-w-[100px] xs:max-w-[140px] sm:max-w-[180px] shrink-1">
                                    <ArrowUpLeft size={12} className="text-zinc-400 shrink-0" />
                                    <span className="truncate" title={getExecutiveName(task.uID, task)}>{getExecutiveName(task.uID, task)}</span>
                                </span>
                            )}
                            {!isMyCreator && (isMyAssignee || isMyObserver) && task.createdUserID && (
                                <span className="flex items-center gap-1 min-w-0 max-w-[100px] xs:max-w-[140px] sm:max-w-[180px] shrink-1">
                                    <ArrowDownRight size={12} className="text-zinc-400 shrink-0" />
                                    <span className="truncate" title={getExecutiveName(task.createdUserID, task)}>{getExecutiveName(task.createdUserID, task)}</span>
                                </span>
                            )}
                        </div>

                        {/* Right side: Target Date / Time with status/date icons */}
                        <div className="flex items-center gap-1 text-xs whitespace-nowrap flex-shrink-0 text-zinc-500">
                            {range === "history" && (() => {
                                const isCompleted = task.sts === 2 || task.sts === 1;
                                const isCancelled = task.sts === 4 || task.sts === 0;
                                const isRejected = task.sts === 3;

                                if (isCompleted) {
                                    return <CircleCheckBig className="h-3.5 w-3.5 flex-shrink-0 text-sahi-green mr-0.5" />;
                                }
                                if (isCancelled) {
                                    return <XCircle className="h-3.5 w-3.5 flex-shrink-0 text-sahi-red mr-0.5" />;
                                }
                                if (isRejected) {
                                    return <Ban className="h-3.5 w-3.5 flex-shrink-0 text-sahi-red mr-0.5" />;
                                }
                                return <ClockFading className="h-3.5 w-3.5 flex-shrink-0 text-zinc-500 mr-0.5" />;
                            })()}

                            {range === "overdue" && <Clock className="h-3 w-3 flex-shrink-0 text-sahi-red" />}

                            {range === "today" && task.rmdrDT && (
                                new Date(task.rmdrDT) < new Date() ? (
                                    <BellRing
                                        className={`h-3 w-3 mr-0.5 ${isOverdue
                                            ? "text-sahi-red"
                                            : "text-sahi-blue"
                                            }`}
                                    />
                                ) : (
                                    <Bell className={`h-3 w-3 mr-0.5 ${isOverdue ? "text-sahi-red" : "text-sahi-blue"}`} />
                                )
                            )}

                            {range === "future" && (
                                task.rmdrDT ? (
                                    new Date(task.rmdrDT) < new Date() ? (
                                        <BellRing className={`h-3 w-3 mr-0.5 ${isOverdue ? "text-sahi-red" : "text-sahi-blue"}`} />
                                    ) : (
                                        <Bell className={`h-3 w-3 mr-0.5 ${isOverdue ? "text-sahi-red" : "text-sahi-blue"}`} />
                                    )
                                ) : (
                                    <Clock className={`h-3 w-3 mr-0.5 ${isOverdue ? "text-sahi-red" : "text-sahi-blue"}`} />
                                )
                            )}

                            {range === "today" && !task.rmdrDT && (
                                isOverdue ? (
                                    <BsHourglassBottom className="h-3 w-3 mr-0.5 text-sahi-red" />
                                ) : (
                                    <BsHourglassTop className="h-3 w-3 mr-0.5 text-sahi-blue" />
                                )
                            )}

                            <span className={range === "history" ? "text-zinc-500" : (isOverdue ? "text-sahi-red" : "text-sahi-blue")}>
                                {range === "history" ? (
                                    (task.updatedDT || task.dueDT) ? getRelativeDateText(task.updatedDT || task.dueDT, false, true, false, false, true) : '-'
                                ) : (
                                    task.dueDT ? getRelativeDateText(task.dueDT, false, true, showTimeAlways, false, true).replace("11:59 PM", "by EOD") : "Not set"
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const getTaskTypeIcon = (type) => {
    const className = "h-3 w-3";
    switch (type?.toLowerCase()) {
        case 'visit': return <MapPin className={className} />;
        case 'call': return <Phone className={className} />;
        case 'meeting': return <Users className={className} />;
        case 'email': return <Mail className={className} />;
        case 'log': return <FileText className={className} />;
        case 'dialed': return <PhoneOutgoing className={className} />;
        case 'message': return <MessageSquare className={className} />;
        case 'no response': return <PhoneMissed className="h-3 w-3 mr-1 text-sahi-red" />;
        default: return <ClipboardList className={className} />;
    }
};

const getTaskClassIcon = (taskClassVal, className = "h-3 w-3") => {
    const val = Number(taskClassVal || 1);
    switch (val) {
        case 1: return <SquareCheckBig className={className} />;
        case 2: return <Calendar className={className} />;
        case 3: return <GitFork className={className} />;
        case 4: return <ShieldCheck className={className} />;
        default: return <SquareCheckBig className={className} />;
    }
};

const getPriWeight = (pri) => {
    if (pri == 'H') return 3;
    if (pri == 'L') return 1;
    return 2; // Normal/unassigned priority
};

const isReminderSentToday = (lastRemitterDate) => {
    if (!lastRemitterDate) return false;
    const lastReminderDate = new Date(lastRemitterDate);
    const today = new Date();
    return (
        lastReminderDate.getFullYear() === today.getFullYear() &&
        lastReminderDate.getMonth() === today.getMonth() &&
        lastReminderDate.getDate() === today.getDate()
    );
};

const getQuickTaskSuggestedTime = (targetDate) => {
    let userEODTime = '17:00';
    const uConfig = getUserConfig();
    if (uConfig?.TaskConfig) {
        try {
            const parsed = JSON.parse(uConfig.TaskConfig);
            if (parsed && parsed[0]) {
                userEODTime = parsed[0].EOD || '17:00';
            }
        } catch (e) {
            console.error(e);
        }
    }

    const now = new Date();
    const sel = new Date(targetDate || new Date());

    const isToday = sel.getFullYear() === now.getFullYear() &&
        sel.getMonth() === now.getMonth() &&
        sel.getDate() === now.getDate();

    if (isToday) {
        const [eodH, eodM] = userEODTime.split(':').map(Number);
        const currH = now.getHours();
        const currM = now.getMinutes();

        const currMinutes = currH * 60 + currM;
        const eodMinutes = eodH * 60 + eodM;

        if (currMinutes < eodMinutes) {
            return userEODTime;
        } else {
            if (currH < 22) {
                const suggH = String(currH + 2).padStart(2, '0');
                return `${suggH}:00`;
            } else {
                return '23:59';
            }
        }
    } else {
        return userEODTime;
    }
};

const QuickAddTaskCard = ({ onAdd, isAdding, myTaskCtgs = [], defaultDate = new Date(), hasCompletedTasksToday = false }) => {
    const [title, setTitle] = useState('');
    const [selectedDate, setSelectedDate] = useState(defaultDate);
    const [selectedTime, setSelectedTime] = useState(() => getQuickTaskSuggestedTime(defaultDate));
    const [selectedCategory, setSelectedCategory] = useState(null);

    const [dateDrawerOpen, setDateDrawerOpen] = useState(false);
    const [categoryDrawerOpen, setCategoryDrawerOpen] = useState(false);
    const [myCategories, setMyCategories] = useState(myTaskCtgs);

    useEffect(() => {
        setMyCategories(myTaskCtgs);
    }, [myTaskCtgs]);

    useEffect(() => {
        setSelectedDate(defaultDate);
        setSelectedTime(getQuickTaskSuggestedTime(defaultDate));
    }, [defaultDate]);

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        if (!title.trim() || isAdding) return;

        let userPlanTime = '10:00';
        try {
            const uConfig = getUserConfig();
            if (uConfig?.TaskConfig) {
                const parsed = JSON.parse(uConfig.TaskConfig);
                if (parsed && parsed[0]) {
                    userPlanTime = parsed[0].PLN || '10:00';
                }
            }
        } catch (err) {
            console.error('Failed to parse TaskConfig for reminder:', err);
        }

        const dueDateTime = new Date(selectedDate);
        const [hours, minutes] = selectedTime.split(':').map(Number);
        dueDateTime.setHours(hours, minutes, 0, 0);

        const now = new Date();
        const suggestedReminder = calculateSuggestedReminder(dueDateTime, userPlanTime, now);

        let scheduleDT = '';
        if (suggestedReminder?.date && suggestedReminder?.time) {
            const reminderDate = new Date(suggestedReminder.date);
            const [remH, remM] = suggestedReminder.time.split(':').map(Number);
            reminderDate.setHours(remH, remM, 0, 0);
            if (reminderDate <= dueDateTime && reminderDate >= now) {
                scheduleDT = format(reminderDate, 'dd-MMM-yy hh:mm aa');
            }
        }

        const success = await onAdd(title.trim(), selectedDate, selectedTime, selectedCategory, scheduleDT);
        if (success) {
            triggerHaptic("success");
            setTitle('');
            setSelectedCategory(null);
            setSelectedDate(defaultDate);
            setSelectedTime(getQuickTaskSuggestedTime(defaultDate));
        } else {
            setSelectedTime(getQuickTaskSuggestedTime(selectedDate));
        }
    };

    const formatTimeLabel = (timeStr) => {
        if (!timeStr) return '';
        try {
            const [hours, minutes] = timeStr.split(':').map(Number);
            let displayHour = hours;
            let ampm = 'AM';

            if (hours === 0) {
                displayHour = 12;
                ampm = 'AM';
            } else if (hours === 12) {
                displayHour = 12;
                ampm = 'PM';
            } else if (hours > 12) {
                displayHour = hours - 12;
                ampm = 'PM';
            }

            return `${displayHour}:${minutes.toString().padStart(2, '0')} ${ampm}`;
        } catch {
            return timeStr;
        }
    };

    return (
        <>
            <div
                className="bg-white rounded-md border border-zinc-200 p-3 w-full flex flex-col gap-2 select-none"
                style={{ marginBottom: hasCompletedTasksToday ? '0' : '4rem' }}
            >
                {/* L1: Task Title using SahiCRM's Input component */}
                <Input
                    type="text"
                    maxLength={50}
                    placeholder="Enter Task"
                    className="w-full text-zinc-900 border !border-green-700/50 focus:border-[var(--sahi-green)] transition-all font-normal leading-tight text-left !h-10"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSubmit(e);
                        }
                    }}
                    disabled={isAdding}
                />

                {/* L2: Category, Time, and Submit buttons in a single flex row using SahiCRM's Button component */}
                <div className="flex items-center gap-2 w-full">
                    {/* Category Box */}
                    <Button
                        type="button"
                        variant="outline"
                        onClick={() => setCategoryDrawerOpen(true)}
                        className="flex-[1.2] flex items-center gap-2 !h-10 px-3 border border-green-700/50 bg-white hover:bg-zinc-50 hover:text-foreground text-foreground text-sm font-normal justify-between text-left min-w-0"
                    >
                        <div className="flex items-center gap-2 min-w-0">
                            <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: selectedCategory ? selectedCategory.Clr : '#e4e4e7' }} />
                            <span className="truncate">{selectedCategory ? selectedCategory.CNm : 'Category'}</span>
                        </div>
                        <ChevronDown className="h-4 w-4 text-zinc-400 shrink-0" />
                    </Button>

                    {/* Time Box using SahiCRM's TimeInputWithDialog */}
                    <div className="flex-1 min-w-0 [&_button]:!h-10 [&_button]:!border-green-700/50 [&_button_.border-l]:!border-l-green-700/50">
                        <TimeInputWithDialog
                            value={selectedTime}
                            onChange={setSelectedTime}
                            disabled={isAdding}
                            isMobile={false}
                            hideLabel={true}
                        />
                    </div>

                    {/* Submit Button */}
                    <Button
                        type="button"
                        variant="sahiGreen"
                        onClick={handleSubmit}
                        disabled={isAdding || !title.trim()}
                        className="!h-10 !w-10 shrink-0 p-0 flex items-center justify-center bg-[var(--sahi-green)] hover:bg-[var(--sahi-green)]/90"
                    >
                        {isAdding ? (
                            <Loader2 className="h-4 w-4 animate-spin text-white" />
                        ) : (
                            <Plus className="h-5 w-5 text-white" strokeWidth={3} />
                        )}
                    </Button>
                </div>
            </div>

            {/* Task Category Manager */}
            <TaskCategoryManager
                open={categoryDrawerOpen}
                onOpenChange={setCategoryDrawerOpen}
                categories={myCategories}
                selectedCID={selectedCategory?.CID || 0}
                onSelect={(cid) => {
                    const cat = myCategories.find(c => c.CID === cid);
                    setSelectedCategory(cat || null);
                    setCategoryDrawerOpen(false);
                }}
                onCategoriesChange={(updated) => {
                    setMyCategories(updated);
                    if (selectedCategory && !updated.filter(c => !c.IsD).find(c => c.CID === selectedCategory.CID)) {
                        setSelectedCategory(null);
                    }
                }}
            />

            {/* Date selection Drawer */}
            <Drawer open={dateDrawerOpen} onOpenChange={setDateDrawerOpen}>
                <DrawerContent className="p-0 [&>div:first-child]:hidden top-auto !h-auto rounded-t-[22px] max-h-[85dvh]">
                    <div className="flex flex-col bg-white rounded-t-[22px] select-none p-4">
                        <div className="flex items-center justify-between pb-3 border-b border-zinc-100 mb-4">
                            <span className="text-lg font-semibold text-gray-900">Select Date</span>
                            <button onClick={() => setDateDrawerOpen(false)} className="text-gray-500">
                                <X className="h-5 w-5" />
                            </button>
                        </div>
                        <div className="flex justify-center mb-6">
                            <UICalendar
                                mode="single"
                                selected={selectedDate}
                                onSelect={(date) => {
                                    if (date) {
                                        setSelectedDate(date);
                                        setDateDrawerOpen(false);
                                    }
                                }}
                                className="rounded-md border shadow-sm"
                            />
                        </div>
                    </div>
                </DrawerContent>
            </Drawer>


        </>
    );
};

const Tasks = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isMobile = useIsMobile();
    const [viewMode, setViewMode] = useState(() => localStorage.getItem("TasksViewMode") || "watch");

    const [viewModeModalOpen, setViewModeModalOpen] = useState(false);

    useEffect(() => {
        const handleToggleViewMode = () => {
            if (isMobile) {
                setViewModeModalOpen(true);
            } else {
                setViewMode(prev => {
                    const next = prev === "watch" ? "category" : (prev === "category" ? "class" : "watch");
                    localStorage.setItem("TasksViewMode", next);
                    window.dispatchEvent(new CustomEvent("tasks-view-mode-changed", { detail: next }));
                    return next;
                });
            }
        };
        const handleSyncViewMode = (e) => {
            if (e.detail) {
                setViewMode(e.detail);
            }
        };
        window.addEventListener("tasks-toggle-view-mode", handleToggleViewMode);
        window.addEventListener("tasks-view-mode-changed", handleSyncViewMode);
        return () => {
            window.removeEventListener("tasks-toggle-view-mode", handleToggleViewMode);
            window.removeEventListener("tasks-view-mode-changed", handleSyncViewMode);
        };
    }, [isMobile]);

    const searchParams = new URLSearchParams(location.search);
    const authData = getAuthData();
    const currentUserID = Number(authData?.UserID);
    const currentUser = getCurrentUser();

    const usersFromRedux = useSelector(getAllUsersArr);

    // Get executive name
    const getExecutiveName = (userID, mobileOrTask = null) => {
        if (!userID && !mobileOrTask) return 'Not Assigned';
        const myUserIDs = getMyAgenciesMappedIDs('UserID');
        if (userID && myUserIDs.includes(Number(userID))) return 'Me';

        let mobileStr = null;
        if (typeof mobileOrTask === 'string') {
            mobileStr = mobileOrTask;
        } else if (mobileOrTask && typeof mobileOrTask === 'object') {
            mobileStr = mobileOrTask.CreatorMobile || mobileOrTask.creatorMobile || mobileOrTask.CreatedMobile || mobileOrTask.POCMobile || mobileOrTask.pocMobile || mobileOrTask.Mobile || mobileOrTask.mobile || mobileOrTask.mob || mobileOrTask.Mob || null;
        }

        const found = findUserByIDOrMobile(usersFromRedux, userID, mobileStr);
        return found?.name || 'Not Assigned';
    };

    let buildTaskDetailsFallback = (task) => {
        if (!task) return null;
        const taskMobile = task.mobile || task.Mobile || task.mob || task.Mob || task.CreatedMobile || task.POCMobile || task.creatorMobile || task.pocMobile || null;
        return {
            taskID: task.tskID || task.TaskID,
            title: task.title || task.Task || task.ttl || '',
            pocTask: task.pocTask || task.POCTask || '',
            description: task.txt || task.Description,
            type: task.typ,
            priority: task.pri,
            status: task.sts,
            dueDT: task.dueDT,
            dueDTF: getTableDateOrWeekday(task.dueDT),
            dueDTColor: getColorClass(getTaskColor(task.dueDT)),
            pocUserID: task.pocUserID || task.uID,
            pocUserName: getExecutiveName(task.uID || task.pocUserID, task.POCMobile || taskMobile),
            connID: task.connID,
            threadIDs: task.tIDs,
            ctrcIDs: '',
            connectionData: {
                bizName: task.bizName,
                contactName: task.contactName,
                mobile: task.mobile,
                email: task.email,
                cc: '91',
            },
            linkedThreads: [],
            linkedCtrcs: [],
            scIDs: task.scIDs,
            createdUserID: task.createdUserID,
            createdDT: task.createdDT || task.CreatedDT || null,
            createdUserName: getExecutiveName(task.createdUserID, task.CreatedMobile || taskMobile),
            lastRmdrDT: task.lastRmdrDT || null,
            rmdrDT: task.rmdrDT || null,
            createdCtgID: task.createdCtgID || 0,
            pocCtgID: task.pocCtgID || 0,
            AgencyID: task.AgencyID || 0,
            canComplete: task.canComplete == true,
            statusNote: task.statusNote || '',
            statusDT: task.statusDT || null,
            updatedDT: task.updatedDT || null,
            observerUserIDs: extractObserverUserIDs(task).join(","),
        };
    };

    const reduxUserCounts = useMemo(() => {
        const counts = {};
        (usersFromRedux || []).forEach(u => {
            const n = (u.name || '').trim().toLowerCase();
            if (n) counts[n] = (counts[n] || 0) + 1;
        });
        return counts;
    }, [usersFromRedux]);
    const myTaskCtgs = (() => {
        try { return JSON.parse(getUserConfig()?.TaskCtgs || '[]'); }
        catch { return []; }
    })();
    const myAgencies = (() => {
        try { return JSON.parse(localStorage.getItem('MyAgencies') || '[]'); }
        catch { return []; }
    })();
    const agencyData = useSelector(getAgencyDetails);
    const taskTypesData = useSelector((state) => state.masterData.recordTypes);
    // Tasks are cross-agency (tied to the user's mobile), so join against ALL connections
    // from IndexedDB rather than state.connectionData, which is scoped to the active agency only.
    const { data: taskData, loading: taskLoading, error: taskError } = useSelector((state) => state.taskData);
    const connectionData = useAllConnectionsFromIDB(taskData);
    const { data: threadData, loading, error } = useSelector((state) => state.threadData);
    const threadTypesObj = useSelector(getThreadTypesArr);
    const [taskActionLoading, setTaskActionLoading] = useState({});
    const [tasksData, setTasksData] = useState([]);
    const [isQuickAdding, setIsQuickAdding] = useState(false);
    const agenciesWithTasks = useMemo(() => {
        const idsInTasks = new Set(tasksData.map(t => Number(t.AgencyID)).filter(Boolean));
        return myAgencies
            .filter(a => idsInTasks.has(Number(a.AgencyID)))
            .map(a => ({ AgencyID: a.AgencyID, name: a.CompanyName || a.AgencyName || getAgencyNameByID(a.AgencyID) }));
    }, [tasksData, myAgencies]);
    const [apiHistoryTasks, setApiHistoryTasks] = useState([]);
    const [apiMobileHistoryTasks, setApiMobileHistoryTasks] = useState([]);
    const [todayClosedTasks, setTodayClosedTasks] = useState([]);
    const [filteredTasks, setFilteredTasks] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showMobileSearch, setShowMobileSearch] = useState(false);
    const [collapsedGroups, setCollapsedGroups] = useState({});
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [isFilterSelected, setIsFilterSelected] = useState(true);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("sort");
    const [connData, setConnData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'pri', direction: 'desc' });
    const [tempSortConfig, setTempSortConfig] = useState(sortConfig);
    const [selectedFilters, setSelectedFilters] = useState({
        taskType: 'all',
        status: '1',
        priority: 'all',
        executive: 'all',
        ownership: 'all',
        connID: 'all',
        dateRange: 'all',
        finYear: 'all',
        otherMonth: "all",
        otherQuarter: "all",  // Add this
        otherYear: "all",
        taskTab: 'all',
        category: 'all',
        taskClass: 'all',
        agency: 'all',
    });
    const [tempFilters, setTempFilters] = useState(selectedFilters);
    const todayClosedTasksFiltered = useMemo(() => {
        const term = searchTerm && searchTerm.trim() ? searchTerm.toLowerCase().trim() : '';
        const list = term
            ? todayClosedTasks.filter(t => [
                t.ttl || '',
                t.txt || '',
                t.typ || '',
                t.bizName || '',
                t.threadNames || '',
                t.threadTypes || '',
                t.statusNote || '',
            ].some(field => field.toLowerCase().includes(term)))
            : todayClosedTasks;

        let res = [...list];

        if (selectedFilters.ownership && selectedFilters.ownership !== 'all') {
            const myUserIDs = getMyAgenciesMappedIDs('UserID');
            const userIDsToCheck = myUserIDs.length > 0 ? myUserIDs : [currentUserID];
            if (selectedFilters.ownership === 'own') {
                res = res.filter(t => userIDsToCheck.includes(Number(t.uID)));
            } else if (selectedFilters.ownership === 'given') {
                res = res.filter(t => userIDsToCheck.includes(Number(t.createdUserID)) && !userIDsToCheck.includes(Number(t.uID)));
            } else if (selectedFilters.ownership === 'others') {
                res = res.filter(t => !userIDsToCheck.includes(Number(t.uID)));
            }
        }

        if (selectedFilters.connID && selectedFilters.connID !== 'all') {
            res = res.filter(t => t.connID && t.connID.toString() === selectedFilters.connID.toString());
        }

        if (selectedFilters.taskType && selectedFilters.taskType !== 'all') {
            res = res.filter(t => (t.typ || "").toString().toLowerCase().trim() === selectedFilters.taskType.toLowerCase().trim());
        }

        if (selectedFilters.executive && selectedFilters.executive !== 'all') {
            if (selectedFilters.executive === 'unassigned') {
                res = res.filter(t => !t.uID);
            } else {
                res = res.filter(t => t.uID && t.uID.toString() === selectedFilters.executive.toString());
            }
        }

        if (selectedFilters.priority && selectedFilters.priority !== 'all') {
            res = res.filter(t => (t.pri || "").toUpperCase().trim() === selectedFilters.priority.toUpperCase().trim());
        }

        if (selectedFilters.category && selectedFilters.category !== 'all') {
            res = res.filter(t => {
                const usrCID = getTaskCategoryIDForUser(t, currentUserID);
                return Number(usrCID) === Number(selectedFilters.category);
            });
        }

        if (selectedFilters.taskClass && selectedFilters.taskClass !== 'all') {
            res = res.filter(t => {
                const tc = Number(t.class || t.Class || t.taskClass || t.TaskClass || 1);
                return tc === Number(selectedFilters.taskClass);
            });
        }

        if (selectedFilters.agency && selectedFilters.agency !== 'all') {
            res = res.filter(t => Number(t.AgencyID) === Number(selectedFilters.agency));
        }

        return res;
    }, [todayClosedTasks, searchTerm, selectedFilters, currentUserID]);
    const prevFiltersRef = useRef({});
    // const hasActiveFilters = useMemo(() => {
    //     return Object.values(selectedFilters).some(value => value != 'all');
    // }, [selectedFilters]);
    const hasActiveFilters = useMemo(() => {
        return Object.entries(selectedFilters).some(([key, value]) => {
            if (key === 'ownership') return false;
            if (key === 'status' && value === '1') return false;
            if (isMobile && key === 'dateRange') {
                const tabBasedRanges = ['Overdue', 'Today', 'Tomorrow', 'Week Ahead', 'Future'];
                if (tabBasedRanges.includes(value)) return false;
            }
            return value != 'all';
        });
    }, [selectedFilters, isMobile]);
    const clickedTabRef = useRef(null);
    const prevAutoFilterKeyRef = useRef('');
    const [dialogStates, setDialogStates] = useState({
        taskEntry: false,
        recordEntry: false,
        userEntry: false,
        // confirmCompleteWarning: false,
    })
    const [taskTimesOpen, setTaskTimesOpen] = useState(false);
    const [openTaskDetail, setOpenTaskDetail] = useState(false)
    const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
    const [taskDeleteBulkIDs, setTaskDeleteBulkIDs] = useState([]);
    const [selectedTaskForRecord, setSelectedTaskForRecord] = useState(null);
    const [selectedTaskID, setSelectedTaskID] = useState(0);
    const [selectedTaskForceClosed, setSelectedTaskForceClosed] = useState(false);
    const [selectedTaskCompletedDT, setSelectedTaskCompletedDT] = useState(null);
    const [selectedTaskFallbackData, setSelectedTaskFallbackData] = useState(null);
    const [editingTaskID, setEditingTaskID] = useState(null);
    const [shareActionByWhatsApp, setShareActionByWhatsApp] = useState(false);
    const [taskEntryPrefillData, setTaskEntryPrefillData] = useState({});
    const [paramConnID, setParamConnID] = useState('')
    const [paramTab, setParamTab] = useState('');
    const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
    const [templateDialogData, setTemplateDialogData] = useState(null);
    const [completionDialogPrefill, setCompletionDialogPrefill] = useState("");
    const pendingRepeatAfterRecordRef = useRef(false);
    const pendingStatusNoteAfterRecordRef = useRef("");

    const isInqOnlyMode = useSelector(checkIfInqOnlyMode);

    //obj making for actions
    const formatTaskData = (task) => {
        const dateObj = new Date(task.dueDT);
        return {
            taskID: task.tskID,
            connID: task.connID,
            taskName: task.ttl,
            description: task.txt,
            dueDT: format(dateObj, 'yyyy-MM-dd'),
            dueTime: format(dateObj, 'HH:mm'),
            pocUserID: task.uID,
            priority: task.pri,
            threads: task.tIDs ? task.tIDs.split(",") : '',
            status: task.sts,
            taskType: task.typ,
            myCategory: getTaskCategoryIDForUser(task, currentUserID) || 0,
            statusNote: task.statusNote || '',
            statusDT: task.statusDT || null,
            updatedDT: task.updatedDT || null,
            taskClass: task.class || task.Class || task.taskClass || task.TaskClass || 1,
            options: task.options || task.Options || null,
            repeatAfter: Number(task.repeatAfter || task.RepeatAfter) || 0,
            repeatDT: task.repeatDT || task.RepeatDT || '',
        };
    };

    // Update task data when connection data is changed
    useEffect(() => {
        const updatedTasks = getProcessedTasks(taskData, connectionData).map(task => ({
            ...task,
            isChecked: false
        }));
        setTasksData(updatedTasks);

    }, [taskData, connectionData]); // Removed threadData to prevent unnecessary resets

    useEffect(() => {
        if (isMobile) return;
        const isCompletedFilter = selectedFilters.status === '2';
        const isCancelledFilter = selectedFilters.status === '4';
        const isRejectedFilter = selectedFilters.status === '3';
        if (!isCompletedFilter && !isCancelledFilter && !isRejectedFilter) {
            setApiHistoryTasks([]);
            return;
        }
        dispatch(setGlobalLoading(true));
        const periodParams = resolvePeriodParams(selectedFilters);
        getTaskHistoryAPI(periodParams).then((response) => {
            const rawRows = Array.isArray(response?.Table1) ? response.Table1 : [];
            const wantedStatus = isCompletedFilter ? 2 : isRejectedFilter ? 3 : 0;
            const matchingRows = rawRows.filter(row => Number(row.Status) == wantedStatus);
            const processedRows = getProcessedTasks(matchingRows, connectionData).map(row => ({
                ...row,
                sts: isCompletedFilter ? 2 : isRejectedFilter ? 3 : 4
            }));
            setApiHistoryTasks(processedRows);
        }).catch((error) => {
            console.error('Get task history API error (desktop status filter):', error);
            setApiHistoryTasks([]);
        }).finally(() => {
            dispatch(setGlobalLoading(false));
        });
    }, [isMobile, selectedFilters.status, selectedFilters.dateRange, selectedFilters.otherMonth, selectedFilters.otherQuarter, selectedFilters.otherYear, connectionData]);

    // Apply filters separately and only reset page on structural filter changes
    useEffect(() => {
        applyFilters();
    }, [tasksData, apiHistoryTasks, selectedFilters, searchTerm]);

    const handleCheckboxChange = (taskID, checked) => {
        setTasksData(prev => prev.map(t => t.tskID == taskID ? { ...t, isChecked: checked } : t));
        setFilteredTasks(prev => prev.map(t => t.tskID == taskID ? { ...t, isChecked: checked } : t));
    };

    const handleSelectAllCurrentPage = (checked) => {
        const currentPageIDs = new Set(currentTasks.map(t => t.tskID));
        setTasksData(prev => prev.map(t => currentPageIDs.has(t.tskID) ? { ...t, isChecked: checked } : t));
        setFilteredTasks(prev => prev.map(t => currentPageIDs.has(t.tskID) ? { ...t, isChecked: checked } : t));
    };

    useEffect(() => {
        setTaskDeleteBulkIDs(filteredTasks.filter(t => t.isChecked).map(t => t.tskID));
    }, [filteredTasks]);

    const handleBulkDelete = async () => {
        if (taskDeleteBulkIDs.length == 0) return;
        try {
            const result = await bulkTaskActionAPI(taskDeleteBulkIDs, 'DLT');
            if (!result.error) {
                // Determine if singular or plural for the toast
                const messageLabel = taskDeleteBulkIDs.length == 1 ? "Task" : "Tasks";

                setTasksData(prev => prev.filter(t => !taskDeleteBulkIDs.includes(t.tskID)));
                setFilteredTasks(prev => prev.filter(t => !taskDeleteBulkIDs.includes(t.tskID)));
                setTaskDeleteBulkIDs([]);

                toast.success(`${messageLabel} deleted.`); // Dynamic toast
                setDeleteAlertOpen(false);
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    const activeThreadTypesArr = useSelector(getActiveThreadTypesArr);
    const currActiveThreadType = getThreadModeTitle(activeThreadTypesArr);

    // Calculate pagination values
    const totalPages = Math.ceil(filteredTasks.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    //currrent tasks
    const currentTasks = useMemo(() => {
        const isHistoryMode = selectedFilters.status === '2' || selectedFilters.status === '4' || selectedFilters.status === '3';
        const sorted = (!sortConfig.key)
            ? [...filteredTasks].sort((a, b) => {
                if (isHistoryMode) {
                    const dateA = new Date(a.updatedDT || a.dueDT || a.createdDT || 0).getTime();
                    const dateB = new Date(b.updatedDT || b.dueDT || b.createdDT || 0).getTime();
                    return dateB - dateA;
                }
                const weightA = getPriWeight(a.pri);
                const weightB = getPriWeight(b.pri);
                if (weightA != weightB) return weightB - weightA;
                const dateA = a.dueDT ? new Date(a.dueDT).getTime() : Infinity;
                const dateB = b.dueDT ? new Date(b.dueDT).getTime() : Infinity;
                return dateA - dateB;
            })
            : (sortConfig.key == 'pri')
                ? [...filteredTasks].sort((a, b) => {
                    const weightA = getPriWeight(a.pri);
                    const weightB = getPriWeight(b.pri);
                    const dir = sortConfig.direction || 'desc';
                    const priorityCompare = dir == 'asc' ? weightA - weightB : weightB - weightA;
                    if (priorityCompare != 0) return priorityCompare;
                    const dateA = a.dueDT ? new Date(a.dueDT).getTime() : Infinity;
                    const dateB = b.dueDT ? new Date(b.dueDT).getTime() : Infinity;
                    return dateA - dateB;
                })
                : (sortConfig.key == 'dueDT')
                    ? [...filteredTasks].sort((a, b) => {
                        const isHistoryMode = selectedFilters.status === '2' || selectedFilters.status === '4' || selectedFilters.status === '3';
                        const dateA = isHistoryMode
                            ? (a.updatedDT || a.dueDT ? new Date(a.updatedDT || a.dueDT).getTime() : 0)
                            : (a.dueDT ? new Date(a.dueDT).getTime() : Infinity);
                        const dateB = isHistoryMode
                            ? (b.updatedDT || b.dueDT ? new Date(b.updatedDT || b.dueDT).getTime() : 0)
                            : (b.dueDT ? new Date(b.dueDT).getTime() : Infinity);
                        return sortConfig.direction == 'asc' ? dateA - dateB : dateB - dateA;
                    })
                    : filteredTasks; // Use already sorted filteredTasks from sortData

        if (isMobile) return sorted;
        const sliced = sorted.slice(startIndex, endIndex);
        return sliced.length > 0 ? sliced : sorted;
    }, [filteredTasks, sortConfig, currentPage, rowsPerPage, isMobile, selectedFilters.status]);

    const groupedCategories = useMemo(() => {
        const groups = {};
        currentTasks.forEach(task => {
            const ctgID = getTaskCategoryIDForUser(task, currentUserID) || 0;
            if (!groups[ctgID]) {
                groups[ctgID] = [];
            }
            groups[ctgID].push(task);
        });

        const categoriesList = [];
        myTaskCtgs.forEach(ctg => {
            if (groups[ctg.CID] && groups[ctg.CID].length > 0) {
                categoriesList.push({
                    ...ctg,
                    tasks: groups[ctg.CID]
                });
                delete groups[ctg.CID];
            }
        });

        let uncategorizedTasks = [];
        Object.keys(groups).forEach(key => {
            uncategorizedTasks = uncategorizedTasks.concat(groups[key]);
        });

        if (uncategorizedTasks.length > 0) {
            categoriesList.push({
                CID: 0,
                CNm: "Uncategorized",
                Clr: "#9ca3af",
                tasks: uncategorizedTasks
            });
        }

        return categoriesList.sort((a, b) => {
            if (a.CID === 0) return 1;
            if (b.CID === 0) return -1;
            return b.tasks.length - a.tasks.length;
        });
    }, [currentTasks, myTaskCtgs, currentUserID]);

    const groupMobileTasksByCategory = (tasksList) => {
        const groups = {};
        tasksList.forEach(task => {
            const ctgID = getTaskCategoryIDForUser(task, currentUserID) || 0;
            if (!groups[ctgID]) {
                groups[ctgID] = [];
            }
            groups[ctgID].push(task);
        });

        const categoriesList = [];
        myTaskCtgs.forEach(ctg => {
            if (groups[ctg.CID] && groups[ctg.CID].length > 0) {
                categoriesList.push({
                    ...ctg,
                    tasks: groups[ctg.CID]
                });
                delete groups[ctg.CID];
            }
        });

        let uncategorizedTasks = [];
        Object.keys(groups).forEach(key => {
            uncategorizedTasks = uncategorizedTasks.concat(groups[key]);
        });

        if (uncategorizedTasks.length > 0) {
            categoriesList.push({
                CID: 0,
                CNm: "Uncategorized",
                Clr: "#9ca3af",
                tasks: uncategorizedTasks
            });
        }

        return categoriesList.sort((a, b) => {
            if (a.CID === 0) return 1;
            if (b.CID === 0) return -1;
            return b.tasks.length - a.tasks.length;
        });
    };

    const groupMobileTasksByClass = (tasksList) => {
        const groups = {
            1: [], // Task
            2: [], // Meeting
            3: [], // Decision
            4: []  // Approval
        };

        tasksList.forEach(task => {
            const classID = Number(task.class || task.Class || task.taskClass || task.TaskClass || 1);
            if (groups[classID]) {
                groups[classID].push(task);
            } else {
                groups[1].push(task);
            }
        });

        const taskClasses = taskClassConfig?.taskClasses || [];

        const classList = [];
        taskClasses.forEach(cls => {
            const classId = cls.id;
            if (groups[classId] && groups[classId].length > 0) {
                classList.push({
                    CLID: classId,
                    CLNm: cls.label === "Task" ? "Tasks" : (cls.label === "Meeting" ? "Meetings" : (cls.label === "Decision" ? "Decisions" : (cls.label === "Approval" ? "Approvals" : cls.label))),
                    Clr: cls.color || "#9ca3af",
                    IconName: cls.icon || "SquareCheckBig",
                    tasks: groups[classId]
                });
            }
        });

        return classList.sort((a, b) => b.tasks.length - a.tasks.length);
    };

    const hasMobile = useMemo(
        () => filteredTasks.some(t => t?.mobile?.trim()),
        [filteredTasks]
    );

    const hasContact = useMemo(
        () => filteredTasks.some(t => Number(t?.connID) > 0),
        [filteredTasks]
    );

    const hasStatusNote = useMemo(
        () => filteredTasks.some(t => t?.statusNote?.trim()),
        [filteredTasks]
    );



    const usersCount = useMemo(() => usersFromRedux?.length ?? 0, []);

    // const hasAssignedFrom = useMemo(() =>
    // 	filteredTasks.some(
    // 	t => t?.uID != null && t?.createdUserID != null && Number(t.uID) != Number(t.createdUserID)),
    // 	[filteredTasks]
    // );?

    const hasAssignedFrom = useMemo(
        () =>
            usersCount > 4,
        [usersCount]
    );

    const hasTasksFromOthers = useMemo(() => {
        if (selectedFilters.ownership != 'own') return false;
        const myUserIDs = getMyAgenciesMappedIDs('UserID');
        const userIDsToCheck = myUserIDs.length > 0 ? myUserIDs : [currentUserID];
        return filteredTasks.some(task =>
            task?.createdUserID != null && !userIDsToCheck.includes(Number(task.createdUserID))
        );
    }, [filteredTasks, selectedFilters.ownership, currentUserID]);

    const shouldShowFromCol = useMemo(() => {
        if (selectedFilters.ownership === 'given') return false;
        if (selectedFilters.ownership === 'own') return hasTasksFromOthers;
        // "Assigned to others" - the executive column already identifies who it's assigned to,
        // so the From/creator column is redundant here and stays hidden.
        if (selectedFilters.ownership === 'others') return false;
        return hasAssignedFrom || hasTasksFromOthers;
    }, [selectedFilters.ownership, hasAssignedFrom, hasTasksFromOthers]);


    const [mobileTab, setMobileTab] = useState(() => {
        const initialClassParam = new URLSearchParams(window.location.search).get("class");
        return initialClassParam ? "all" : "due";
    });

    useModalBackButton(isMobile && mobileTab === "history", (open) => {
        if (!open) setMobileTab("due");
    }, "tasks-history-tab");

    // Reset filters when switching between history and normal/active mobile tabs
    useEffect(() => {
        if (!isMobile) return;
        if (mobileTab === 'history') {
            setSelectedFilters(prev => ({
                ...prev,
                status: 'all',
                priority: 'all',
                dateRange: prev.dateRange === 'all' ? 'This Month' : prev.dateRange
            }));
            setSortConfig({ key: 'dueDT', direction: 'desc' });
            setTempSortConfig({ key: 'dueDT', direction: 'desc' });
        } else {
            setSelectedFilters(prev => ({
                ...prev,
                status: '1',
                priority: 'all',
                dateRange: 'all',
                otherMonth: 'all',
                otherQuarter: 'all',
                otherYear: 'all'
            }));
            setSortConfig({ key: 'pri', direction: 'desc' });
            setTempSortConfig({ key: 'pri', direction: 'desc' });
        }
    }, [mobileTab, isMobile]);

    // Automatically sort by Completed/Cancelled date when history filter is selected on desktop
    useEffect(() => {
        if (isMobile) return;
        const isHistoryMode = selectedFilters.status === '2' || selectedFilters.status === '4' || selectedFilters.status === '3';
        if (isHistoryMode) {
            setSortConfig({ key: 'dueDT', direction: 'desc' });
            setSelectedFilters(prev => {
                if (prev.dateRange === 'all') {
                    return { ...prev, dateRange: 'This Month' };
                }
                return prev;
            });
            setTempFilters(prev => {
                if (prev.dateRange === 'all') {
                    return { ...prev, dateRange: 'This Month' };
                }
                return prev;
            });
        } else {
            setSortConfig({ key: 'pri', direction: 'desc' });
        }
    }, [selectedFilters.status, isMobile]);

    // Mobile header "History" tab pulls from the getTskHistory report API instead of the locally
    // synced taskData - shows every task from the report; the Completed/Cancelled filter (raw
    // Status 1 / 0) is applied client-side in mobileTaskGroups below.
    useEffect(() => {
        if (mobileTab !== "history") return;
        dispatch(setGlobalLoading(true));
        const periodParams = resolvePeriodParams(selectedFilters);
        getTaskHistoryAPI(periodParams).then((response) => {
            const rawRows = Array.isArray(response?.Table1) ? response.Table1 : [];
            const filteredRows = rawRows.filter(row => Number(row.Status) === 0 || Number(row.Status) === 2 || Number(row.Status) === 3);
            const processedRows = getProcessedTasks(filteredRows, connectionData).map(row => ({
                ...row,
                sts: row.sts == 0 ? 4 : row.sts
            }));
            setApiMobileHistoryTasks(processedRows);
        }).catch((error) => {
            console.error('getTskHistory API error (mobile History tab):', error);
            setApiMobileHistoryTasks([]);
        }).finally(() => {
            dispatch(setGlobalLoading(false));
        });
    }, [mobileTab, selectedFilters.dateRange, selectedFilters.otherMonth, selectedFilters.otherQuarter, selectedFilters.otherYear, connectionData]);

    const todayClosedFetchedRef = useRef(false);
    const connectionDataRef = useRef(connectionData);
    connectionDataRef.current = connectionData;

    const fetchTodayClosedTasks = () => {
        if (!isMobile) return;
        const now = new Date();
        const todayStr = now.toDateString();

        getTaskHistoryAPI({ prdType: 'MM', prdQty: 1, year: now.getFullYear(), month: now.getMonth() + 1 }).then((response) => {
            const rawRows = Array.isArray(response?.Table1) ? response.Table1 : [];

            const closedTodayRows = rawRows.filter(row => {
                if (Number(row.Status) === 1) return false;
                const updatedDT = row.UpdatedDT || row.updatedDT;
                if (!updatedDT) return false;
                return new Date(updatedDT).toDateString() === todayStr;
            });

            const processedRows = getProcessedTasks(closedTodayRows, connectionDataRef.current).map(row => ({
                ...row,
                sts: row.sts == 0 ? 4 : row.sts
            }));
            setTodayClosedTasks(processedRows);
        }).catch((error) => {
            console.error('getTskHistory API error (today closed tasks):', error);
            setTodayClosedTasks([]);
        });
    };

    useEffect(() => {
        if (!isMobile || todayClosedFetchedRef.current) return;
        todayClosedFetchedRef.current = true;
        fetchTodayClosedTasks();
    }, [isMobile]);

    const [selectedMobileDate, setSelectedMobileDate] = useState(new Date());
    const [calendarDrawerOpen, setCalendarDrawerOpen] = useState(false);
    const [tempMobileDate, setTempMobileDate] = useState(new Date());
    const [calendarMonth, setCalendarMonth] = useState(new Date());

    const formatMobileDateTabLabel = (date) => {
        if (!date) return 'Date';
        const now = new Date();
        if (date.getFullYear() === now.getFullYear()) {
            return format(date, 'd-MMM');
        } else {
            return format(date, 'd-MMM-yy');
        }
    };

    const mobileTaskGroups = useMemo(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const todayEnd = new Date(today);
        todayEnd.setHours(23, 59, 59, 999);

        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        const tomorrowEnd = new Date(tomorrow);
        tomorrowEnd.setHours(23, 59, 59, 999);

        // Flag to configure if tomorrow's tasks are shown in the Future tab
        const INCLUDE_TOMORROW_IN_FUTURE = false;

        const sortGroup = (tasks) => {
            return [...tasks].sort((a, b) => {
                const weightA = getPriWeight(a.pri);
                const weightB = getPriWeight(b.pri);
                if (weightA !== weightB) return weightB - weightA;

                const dateA = a.dueDT ? new Date(a.dueDT).getTime() : Infinity;
                const dateB = b.dueDT ? new Date(b.dueDT).getTime() : Infinity;
                return dateA - dateB;
            });
        };

        // History rows are sorted dynamically based on sortConfig or by Completed Date descending as default.
        const sortHistoryGroup = (tasks) => {
            const key = sortConfig.key || 'dueDT';
            const direction = sortConfig.direction || 'desc';

            return [...tasks].sort((a, b) => {
                if (key === 'pri') {
                    const weightA = getPriWeight(a.pri);
                    const weightB = getPriWeight(b.pri);
                    const priorityCompare = direction === 'asc' ? weightA - weightB : weightB - weightA;
                    if (priorityCompare !== 0) return priorityCompare;

                    const dateA = new Date(a.updatedDT || a.dueDT || a.createdDT || 0).getTime();
                    const dateB = new Date(b.updatedDT || b.dueDT || b.createdDT || 0).getTime();
                    return dateB - dateA;
                }

                if (key === 'dueDT') {
                    const dateA = new Date(a.updatedDT || a.dueDT || a.createdDT || 0).getTime();
                    const dateB = new Date(b.updatedDT || b.dueDT || b.createdDT || 0).getTime();
                    return direction === 'asc' ? dateA - dateB : dateB - dateA;
                }

                if (key === 'executive' || key === 'uID' || key === 'createdUserID') {
                    const nameA = getExecutiveName(key === 'createdUserID' ? a.createdUserID : a.uID, a) || '';
                    const nameB = getExecutiveName(key === 'createdUserID' ? b.createdUserID : b.uID, b) || '';
                    if (nameA === 'Me' && nameB !== 'Me') return direction === 'asc' ? -1 : 1;
                    if (nameB === 'Me' && nameA !== 'Me') return direction === 'asc' ? 1 : -1;
                    const nameCompare = direction === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
                    if (nameCompare !== 0) return nameCompare;

                    const dateA = new Date(a.updatedDT || a.dueDT || a.createdDT || 0).getTime();
                    const dateB = new Date(b.updatedDT || b.dueDT || b.createdDT || 0).getTime();
                    return dateB - dateA;
                }

                const dateA = new Date(a.updatedDT || a.dueDT || a.createdDT || 0).getTime();
                const dateB = new Date(b.updatedDT || b.dueDT || b.createdDT || 0).getTime();
                return dateB - dateA;
            });
        };
        const term = searchTerm && searchTerm.trim() ? searchTerm.toLowerCase().trim() : '';
        const matchesSearchTerm = (t) => {
            if (!term) return true;
            return [
                t.ttl || '',
                t.txt || '',
                t.typ || '',
                t.bizName || '',
                t.threadNames || '',
                t.threadTypes || '',
                t.statusNote || '',
            ].some(field => field.toLowerCase().includes(term));
        };

        const activeTasks = currentTasks.filter(t => {
            if (t.sts !== 1) return false;
            if (!matchesSearchTerm(t)) return false;
            const tc = Number(t.class || t.Class || t.taskClass || t.TaskClass || 1);
            if (tc === 2) {
                const myUserIDsArr = getMyAgenciesMappedIDs('UserID').map(Number);
                const userIDsArr = myUserIDsArr.length > 0 ? myUserIDsArr : [currentUserID];
                const isAssignedToMe = userIDsArr.includes(Number(t.uID || t.pocUserID || 0));
                const isAssignedByMe = userIDsArr.includes(Number(t.createdUserID || 0));
                const getObsIDs = (obs) => {
                    if (!obs) return [];
                    if (Array.isArray(obs)) return obs.map(Number);
                    if (typeof obs === 'string') return obs.split(',').map(Number).filter(Boolean);
                    return [];
                };
                const obsIDs = getObsIDs(t.observerUserIDs);
                const isObserverOnly = obsIDs.some(id => userIDsArr.includes(id)) && !isAssignedToMe && !isAssignedByMe;
                if (isObserverOnly) {
                    const obsActions = Array.isArray(t.observerUActions) ? t.observerUActions : [];
                    const myObsEntry = obsActions.find(oa => userIDsArr.includes(Number(oa.OUID || oa.OuID || oa.UserID || 0)));
                    if (myObsEntry && Number(myObsEntry.Sts || myObsEntry.sts || 0) === 2) return false;
                }
            }
            return true;
        });
        const historyTasksFiltered = apiMobileHistoryTasks.filter(matchesSearchTerm);

        const applyCommonHistoryFilters = (list) => {
            let res = [...list];

            if (selectedFilters.ownership && selectedFilters.ownership !== 'all') {
                const myUserIDs = getMyAgenciesMappedIDs('UserID');
                const userIDsToCheck = myUserIDs.length > 0 ? myUserIDs : [currentUserID];
                if (selectedFilters.ownership === 'own') {
                    res = res.filter(t => userIDsToCheck.includes(Number(t.uID)));
                } else if (selectedFilters.ownership === 'given') {
                    res = res.filter(t => userIDsToCheck.includes(Number(t.createdUserID)) && !userIDsToCheck.includes(Number(t.uID)));
                } else if (selectedFilters.ownership === 'others') {
                    res = res.filter(t => !userIDsToCheck.includes(Number(t.uID)));
                }
            }

            if (selectedFilters.connID && selectedFilters.connID !== 'all') {
                res = res.filter(t => t.connID && t.connID.toString() === selectedFilters.connID.toString());
            }

            if (selectedFilters.taskType && selectedFilters.taskType !== 'all') {
                res = res.filter(t => (t.typ || "").toString().toLowerCase().trim() === selectedFilters.taskType.toLowerCase().trim());
            }

            if (selectedFilters.executive && selectedFilters.executive !== 'all') {
                if (selectedFilters.executive === 'unassigned') {
                    res = res.filter(t => !t.uID);
                } else {
                    res = res.filter(t => t.uID && t.uID.toString() === selectedFilters.executive.toString());
                }
            }

            if (selectedFilters.priority && selectedFilters.priority !== 'all') {
                res = res.filter(t => (t.pri || "").toUpperCase().trim() === selectedFilters.priority.toUpperCase().trim());
            }

            if (selectedFilters.category && selectedFilters.category !== 'all') {
                res = res.filter(t => {
                    const usrCID = getTaskCategoryIDForUser(t, currentUserID);
                    return Number(usrCID) === Number(selectedFilters.category);
                });
            }

            if (selectedFilters.taskClass && selectedFilters.taskClass !== 'all') {
                const allowedClasses = String(selectedFilters.taskClass).split(',').map(c => Number(c.trim())).filter(Boolean);
                res = res.filter(t => {
                    const tc = Number(t.class || t.Class || t.taskClass || t.TaskClass || 1);
                    return allowedClasses.includes(tc);
                });
            }

            if (selectedFilters.agency && selectedFilters.agency !== 'all') {
                res = res.filter(t => Number(t.AgencyID) === Number(selectedFilters.agency));
            }

            if (selectedFilters.dateRange && selectedFilters.dateRange !== 'all') {
                res = res.filter(t => {
                    const taskDate = t.updatedDT || t.statusDT || t.dueDT || t.createdDT;
                    return isRecordInDateRange(taskDate, selectedFilters.dateRange, selectedFilters.finYear, selectedFilters.otherMonth, selectedFilters.otherQuarter, selectedFilters.otherYear);
                });
            }

            return res;
        };

        const historyListFiltered = (() => {
            const baseFiltered = applyCommonHistoryFilters(historyTasksFiltered);
            let list = selectedFilters.status === '2'
                ? baseFiltered.filter(t => Number(t.sts) == 2)
                : selectedFilters.status === '4'
                    ? baseFiltered.filter(t => Number(t.sts) == 4 || Number(t.sts) == 3)
                    : selectedFilters.status === '3'
                        ? baseFiltered.filter(t => Number(t.sts) == 3)
                        : baseFiltered;
            return list;
        })();

        const overdueFiltered = activeTasks.filter(t => t.dueDT && new Date(t.dueDT) < today);
        const todayTasksFiltered = activeTasks.filter(t => {
            if (!t.dueDT) return false;
            const d = new Date(t.dueDT);
            const sel = new Date(selectedMobileDate || new Date());
            return d.getFullYear() === sel.getFullYear() &&
                d.getMonth() === sel.getMonth() &&
                d.getDate() === sel.getDate();
        });

        const calendarTasksFiltered = selectedMobileDate ? activeTasks.filter(t => {
            if (!t.dueDT) return false;
            const d = new Date(t.dueDT);
            const sel = new Date(selectedMobileDate);
            return d.getFullYear() === sel.getFullYear() &&
                d.getMonth() === sel.getMonth() &&
                d.getDate() === sel.getDate();
        }) : [];
        const importantFiltered = activeTasks.filter(t => t.pri === 'H');
        const isToday = (() => {
            if (!selectedMobileDate) return true;
            const t = new Date();
            const sel = new Date(selectedMobileDate);
            return t.getFullYear() === sel.getFullYear() &&
                t.getMonth() === sel.getMonth() &&
                t.getDate() === sel.getDate();
        })();
        const dueFiltered = isToday ? [...overdueFiltered, ...todayTasksFiltered] : todayTasksFiltered;

        const upcomingFiltered = activeTasks.filter(t => {
            if (!t.dueDT) return false;
            const d = new Date(t.dueDT);
            const sevenDaysLater = new Date(tomorrowEnd);
            sevenDaysLater.setDate(sevenDaysLater.getDate() + 7);
            return d >= tomorrow && d <= sevenDaysLater;
        });

        return {
            all: sortGroup(activeTasks),
            important: sortGroup(importantFiltered),
            due: sortGroup(dueFiltered),
            upcoming: sortGroup(upcomingFiltered),
            overdue: sortGroup(overdueFiltered),
            today: sortGroup(todayTasksFiltered),
            tmrw: sortGroup(activeTasks.filter(t => {
                if (!t.dueDT) return false;
                const d = new Date(t.dueDT);
                return d >= tomorrow && d <= tomorrowEnd;
            })),
            future: sortGroup(activeTasks.filter(t => {
                if (!t.dueDT) return false;
                const d = new Date(t.dueDT);
                const limit = INCLUDE_TOMORROW_IN_FUTURE ? todayEnd : tomorrowEnd;
                return d > limit;
            })),
            calendar: sortGroup(calendarTasksFiltered),
            history: sortHistoryGroup(historyListFiltered),
            // Stats for the 4 summary boxes while on the History tab - "all" mirrors the exact
            // list above (history) so the box count always matches the rows actually shown;
            // important/due/upcoming are quick-filter shortcuts over the full history response.
            historyStats: {
                important: applyCommonHistoryFilters(historyTasksFiltered).filter(t => t.pri === 'H').length,
                due: applyCommonHistoryFilters(historyTasksFiltered).filter(t => Number(t.sts) === 2).length,
                upcoming: applyCommonHistoryFilters(historyTasksFiltered).filter(t => Number(t.sts) === 4 || Number(t.sts) === 3).length,
                all: applyCommonHistoryFilters(historyTasksFiltered).length
            }
        };
    }, [currentTasks, selectedMobileDate, apiMobileHistoryTasks, selectedFilters.status, selectedFilters.priority, selectedFilters.dateRange, selectedFilters.finYear, selectedFilters.otherMonth, selectedFilters.otherQuarter, selectedFilters.otherYear, selectedFilters.ownership, selectedFilters.connID, selectedFilters.taskType, selectedFilters.executive, selectedFilters.category, selectedFilters.taskClass, selectedFilters.agency, sortConfig, currentUserID, searchTerm]);

    // Auto-switch mobile tab to 'all' ONLY when a filter/search changes and Today has 0 items.
    // Subsequent tab clicks by the user are never overridden.
    useEffect(() => {
        if (!isMobile || mobileTab === 'history') return;
        const periodParam = new URLSearchParams(location.search).get('period');
        if (periodParam) return; // Respect URL period parameter
        const filterKey = JSON.stringify({ selectedFilters, searchTerm, tasksCount: currentTasks.length });
        if (prevAutoFilterKeyRef.current !== filterKey) {
            prevAutoFilterKeyRef.current = filterKey;
            const dueCount = mobileTaskGroups.due?.length || 0;
            const allCount = mobileTaskGroups.all?.length || 0;
            if (dueCount === 0 && allCount > 0) {
                setMobileTab('all');
            }
        }
    }, [isMobile, selectedFilters, searchTerm, currentTasks.length, mobileTaskGroups, mobileTab, location.search]);

    const isTodayMobileSelected = useMemo(() => {
        if (!selectedMobileDate) return true;
        const today = new Date();
        const sel = new Date(selectedMobileDate);
        return today.getFullYear() === sel.getFullYear() &&
            today.getMonth() === sel.getMonth() &&
            today.getDate() === sel.getDate();
    }, [selectedMobileDate]);

    const resolvedMobileActiveTasks = useMemo(() => {
        if (!isMobile) return [];
        const tabKey = mobileTab || 'due';
        const group = mobileTaskGroups[tabKey] || [];
        let flat = [];
        if (viewMode === "category") {
            const grouped = groupMobileTasksByCategory(group);
            grouped.forEach(g => {
                flat = flat.concat(g.tasks || []);
            });
        } else if (viewMode === "class") {
            const grouped = groupMobileTasksByClass(group);
            grouped.forEach(g => {
                flat = flat.concat(g.tasks || []);
            });
        } else {
            flat = [...group];
        }

        if (tabKey === 'due' && isTodayMobileSelected && todayClosedTasksFiltered.length > 0) {
            flat = flat.concat(todayClosedTasksFiltered);
        }

        return flat.map(t => buildTaskDetailsFallback(t));
    }, [isMobile, mobileTab, mobileTaskGroups, viewMode, isTodayMobileSelected, todayClosedTasksFiltered, myTaskCtgs, usersFromRedux]);

    const [selectedScheduleDate, setSelectedScheduleDate] = useState(new Date());
    const [now, setNow] = useState(new Date());

    // Read view from URL: v=2 is schedule, default is list
    const mobileView = searchParams.get('v') == '2' ? 'schedule' : 'list';


    const isTmrwMobileSelected = useMemo(() => {
        if (!selectedMobileDate) return false;
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const sel = new Date(selectedMobileDate);
        return tomorrow.getFullYear() === sel.getFullYear() &&
            tomorrow.getMonth() === sel.getMonth() &&
            tomorrow.getDate() === sel.getDate();
    }, [selectedMobileDate]);

    const isPastMobileDate = useMemo(() => {
        if (!selectedMobileDate) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const sel = new Date(selectedMobileDate);
        sel.setHours(0, 0, 0, 0);
        return sel < today;
    }, [selectedMobileDate]);

    // Keep "now" ticking so the current-time line & past-slot lock stay accurate
    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), 30000);
        return () => clearInterval(timer);
    }, []);

    const [draggingTask, setDraggingTask] = useState(null);
    const [dragPointer, setDragPointer] = useState(null);
    const [dragOverHour, setDragOverHour] = useState(null);
    const [dragOverInvalid, setDragOverInvalid] = useState(false);
    const dateScrollRef = useRef(null);
    const timelineScrollRef = useRef(null);
    // Schedule tab scrolls inside its own container; List tab scrolls with the window (like other list pages).
    const { indicatorRef: taskPullIndicatorRef, iconRef: taskPullIconRef, isRefreshing: isTaskPullRefreshing } = usePullToRefresh(
        timelineScrollRef,
        () => window.location.reload(),
        { disabled: !isMobile || mobileView !== 'schedule' }
    );
    const { indicatorRef: taskListPullIndicatorRef, iconRef: taskListPullIconRef, isRefreshing: isTaskListPullRefreshing } = usePullToRefresh(
        null,
        () => window.location.reload(),
        { disabled: !isMobile || mobileView !== 'list' }
    );
    const dragStartInfo = useRef(null);
    const longPressTimer = useRef(null);
    const isDraggingRef = useRef(false);
    const justDraggedRef = useRef(false);
    const edgeScrollTimer = useRef(null);

    // Auto-scroll to today in the horizontal date picker
    useEffect(() => {
        if (mobileView == 'schedule' && dateScrollRef.current) {
            const todayBtn = dateScrollRef.current.querySelector('[data-today="true"]');
            if (todayBtn) {
                setTimeout(() => {
                    todayBtn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                }, 50);
            }
        }
    }, [mobileView]);

    const scrollTimelineToCurrentHour = () => {
        if (!timelineScrollRef.current) return;
        const container = timelineScrollRef.current;
        const anchor = container.querySelector('[data-current-hour="true"]')
            || container.querySelector('[data-hour-slot]');
        if (!anchor) return;
        container.scrollTo({ top: Math.max(anchor.offsetTop - 90, 0), behavior: 'smooth' });
    };

    // Auto-scroll the hourly timeline to "now" (or the first slot) when the view opens
    useEffect(() => {
        if (mobileView != 'schedule') return;

        const attemptScroll = () => {
            scrollTimelineToCurrentHour();
        };

        requestAnimationFrame(() => {
            setTimeout(attemptScroll, 120);
        });

        const retryTimeout = setTimeout(attemptScroll, 300);
        return () => clearTimeout(retryTimeout);
    }, [mobileView, selectedScheduleDate, now]);

    // ---- Pointer-based drag & drop: works for touch, mouse, and pen in one path ----
    const handleTaskPointerDown = (e, task) => {
        if (e.button != undefined && e.button != 0) return;
        dragStartInfo.current = { x: e.clientX, y: e.clientY, task };
        clearTimeout(longPressTimer.current);
        longPressTimer.current = setTimeout(() => {
            isDraggingRef.current = true;
            setDraggingTask(task);
            setDragPointer({ x: e.clientX, y: e.clientY });
            try { e.target.setPointerCapture(e.pointerId); } catch (err) { }
            if (navigator.vibrate) navigator.vibrate(8);
        }, 180);
    };

    const handleTaskPointerMove = (e) => {
        if (!dragStartInfo.current) return;
        if (!isDraggingRef.current) {
            const dx = Math.abs(e.clientX - dragStartInfo.current.x);
            const dy = Math.abs(e.clientY - dragStartInfo.current.y);
            if (dx > 10 || dy > 10) clearTimeout(longPressTimer.current);
            return;
        }
        e.preventDefault();
        setDragPointer({ x: e.clientX, y: e.clientY });
        const el = document.elementFromPoint(e.clientX, e.clientY);
        const hourCell = el?.closest('[data-hour-slot]');
        const slot = hourCell?.getAttribute('data-hour-slot') || null;
        if (slot && isSlotInPast(slot)) {
            setDragOverHour(null);
            setDragOverInvalid(true);
        } else {
            setDragOverHour(slot);
            setDragOverInvalid(false);
        }

        // Edge-scroll the timeline when dragging near top or bottom
        const container = timelineScrollRef.current;
        if (container) {
            const { top, bottom } = container.getBoundingClientRect();
            const edgeZone = 80;
            clearInterval(edgeScrollTimer.current);
            if (e.clientY < top + edgeZone) {
                const speed = Math.max(4, Math.round((edgeZone - (e.clientY - top)) / 6));
                edgeScrollTimer.current = setInterval(() => { container.scrollTop -= speed; }, 16);
            } else if (e.clientY > bottom - edgeZone) {
                const speed = Math.max(4, Math.round((edgeZone - (bottom - e.clientY)) / 6));
                edgeScrollTimer.current = setInterval(() => { container.scrollTop += speed; }, 16);
            }
        }
    };

    const handleTaskPointerUp = async (e) => {
        clearTimeout(longPressTimer.current);
        clearInterval(edgeScrollTimer.current);
        if (isDraggingRef.current && dragStartInfo.current?.task && dragOverHour) {
            justDraggedRef.current = true;
            await handleDrop(dragOverHour, dragStartInfo.current.task);
        }
        isDraggingRef.current = false;
        dragStartInfo.current = null;
        setDraggingTask(null);
        setDragPointer(null);
        setDragOverHour(null);
        setDragOverInvalid(false);
    };

    const handleDrop = async (hourLabel, taskToMove) => {
        if (!taskToMove || !hourLabel) return;
        if (isSlotInPast(hourLabel)) {
            toast.error("Can't move a task to a time that's already passed");
            return;
        }
        try {
            const { hour, minute } = parseSlotLabel(hourLabel);

            const newDate = new Date(selectedScheduleDate);
            newDate.setHours(hour, minute, 0, 0);

            const currentDueDate = new Date(taskToMove.dueDT);
            if (!isNaN(currentDueDate)) {
                const currentBucket = new Date(currentDueDate);
                currentBucket.setMinutes(currentDueDate.getMinutes() < 30 ? 0 : 30, 0, 0);
                if (
                    currentBucket.getFullYear() == newDate.getFullYear() &&
                    currentBucket.getMonth() == newDate.getMonth() &&
                    currentBucket.getDate() == newDate.getDate() &&
                    format(currentBucket, 'h:mm a') == hourLabel
                ) {
                    return;
                }
            }

            const apiData = {
                taskID: taskToMove.tskID,
                taskName: taskToMove.ttl,
                dueDT: format(newDate, 'yyyy-MM-dd HH:mm:ss'),
                pocUserID: taskToMove.uID,
                status: 1,
                taskType: taskToMove.typ || 'Internal',
                connID: taskToMove.connID,
                priority: taskToMove.pri || 'M',
                AgencyID: taskToMove.AgencyID,
                taskAgencyID: taskToMove.AgencyID
            };

            // The task's own agency may differ from the currently active one (e.g. moving my own
            // task that lives under another of my agency profiles) - switch context so the API
            // resolves the correct UserID for that agency, same as Complete/Cancel/Status/CATEDIT.
            const taskAgencyID = Number(taskToMove.AgencyID || 0);
            if (taskAgencyID) apiService.setAgencyContext(taskAgencyID);
            let response;
            try {
                response = await manageTaskAPI(apiData, 'EDIT');
            } finally {
                if (taskAgencyID) apiService.clearAgencyContext();
            }
            if (response) {
                setTasksData(prev => prev.map(t =>
                    t.tskID == taskToMove.tskID ? { ...t, dueDT: newDate.toISOString() } : t
                ));
                toast.success(`Moved to ${hourLabel}`);
            }
        } catch (err) {
            toast.error("Error moving task");
        }
    };

    // 30-day scrollable window: 3 days back through 26 days ahead
    const scheduleDates = useMemo(() => {
        const dates = [];
        const today = new Date();
        for (let i = -30; i <= 30; i++) {
            const d = new Date(today);
            d.setDate(today.getDate() + i);
            dates.push(d);
        }
        return dates;
    }, []);

    // Auto-select tab or ensure a tab is always selected
    useEffect(() => {
        if (!isMobile) return;

        if (!mobileTab || mobileTab === "") {
            setMobileTab("due");
        }
    }, [mobileTab, isMobile]);

    const hasOtherTaskClasses = useMemo(() => {
        const allList = mobileTaskGroups?.all || [];
        return allList.some(t => {
            const tc = Number(t.class || t.Class || t.taskClass || t.TaskClass || 1);
            return tc === 2 || tc === 3 || tc === 4; // Meeting, Decision, Approval
        });
    }, [mobileTaskGroups?.all]);

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('tasks-date-changed', {
            detail: {
                date: selectedScheduleDate,
                hasOtherTaskClasses
            }
        }));
    }, [selectedScheduleDate, hasOtherTaskClasses]);

    useEffect(() => {
        const handleToggleSearch = () => {
            setShowMobileSearch(prev => {
                if (prev) {
                    setSearchTerm('');
                }
                return !prev;
            });
        };
        const handleToggleHistory = () => {
            setMobileTab(prev => prev === "history" ? "due" : "history");
        };
        const handleToggleFilter = () => {
            setIsFilterSelected(true);
            setIsDrawerOpen(true);
        };
        const handleToggleSettings = () => {
            setTaskTimesOpen(true);
        };

        window.addEventListener("tasks-toggle-search", handleToggleSearch);
        window.addEventListener("tasks-toggle-history", handleToggleHistory);
        window.addEventListener("tasks-toggle-filter", handleToggleFilter);
        window.addEventListener("tasks-toggle-settings", handleToggleSettings);

        return () => {
            window.removeEventListener("tasks-toggle-search", handleToggleSearch);
            window.removeEventListener("tasks-toggle-history", handleToggleHistory);
            window.removeEventListener("tasks-toggle-filter", handleToggleFilter);
            window.removeEventListener("tasks-toggle-settings", handleToggleSettings);
        };
    }, []);

    useEffect(() => {
        if (isMobile) {
            dispatch(updateHeaderConfig({
                title: "Tasks",
                iconLeft: {
                    icon: ArrowLeft,
                    onClick: () => {
                        if (mobileTab === "history") {
                            setMobileTab("due");
                        } else {
                            navigate("/", { replace: true });
                        }
                    },
                },
                actionsRight: [
                    {
                        icon: Search,
                        onClick: () => setShowMobileSearch(prev => {
                            if (prev) {
                                setSearchTerm('');
                            }
                            return !prev;
                        }),
                    },
                    {
                        icon: Filter,
                        onClick: () => {
                            setIsFilterSelected(true);
                            setIsDrawerOpen(true);
                        },
                        showBadge: hasActiveFilters,
                    },
                    {
                        icon: History,
                        onClick: () => setMobileTab(prev => prev === "history" ? "due" : "history"),
                        showBadge: mobileTab === "history",
                        badgeColor: "#0B5D1E",
                    },
                    {
                        icon: Settings,
                        onClick: () => setTaskTimesOpen(true),
                    }
                ]
            }));
        }
    }, [isMobile, dispatch, navigate, hasActiveFilters, mobileTab, setTaskTimesOpen]);

    // Sync temp date with selected date when calendar drawer opens
    useEffect(() => {
        if (calendarDrawerOpen) {
            const initialDate = selectedMobileDate || new Date();
            setTempMobileDate(initialDate);
            setCalendarMonth(initialDate);
        }
    }, [calendarDrawerOpen, selectedMobileDate]);
    //making task data
    const getProcessedTasks = (taskData, connectionData) => {
        if (!Array.isArray(taskData)) return [];

        const filteredTasks = taskData.filter(task => [0, 1, 2, 3, 4].includes(Number(task.Status)));

        return filteredTasks.map(task => {
            // Find connection data for this task
            const conn = connectionData.find(c => Number(c.ConnID || c.NodeID || 0) === Number(task.ConnID));

            // Process thread information (keep existing logic)
            let threadNames = [];
            let threadTypes = [];
            let threadDueDates = [];
            let threadSinceDates = [];
            let threadTypeIDs = [];

            if (task.ThreadIDs?.trim()) {
                const threadIDs = task.ThreadIDs.split(",").map(ID => ID.trim());
                threadIDs.forEach(threadId => {
                    const thread = threadData.find(t => t.ThreadID?.toString() == threadId);
                    if (thread) {
                        const threadTypeMeta = getThreadTypeMeta(thread.TypeID, threadTypesObj);
                        const threadType = threadTypeMeta?.nameSng || "General";
                        const threadName = thread.MainProduct || thread.product || thread.Product
                            || `${threadTypeMeta?.nameSnSng} (${getRelativeDateText(new Date(thread.DueDT), false, false)})`;;

                        threadTypes.push(threadType);
                        threadNames.push(threadName);
                        threadDueDates.push(thread.DueDT || thread.targetDT || "");
                        threadSinceDates.push(thread.SinceDT || thread.sinceDT || "");
                        threadTypeIDs.push(thread.TypeID);
                    }
                });
            }

            return {
                tskID: task.TaskID || task.tskID,
                ttl: getTaskTitleForUser(task, currentUserID),
                title: task.Task || task.title || task.ttl || '',
                pocTask: task.POCTask || task.pocTask || '',
                bizName: conn?.BizName || '',
                mobile: conn?.Mobile || '',
                email: conn?.Email || '',
                connType: conn?.ConnType || '',
                contactName: conn?.ContactName || '',
                contactCard: conn?.ContactCard || '',
                dueDT: task.DueDT,
                pri: getTaskPriorityForUser(task, currentUserID),
                connID: task.ConnID,
                uID: task.POCUserID,
                typ: task.TaskType || "",
                txt: task.Description,
                sts: task.Status,
                tIDs: task.ThreadIDs,
                threadNames: threadNames.join(", "),
                threadTypes: threadTypes.join(", "),
                threadDueDates: threadDueDates.join(", "),
                threadSinceDates: threadSinceDates.join(", "),
                threadTypeIDs: threadTypeIDs.join(", "),
                scIDs: task.SecConnIDs,
                pocUserID: task?.POCUserID || 0,
                createdUserID: task?.CreatedUserID || 0,
                CreatedUserID: task?.CreatedUserID || task?.createdUserID || 0,
                POCUserID: task?.POCUserID || task?.pocUserID || 0,
                taskMobile: task?.CreatorMobile || task?.creatorMobile || task?.CreatedMobile || task?.POCMobile || task?.pocMobile || task?.Mobile || task?.mobile || task?.Mob || task?.mob || null,
                CreatedMobile: task?.CreatorMobile || task?.creatorMobile || task?.CreatedMobile || task?.Mobile || task?.mobile || task?.Mob || task?.mob || null,
                POCMobile: task?.POCMobile || task?.pocMobile || task?.Mobile || task?.mobile || task?.Mob || task?.mob || null,
                createdDT: task.CreatedDT || null,
                lastRmdrDT: task.LastRmdrDT || null,
                rmdrDT: task.RmdrDT || null,
                createdCtgID: task.CreatedCtgID || 0,
                pocCtgID: task.POCCtgID || 0,
                AgencyID: task.AgencyID || conn?.AgencyID,
                // Whether the assigned executive (when not the creator) can complete this task directly.
                // Strictly truthy - until the backend actually sets this bit, an assignee cannot complete/mark done.
                canComplete: task.CanComplete == true,
                statusNote: task.StatusNote || '',
                statusDT: task.StatusDT || null,
                updatedDT: task.UpdatedDT || null,
                repeatAfter: Number(task.RepeatAfter) || 0,
                repeatDT: task.RepeatDT || '',
                taskClass: task.class || task.Class || task.TaskClass || 1,
                options: task.Options || null,
                observerUserIDs: extractObserverUserIDs(task).join(","),
                observerUActions: (() => {
                    const u = task.ObserverUActions || task.observerUActions || task.obsUActions || task.ObsUActions;
                    if (!u) return [];
                    try { return typeof u === 'string' ? JSON.parse(u) : u; }
                    catch (e) { return []; }
                })(),
            };
        });
    };

    // Process connection data
    useEffect(() => {
        if (!Array.isArray(connectionData)) {
            setConnData([]);
            return;
        }
        const processed = [...connectionData]  // shallow copy to avoid mutating props
            .filter(conn => conn.IsCold != 1 && conn.IsCold != true)
            .sort((a, b) => (a.BizName || "").localeCompare(b.BizName || ""));

        setConnData(processed);
    }, [connectionData]);

    // Sidebar icons for mobile filter drawer
    const isHistoryViewMode = isMobile ? (mobileTab === 'history') : (selectedFilters.status === '2' || selectedFilters.status === '4' || selectedFilters.status === '3');

    const resolvePeriodParams = (filters) => {
        const now = new Date();
        let year = now.getFullYear();
        let month = now.getMonth() + 1;
        let prdType = "MM";
        let prdQty = 1;

        const p = filters.dateRange;
        if (p === "This Year") {
            prdType = "YY";
            prdQty = 1;
            year = now.getFullYear();
            month = 0;
        } else if (p === "This Quarter") {
            const currentQuarter = Math.ceil((now.getMonth() + 1) / 3);
            prdType = `QQ${currentQuarter}`;
            prdQty = 1;
            year = now.getFullYear();
            month = now.getMonth() + 1;
        } else if (p === "Other Month" && filters.otherMonth !== "all") {
            const [mName, yStr] = filters.otherMonth.split(" ");
            month = months.indexOf(mName) + 1;
            year = parseInt(yStr);
            prdType = "MM";
        } else if (p === "Other Quarter" && filters.otherQuarter !== "all") {
            const [qStr, yStr] = filters.otherQuarter.split(" ");
            prdType = `QQ${qStr.replace("Q", "")}`;
            year = parseInt(yStr);
        } else if (p === "Other Year" && filters.otherYear !== "all") {
            prdType = "YY";
            year = parseInt(filters.otherYear);
        } else {
            // Default: This Month
            prdType = "MM";
            prdQty = 1;
            year = now.getFullYear();
            month = now.getMonth() + 1;
        }

        return { prdType, prdQty, year, month };
    };

    const sidebarIcons = [
        { key: "sort", icon: ArrowDownWideNarrow, tooltip: "Sort" },
        { key: "taskType", icon: CheckCircle, tooltip: "Task Type" },
        ...(!isMobile ? [{ key: "status", icon: Clock, tooltip: "Status" }] : []),
        { key: "executive", icon: User, tooltip: "Executive" },
        { key: "dateRange", icon: Calendar, tooltip: isHistoryViewMode ? "Period" : "Date Range" },
    ];

    const mobileSortMap = isHistoryViewMode ? {
        "Completed Date (newest first)": { key: "dueDT", direction: "desc" },
        "Completed Date (oldest first)": { key: "dueDT", direction: "asc" },
        "Priority (highest first)": { key: "pri", direction: "desc" },
        "Priority (lowest first)": { key: "pri", direction: "asc" },
        "Executive": { key: "executive", direction: "asc" },
    } : {
        "Due Date (newest first)": { key: "dueDT", direction: "desc" },
        "Due Date (oldest first)": { key: "dueDT", direction: "asc" },
        "Priority (highest first)": { key: "pri", direction: "desc" },
        "Priority (lowest first)": { key: "pri", direction: "asc" },
        "Executive": { key: "executive", direction: "asc" },
    };

    const getAccountCreatedDate = () => {
        if (agencyData?.CreatedDT) {
            return new Date(agencyData.CreatedDT);
        }
        try {
            const signUp = JSON.parse(localStorage.getItem('SignUp'));
            if (signUp && signUp.CreatedDT) return new Date(signUp.CreatedDT);
            if (Array.isArray(signUp) && signUp[0] && signUp[0].CreatedDT) return new Date(signUp[0].CreatedDT);
        } catch (e) { }
        try {
            const account = JSON.parse(localStorage.getItem('account'));
            if (account && account.CreatedDT) return new Date(account.CreatedDT);
            if (Array.isArray(account) && account[0] && account[0].CreatedDT) return new Date(account[0].CreatedDT);
        } catch (e) { }

        const fallback = new Date();
        fallback.setFullYear(fallback.getFullYear() - 1);
        return fallback;
    };

    const getMonthsAscending = (createdDate) => {
        const options = [];
        const currentDate = new Date();
        const start = new Date(createdDate);
        start.setDate(1);

        while (start <= currentDate) {
            const monthName = months[start.getMonth()];
            const year = start.getFullYear();
            const value = `${monthName} ${year}`;
            options.push({ name: value, ID: value });
            start.setMonth(start.getMonth() + 1);
        }
        return options;
    };

    const getQuartersAscending = (createdDate) => {
        const options = [];
        const currentDate = new Date();
        const start = new Date(createdDate);

        const startQuarter = Math.floor(start.getMonth() / 3) + 1;
        let startYear = start.getFullYear();
        let q = startQuarter;

        const currentQuarter = Math.floor(currentDate.getMonth() / 3) + 1;
        const currentYear = currentDate.getFullYear();

        while (startYear < currentYear || (startYear === currentYear && q <= currentQuarter)) {
            const label = `Q${q} ${startYear}`;
            options.push({ name: label, ID: label });
            q++;
            if (q > 4) {
                q = 1;
                startYear++;
            }
        }
        return options;
    };

    const getYearsAscending = (createdDate) => {
        const options = [];
        const currentYear = new Date().getFullYear();
        const startYear = new Date(createdDate).getFullYear();

        for (let year = startYear; year <= currentYear; year++) {
            options.push({ name: year.toString(), ID: year.toString() });
        }
        return options;
    };

    const createdDT = getAccountCreatedDate();

    const filterOptions = [
        {
            key: 'ownership',
            label: 'Own & Assigned',
            mobileLabel: "Ownership",
            options: !isMobile ? [
                { name: 'All', ID: 'all' },
                { name: 'Assigned to me', ID: 'own' },
                // { name: 'Assigned by me', ID : 'given' },
                ...(!isSmartSellerMode() && usersFromRedux.length > 1 ? [{ name: 'Assigned to others', ID: 'others' }] : [])
            ] : [
                { name: 'All', ID: 'all' },
                { name: 'Me', ID: 'own' },
                // { name: 'Given', ID : 'given' },
                ...(!isSmartSellerMode() && usersFromRedux.length > 1 ? [{ name: 'Others', ID: 'others' }] : [])
            ],
            displayValue: (val) => {
                if (val == 'own') return isMobile ? 'Me' : 'Assigned to me';
                if (val == 'others') return isMobile ? 'Others' : 'Assigned to others';
                // if (val == 'given') return isMobile ? 'Given' : 'Assigned by me';
                return isMobile ? 'All' : 'All Tasks';
            },
            type: 'options',
            searchEnabled: false,
            mobileDropdownText: "Select Ownership",
            hideAllOption: true
        },
        {
            key: 'dateRange',
            label: isHistoryViewMode ? (selectedFilters.dateRange === "all" ? "This Month" : selectedFilters.dateRange) : 'All Time',
            options: isHistoryViewMode ? [
                "This Month",
                "This Quarter",
                "This Year",
                "Other Month",
                "Other Quarter",
                "Other Year"
            ] : (isMobile ? [
                "This Month",
                "Other Month"
            ] : [
                "Overdue",
                "Today",
                "Tomorrow",
                "Week Ahead",
                "This Month",
                "Other Month",
                "Future"
            ]),
            type: isHistoryViewMode ? 'list' : 'options',
            searchEnabled: false,
            showAllOption: !isHistoryViewMode && !isMobile,
            mobileLabel: isHistoryViewMode ? "Period" : "Due",
            displayValue: (val) => {
                if (isHistoryViewMode && (val === "all" || !val)) return "This Month";
                return val || "All Time";
            }
        },
        {
            key: "finYear",
            label: "Select Year",
            options: getFinYearOptions(),
            disabled: !(selectedFilters.dateRange == "Fin Year" || tempFilters.dateRange == "Fin Year"),
            type: "list",
            mobileDropdownText: "Select Year",
            mobileNoLabel: true
        },
        {
            key: "otherMonth",
            label: "Select Month",
            options: getMonthsAscending(createdDT),
            disabled: !(selectedFilters.dateRange == "Other Month" || tempFilters.dateRange == "Other Month"),
            mobiledisabled: !(tempFilters.dateRange === "Other Month"),
            type: "list",
            mobileDropdownText: "Select Month",
            mobileNoLabel: true
        },
        {
            key: "otherQuarter",
            label: "Select Quarter",
            options: getQuartersAscending(createdDT),
            disabled: !(selectedFilters.dateRange == "Other Quarter" || tempFilters.dateRange == "Other Quarter"),
            mobiledisabled: !(tempFilters.dateRange === "Other Quarter"),
            type: "list",
            mobileDropdownText: "Select Quarter",
            mobileNoLabel: true
        },
        {
            key: "otherYear",
            label: "Select Year",
            options: getYearsAscending(createdDT),
            disabled: !(selectedFilters.dateRange == "Other Year" || tempFilters.dateRange == "Other Year"),
            mobiledisabled: !(tempFilters.dateRange === "Other Year"),
            type: "list",
            mobileDropdownText: "Select Year",
            mobileNoLabel: true
        },
        // Only show executive filter in DESKTOP when ownership is 'others'
        ...(!isSmartSellerMode() && usersFromRedux.length > 1 && !isMobile && (selectedFilters.ownership == 'others' || tempFilters.ownership == 'others')
            ? [
                {
                    key: 'executive',
                    label: 'All Executives',
                    mobileLabel: 'Executive',

                    options: [
                        ...usersFromRedux
                            .filter(u => u.userID != currentUserID)
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map(u => {
                                const trimmed = (u.name || '').trim().toLowerCase();
                                const isDup = reduxUserCounts[trimmed] > 1;
                                const agnName = isDup ? (u.agencyName || u.AgencyName || getAgencyNameByID(u.agencyID || u.AgencyID)) : '';
                                return {
                                    name: u.name,
                                    label: u.name,
                                    ID: u.userID,
                                    value: u.userID,
                                    agencyName: agnName
                                };
                            }),
                        { name: 'Not Assigned', ID: 'unassigned' }
                    ],

                    displayValue: (val) => {
                        if (val == 'all') return 'All Executives';
                        if (val == 'unassigned') return 'Not Assigned';
                        return (
                            usersFromRedux.find(u => u.userID == val)?.name ||
                            'All Executives'
                        );
                    },

                    type: 'list',
                    searchEnabled: false,
                    mobileDropdownText: 'Select Executive',
                    showAllOption: true
                }
            ]

            : []
        ),
        {
            key: 'connID',
            label: 'All Contacts',
            mobileLabel: "Contact",
            options: connData.map(c => ({ name: c.BizName || c.ContactName, ID: c.ConnID })),
            displayValue: (val) => {
                let displayText = 'All Contacts';
                let bizName = connData.find(c => Number(c.ConnID) == Number(val))?.BizName
                if (bizName == '') {
                    displayText = connData.find(c => Number(c.ConnID) == Number(val))?.ContactName || ''
                }
                else {
                    displayText = bizName;
                }
                return displayText;
            },
            type: 'list',
            searchEnabled: connData.length > 100,
            mobileDropdownText: "Select Contact",
            showAllOption: true
        },
        {
            key: "taskType",
            label: "All Types",
            mobileLabel: "Type",
            options: [...taskTypesData]
                .sort((a, b) =>
                    a.Typ.localeCompare(b.Typ, undefined, { sensitivity: "base" })
                )
                .map(t => ({
                    name: t.Typ,
                    ID: t.Typ
                })),
            displayValue: (val) => val || "All Types",
            type: "options",
            searchEnabled: false,
        },
        ...(myTaskCtgs.filter(c => !c.IsD).length > 0 ? [{
            key: 'category',
            label: 'All Growth Areas',
            mobileLabel: 'Growth Area',
            options: myTaskCtgs.filter(c => !c.IsD).sort((a, b) => a.CNm.localeCompare(b.CNm)).map(c => ({ name: c.CNm, ID: c.CID, Clr: c.Clr })),
            displayValue: (val) => {
                if (!val || val == 'all') return 'All Growth Areas';
                const cat = myTaskCtgs.find(c => c.CID == val);
                if (!cat) return 'All Growth Areas';
                return (
                    <span className="flex items-center gap-1.5">
                        <span className="w-2 h-2 rounded-full shrink-0 inline-block" style={{ backgroundColor: cat.Clr }} />
                        {cat.CNm}
                    </span>
                );
            },
            renderOption: (option) => (
                <>
                    {option.Clr && (
                        <span className="w-2.5 h-2.5 rounded-full flex-shrink-0 inline-block" style={{ backgroundColor: option.Clr }} />
                    )}
                    <span>{option.name}</span>
                </>
            ),
            type: 'list',
            searchEnabled: false,
            mobileDropdownText: 'Select Growth Area',
            showAllOption: true
        }] : []),
        {
            key: 'taskClass',
            label: 'All Tasks',
            mobileLabel: 'Class',
            options: [
                { name: 'All Tasks', ID: 'all', Icon: null },
                { name: 'Task', ID: '1', Icon: SquareCheckBig },
                { name: 'Meeting', ID: '2', Icon: Calendar },
                { name: 'Decision', ID: '3', Icon: GitFork },
                { name: 'Approval', ID: '4', Icon: ShieldCheck }
            ],
            displayValue: (val) => {
                if (!val || val === 'all') return 'All Tasks';
                const mapping = {
                    '1': { name: 'Task', Icon: SquareCheckBig },
                    '2': { name: 'Meeting', Icon: Calendar },
                    '3': { name: 'Decision', Icon: GitFork },
                    '4': { name: 'Approval', Icon: ShieldCheck },
                    '3,4': { name: 'Decision & Approval', Icon: GitFork },
                    '4,3': { name: 'Decision & Approval', Icon: GitFork }
                };
                const match = mapping[String(val)];
                if (!match) return 'All Tasks';
                const Icon = match.Icon;
                return (
                    <span className="flex items-center gap-1.5">
                        <Icon className="h-4 w-4 shrink-0" style={{ color: 'var(--sahi-green)' }} />
                        {match.name}
                    </span>
                );
            },
            renderOption: (option) => {
                const Icon = option.Icon;
                return (
                    <span className="flex items-center gap-2">
                        {Icon && <Icon className="h-4 w-4 shrink-0" style={{ color: 'var(--sahi-green)' }} />}
                        <span>{option.name}</span>
                    </span>
                );
            },
            type: 'list',
            searchEnabled: false,
            mobileDropdownText: 'Select Class',
            showAllOption: false
        },
        ...(!isMobile ? [
            {
                key: "status",
                label: "Status",
                options: [
                    { name: "Cancelled", ID: "4" },
                    { name: "Completed", ID: "2" },
                    { name: "Pending", ID: "1" },
                    { name: "Rejected", ID: "3" }
                ],
                displayValue: (val) => {
                    if (val === "1") return "Pending";
                    if (val === "2") return "Completed";
                    if (val === "3") return "Rejected";
                    if (val === "4") return "Cancelled";
                    return "Pending";
                },
                type: "options",
                searchEnabled: false,
                hideAllOption: true,
            }
        ] : []),
        ...(agenciesWithTasks.length > 0 ? [{
            key: 'agency',
            label: 'All Agencies',
            mobileLabel: 'Agency',
            options: [...agenciesWithTasks].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(a => ({ name: a.name, ID: a.AgencyID })),
            displayValue: (val) => {
                if (!val || val == 'all') return 'All Agencies';
                const agn = agenciesWithTasks.find(a => a.AgencyID == val);
                return agn ? agn.name : 'All Agencies';
            },
            type: 'list',
            searchEnabled: true,
            mobileDropdownText: 'Select Agency',
            showAllOption: true
        }] : []),
        {
            key: 'sort',
            label: 'Sort by',
            options: Object.keys(mobileSortMap),
            type: 'sort',
            mobileOnly: true
        },
    ];

    //managing params
    useEffect(() => {
        const conn = searchParams.get("cid");
        const tab = searchParams.get("tab");
        const typeFromUrl = searchParams.get("type");
        const period = searchParams.get("period");
        const classFromUrl = searchParams.get("class");
        const ownershipFromUrl = searchParams.get("ownership");

        const newFilters = { ...selectedFilters };
        let hasChanged = false;

        if (conn && conn != selectedFilters.connID) {
            newFilters.connID = conn;
            hasChanged = true;
        }
        if (tab && Number(tab) != selectedFilters.taskTab) {
            newFilters.taskTab = Number(tab);
            hasChanged = true;
        }
        // Logic for Task Type param
        if (typeFromUrl && typeFromUrl != selectedFilters.taskType) {
            newFilters.taskType = typeFromUrl;
            hasChanged = true;
        }
        // Logic for Ownership param (own / given / others / all)
        if (ownershipFromUrl) {
            const validOwnerships = ['own', 'given', 'others', 'all'];
            const mappedOwnership = ownershipFromUrl.toLowerCase();
            if (validOwnerships.includes(mappedOwnership) && mappedOwnership !== selectedFilters.ownership) {
                newFilters.ownership = mappedOwnership;
                hasChanged = true;
            }
        }
        // Logic for Task Class param
        if (classFromUrl) {
            if (classFromUrl != selectedFilters.taskClass) {
                newFilters.taskClass = classFromUrl;
                hasChanged = true;
            }
            if (!period && selectedFilters.dateRange !== 'all') {
                newFilters.dateRange = 'all';
                hasChanged = true;
            }
            if (!period && isMobile && mobileTab !== 'all') {
                setMobileTab('all');
            }
        }

        // Logic for Period param (mapped to dateRange filter)
        if (period) {
            const periodMap = {
                overdue: 'Overdue',
                today: 'Today',
                week: 'Week Ahead'
            };
            const mappedValue = periodMap[period.toLowerCase()];
            if (mappedValue && mappedValue != selectedFilters.dateRange) {
                newFilters.dateRange = mappedValue;
                hasChanged = true;
            }
            if (isMobile) {
                const mobileTabMap = {
                    overdue: 'due',
                    today: 'due',
                    week: 'upcoming'
                };
                const targetMobileTab = mobileTabMap[period.toLowerCase()];
                if (targetMobileTab && targetMobileTab !== mobileTab) {
                    setMobileTab(targetMobileTab);
                }
            }
        }

        if (hasChanged) {
            setSelectedFilters(newFilters);
            setTempFilters(newFilters);
            if (!isMobile) {
                setIsFilterSelected(true);
            }
        }
    }, [location.search]);

    // Open Task Details if tid is present in URL and tasks are loaded
    useEffect(() => {
        const tid = searchParams.get("tid");
        if (tid && tasksData.length > 0) {
            const taskID = Number(tid);
            // Verify the task actually exists in the loaded list
            const taskExists = tasksData.find(t => t.tskID == taskID);

            // Only open if valid and not already open with the same ID
            if (taskExists && (selectedTaskID != taskID || !openTaskDetail)) {
                setSelectedTaskID(taskID);
                setOpenTaskDetail(true);

                // Clear tid from URL immediately to prevent it staying in history
                const params = new URLSearchParams(location.search);
                params.delete("tid");
                const newSearch = params.toString();
                navigate({
                    pathname: location.pathname,
                    search: newSearch ? `?${newSearch}` : ""
                }, { replace: true });
            }
        }
    }, [tasksData, location.search]);

    //applying params filters
    useEffect(() => {
        const paramMap = {
            connID: paramConnID,
            taskTab: paramTab,
        };

        Object.entries(paramMap).forEach(([key, value]) => {
            if (value != '' && value != null && value != undefined) {
                setSelectedFilters((prev) => ({
                    ...prev,
                    [key]: value,
                }));
                setTempFilters((prev) => ({
                    ...prev,
                    [key]: value,
                }));
                if (!isMobile) {
                    setIsFilterSelected(true);
                }
            }
        });
    }, [paramConnID, paramTab]);

    //task actions
    const handleItemAction = (action, item, type, event = null) => {
        if (event) event.stopPropagation(); // Handle event propagation for actions like edit

        switch (action) {
            case 'COMPLETE':
                setSelectedTaskForRecord(item);
                const myUserIDs = getMyAgenciesMappedIDs('UserID');
                const isSamePerson = Number(item.uID) === Number(item.createdUserID) || (myUserIDs.includes(Number(item.uID)) && myUserIDs.includes(Number(item.createdUserID)));
                /* if (!isSamePerson && !item.doneDT) {
                    setDialogStates(prev => ({ ...prev, confirmCompleteWarning: true }));
                } else {
                    setDialogStates(prev => ({ ...prev, confirmCompleteAlert: true }));
                } */
                setDialogStates(prev => ({ ...prev, confirmCompleteAlert: true }));
                break;
            case 'CANCEL':
                setSelectedTaskForRecord(item);
                setDialogStates(prev => ({ ...prev, confirmCancelAlert: true }));
                break;
            case 'REOPEN':
                setSelectedTaskForRecord(item);
                setDialogStates(prev => ({ ...prev, confirmReopenAlert: true }));
                break;
            case 'EDIT':
                setEditingTaskID(item.tskID);
                setDialogStates(prev => ({ ...prev, taskEntry: true }));
                break;
            case 'RECORD_AND_COMPLETE':
                if (type == 'task') {
                    setDialogStates(prev => ({ ...prev, confirmCompleteAlert: false, recordEntry: true }));
                }
                break;
            default:
                console.warn(`Unknown action: ${action}`);
                break;
        }
    };

    const handleQuickAddTask = async (title, selectedDate, selectedTime, selectedCategory, scheduleDT = '') => {
        if (!title || !title.trim()) return false;
        setIsQuickAdding(true);
        try {
            const activeAgencyID = Number(authData?.AgencyID || 0);

            const combinedDT = new Date(selectedDate);
            const [hours, minutes] = selectedTime.split(':').map(Number);
            combinedDT.setHours(hours, minutes, 0, 0);

            if (combinedDT < new Date()) {
                toast.error('Due date and time cannot be in the past.');
                setIsQuickAdding(false);
                return false;
            }

            const apiData = {
                taskID: 0,
                taskName: title.trim(),
                description: '',
                dueDT: format(combinedDT, 'yyyy-MM-dd HH:mm:ss'),
                scheduleDT: scheduleDT || '',
                isRmdrUpdate: 1,
                pocUserID: String(currentUserID),
                priority: 'M',
                taskType: 'Internal',
                taskAgencyID: activeAgencyID,
                myCategory: selectedCategory ? Number(selectedCategory.CID) : 0
            };

            const result = await manageTaskAPI(apiData, 'ADD');
            if (result) {
                toast.success('Task added.');
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error adding quick task:', error);
            toast.error('Failed to add task.');
            return false;
        } finally {
            setIsQuickAdding(false);
        }
    };

    // Alert action function
    const handleAction = async (task, action, repeatTask = false, statusNote = "") => {
        const ID = task.tskID;
        const taskClass = Number(task.class || task.Class || task.taskClass || task.TaskClass || 1);
        const classLabel = taskClass === 2 ? "Meeting" : taskClass === 3 ? "Decision" : taskClass === 4 ? "Approval" : "Task";

        // Check reminder limit for REMIND action
        if (action == "REMIND" && isReminderSentToday(task.lastRmdrDT)) {
            toast.error(`You can only send one reminder for this ${classLabel.toLowerCase()} per day`);
            return;
        }

        if (shareActionByWhatsApp) {
            const myUserIDs = getMyAgenciesMappedIDs('UserID').map(Number);
            const currentUserID = getAuthData()?.UserID ? Number(getAuthData().UserID) : 0;
            const assigneeID = Number(task.uID || task.pocUserID || 0);
            const creatorID = Number(task.createdUserID || task.CreatedUserID || 0);
            const isAssigneeMe = (assigneeID === currentUserID) || myUserIDs.includes(assigneeID);
            const notifyUserID = isAssigneeMe ? creatorID : assigneeID;

            if (notifyUserID) {
                const userObj = usersFromRedux.find(u => Number(u.userID || u.UserID || 0) === Number(notifyUserID));
                if (userObj && (userObj.mobile || userObj.Mobile)) {
                    const phone = userObj.mobile || userObj.Mobile || '';
                    const cc = userObj.cc || userObj.CC || '91';
                    const taskTitle = task.ttl || task.taskName || task.title || '';
                    const message = getTaskActionWhatsAppMessage({
                        action,
                        task,
                        statusNote,
                        isAssigneeMe
                    });
                    const cleanedPhone = String(phone).replace(/[^\d]/g, "");
                    const cleanedCC = String(cc).replace(/[^\d]/g, "");
                    const whatsappUrl = `https://api.whatsapp.com/send/?phone=${cleanedCC}${cleanedPhone}&text=${encodeURIComponent(message)}`;

                    window.open(whatsappUrl, '_blank');
                }
            }
        }

        try {
            const taskData = {
                taskID: ID,
                connID: task.connID,
                pocUserID: task.uID,
                taskName: task.ttl,
                description: task.txt,
                priority: task.pri,
                status: task.sts,
                taskType: task.typ,
                threads: task.tIDs,
                AgencyID: task.AgencyID,
                repeatTask: repeatTask,
                statusNote: statusNote,
            };

            if (action == "DONE") {
                await completeTaskAPI(taskData);
                triggerHaptic("success");
                // playTaskSuccessSound();
                setTasksData(prevTasks =>
                    prevTasks.map(t =>
                        t.tskID == ID
                            ? { ...t, sts: 2 }
                            : t
                    )
                );
                fetchTodayClosedTasks();
                toast.success(`${classLabel} completed.`);
            } else if (action == "CANCEL") {
                // Assignee (not creator) declining the task is a Reject, not a Cancel
                const myUserIDs = getMyAgenciesMappedIDs('UserID');
                const isMyCreator = myUserIDs.includes(Number(task.createdUserID)) || Number(task.createdUserID) === currentUserID;
                const isMyAssignee = myUserIDs.includes(Number(task.uID)) || Number(task.uID) === currentUserID;
                const isReject = isMyAssignee && !isMyCreator;

                if (isReject) {
                    await rejectTaskAPI(taskData);
                } else {
                    await cancelTaskAPI(taskData);
                }
                setTasksData(prevTasks =>
                    prevTasks.map(t =>
                        t.tskID == ID
                            ? { ...t, sts: isReject ? 3 : 0 }
                            : t
                    )
                );
                fetchTodayClosedTasks();
                toast.success(isReject ? `${classLabel} rejected.` : `${classLabel} cancelled.`);
            } else if (action == "REMIND") {
                await remindTaskAPI(taskData);
                setTasksData(prevTasks =>
                    prevTasks.map(t =>
                        t.tskID == ID
                            ? { ...t, lastRmdrDT: new Date() }
                            : t
                    )
                );
                toast.success(`Reminder sent to ${getExecutiveName(task.uID)}.`);
            } else if (action == "REOPEN") {
                await reopenTaskAPI(taskData);
                setTasksData(prevTasks =>
                    prevTasks.map(t =>
                        t.tskID == ID
                            ? { ...t, sts: 1 }
                            : t
                    )
                );
                setTodayClosedTasks(prev => prev.filter(t => t.tskID != ID));
                // Also drop it from the desktop status-filter (Completed/Cancelled/Rejected) history
                // list, since a reopened task is no longer closed and shouldn't show there anymore.
                setApiHistoryTasks(prev => prev.filter(t => t.tskID != ID));
                toast.success(`${classLabel} reopened.`);
                setEditingTaskID(ID);
                setDialogStates(prev => ({ ...prev, taskEntry: true }));
            }
        } catch (error) {
            console.error(`Error performing action ${action}:`, error);
            const actionText = action == "DONE" ? "complete" : action == "MRKDONE" ? "mark as done" : action == "REMIND" ? "send reminder for" : action == "REOPEN" ? "reopen" : "cancel";
            toast.error(
                error.message ||
                `Failed to ${actionText} task. Please try again.`
            );
        } finally {
            setTaskActionLoading((prev) => ({ ...prev, [ID]: null }));
            setShareActionByWhatsApp(false);
            setDialogStates((prev) => ({
                ...prev,
                confirmCompleteWarning: false,
                confirmCompleteAlert: false,
                confirmCancelAlert: false,
                confirmReopenAlert: false,
            }));
            setSelectedTaskForRecord(null);
        }
    };

    //sorting function
    const sortData = (key, dir) => {
        const excludedKeys = ["threads", "tIDs"];
        // skip if key is excluded
        if (excludedKeys.includes(key)) {
            return;
        }

        const actualKey = key;
        let direction =
            dir ??
            (sortConfig.key == actualKey && sortConfig.direction == "asc" ? "desc" : "asc"); setSortConfig({ key, direction });

        const sorted = [...filteredTasks].sort((a, b) => {
            let lowerVal = a[key] || '';
            let upperVal = b[key] || '';

            // Fix: Sort by the displayed executive name so all multi-agency IDs map to "Me"
            if (key === 'createdUserID') {
                lowerVal = getExecutiveName(a.createdUserID, a);
                upperVal = getExecutiveName(b.createdUserID, b);
            }
            if (key === 'uID' || key === 'executive') {
                lowerVal = getExecutiveName(a.uID, a);
                upperVal = getExecutiveName(b.uID, b);
            }
            if (key === 'createdUserID' || key === 'uID' || key === 'executive') {
                if (lowerVal === 'Me' && upperVal !== 'Me') return direction === 'asc' ? -1 : 1;
                if (upperVal === 'Me' && lowerVal !== 'Me') return direction === 'asc' ? 1 : -1;
            }

            if (key == 'pri') {
                const getPriWeight = (p) => {
                    if (p == 'H') return 3;
                    if (p == 'L') return 1;
                    return 2; // Normal/unassigned priority
                };
                const weightA = getPriWeight(a.pri);
                const weightB = getPriWeight(b.pri);
                const priorityCompare = direction == 'asc' ? weightA - weightB : weightB - weightA;

                if (priorityCompare != 0) return priorityCompare;

                // Secondary sort: dueDT latest to oldest (descending)
                const dateA = a.dueDT ? new Date(a.dueDT).getTime() : 0;
                const dateB = b.dueDT ? new Date(b.dueDT).getTime() : 0;
                return dateB - dateA;
            }

            // Handle date fields
            if (['uID'].includes(actualKey)) {
                const primary = direction == 'asc' ? lowerVal - upperVal : upperVal - lowerVal;
                if (primary != 0) return primary;
                // Secondary sort by dueDT asc
                const dateA = a.dueDT ? new Date(a.dueDT).getTime() : Infinity;
                const dateB = b.dueDT ? new Date(b.dueDT).getTime() : Infinity;
                return dateB - dateA;
            }

            if (key == 'ctgDot') {
                const getCatName = (task) => {
                    const cid = getTaskCategoryIDForUser(task, currentUserID) || null;
                    // Sort by whatever category is actually assigned, even if it's since been deleted.
                    return cid ? (myTaskCtgs.find(c => c.CID == cid)?.CNm || '') : '';
                };
                const nameA = getCatName(a);
                const nameB = getCatName(b);
                if (!nameA && !nameB) return 0;
                if (!nameA) return 1;
                if (!nameB) return -1;
                return direction == 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
            }

            if (['dueDT'].includes(key)) {
                const isHistoryMode = selectedFilters.status === '2' || selectedFilters.status === '4' || selectedFilters.status === '3';
                const dateA = isHistoryMode
                    ? new Date(a.statusDT || a.updatedDT || a.dueDT || 0)
                    : new Date(a.dueDT || 0);
                const dateB = isHistoryMode
                    ? new Date(b.statusDT || b.updatedDT || b.dueDT || 0)
                    : new Date(b.dueDT || 0);
                return direction == 'asc' ? dateA - dateB : dateB - dateA;
            }
            // Handle string fields (e.g., Title, TaskType, AssignedTo)
            lowerVal = String(lowerVal).toLowerCase();
            upperVal = String(upperVal).toLowerCase();
            return direction == 'asc'
                ? lowerVal.localeCompare(upperVal)
                : upperVal.localeCompare(lowerVal);
        });

        setFilteredTasks(sorted);
    };

    // Apply filters
    const applyFilters = () => {
        const { taskType, status, priority, executive, connID, dateRange, finYear, otherMonth, taskTab, otherQuarter, otherYear, ownership, category, agency, taskClass } = selectedFilters;
        const isApiHistoryMode = !isMobile && (status === '2' || status === '4' || status === '3');
        const baseList = isApiHistoryMode ? apiHistoryTasks : tasksData;
        const filtered = [];

        for (const task of baseList) {
            let filteredReason = null;

            // Only show tasks that are either assigned to me, assigned by me, or where I am an observer
            const myUserIDs = getMyAgenciesMappedIDs('UserID').map(Number);
            const userIDsToCheck = myUserIDs.length > 0 ? myUserIDs : [currentUserID];
            const isAssignedToMe = userIDsToCheck.includes(Number(task.uID));
            const isAssignedByMe = userIDsToCheck.includes(Number(task.createdUserID));

            const getObserverIDs = (obs) => {
                if (!obs) return [];
                if (Array.isArray(obs)) return obs.map(Number);
                if (typeof obs === 'string') return obs.split(',').map(Number).filter(Boolean);
                return [];
            };
            const observerIDs = getObserverIDs(task.observerUserIDs);
            const isObserver = observerIDs.some(id => userIDsToCheck.includes(id));

            if (!isAssignedToMe && !isAssignedByMe && !isObserver) {
                continue;
            }

            // For meeting tasks (class=2) in active mode: if I am observer-only and I declined (Sts=2 in ObserverUActions), hide from active list
            if (!isApiHistoryMode) {
                const taskClass = Number(task.class || task.Class || task.taskClass || task.TaskClass || 1);
                if (taskClass === 2 && isObserver && !isAssignedToMe && !isAssignedByMe) {
                    const obsActions = Array.isArray(task.observerUActions) ? task.observerUActions : [];
                    const myObsEntry = obsActions.find(oa => userIDsToCheck.includes(Number(oa.OUID || oa.OuID || oa.UID || 0)));
                    if (myObsEntry && Number(myObsEntry.Sts || myObsEntry.sts || 0) === 2) {
                        continue;
                    }
                }
            }

            // Filter out tasks from cold contacts

            // const taskConnection = connectionData.find(c => c.ConnID == task.connID);
            // if (taskConnection && (taskConnection.IsCold == 1 || taskConnection.IsCold == true)) {
            //     continue;
            // }

            // Filter by ownership
            if (ownership != 'all') {
                const myUserIDs = getMyAgenciesMappedIDs('UserID');
                const userIDsToCheck = myUserIDs.length > 0 ? myUserIDs : [currentUserID];
                if (ownership == 'own') {
                    if (!userIDsToCheck.includes(Number(task.uID))) {
                        continue;
                    }
                } else if (ownership == 'given') {
                    if (!userIDsToCheck.includes(Number(task.createdUserID)) || userIDsToCheck.includes(Number(task.uID))) {
                        continue;
                    }
                } else if (ownership == 'others') {
                    if (userIDsToCheck.includes(Number(task.uID))) {
                        continue;
                    }
                }
            }

            // Filter by taskTab
            if (!isMobile && taskTab && taskTab != 0) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const endOfToday = new Date(today);
                endOfToday.setHours(23, 59, 59, 999);

                const endOfNext7Days = new Date(today);
                endOfNext7Days.setDate(endOfNext7Days.getDate() + 7);
                endOfNext7Days.setHours(23, 59, 59, 999);

                const taskDueDT =
                    task.dueDT && !isNaN(new Date(task.dueDT))
                        ? new Date(task.dueDT)
                        : null;

                let passesTaskTab = false;

                switch (Number(taskTab)) {
                    case 1: // Overdue
                        passesTaskTab = taskDueDT && taskDueDT < today;
                        break;
                    case 2: // Today
                        passesTaskTab =
                            taskDueDT && taskDueDT >= today && taskDueDT <= endOfToday;
                        break;
                    case 3: // Week Ahead
                        passesTaskTab =
                            taskDueDT && taskDueDT > endOfToday && taskDueDT <= endOfNext7Days;
                        break;
                    default:
                        passesTaskTab = true;
                        break;
                }

                if (!passesTaskTab) continue;
            }

            // Filter by connID
            if (connID != 'all' && (!task.connID || task.connID.toString() != connID.toString())) continue;


            if (taskType && taskType != "all") {
                const currentTaskType = (task.typ || "").toString().toLowerCase().trim();
                const filterTaskType = taskType.toLowerCase().trim();

                if (currentTaskType != filterTaskType) continue;
            }

            // Filter by executive
            if (executive != 'all') {
                if (executive == 'unassigned') {
                    if (task.uID) continue;
                } else if (task.uID?.toString() != executive.toString()) continue;
            }

            // Filter by priority
            if (priority && priority != 'all') {
                const currentPri = (task.pri || "").toUpperCase().trim();
                const filterPri = priority.toUpperCase().trim();
                if (currentPri != filterPri) continue;
            }

            // Filter by status (desktop only) - already filtered upstream when pulling from the
            // history API (apiHistoryTasks), whose rows carry the raw 1/0 report status, not 2/4.
            if (!isApiHistoryMode && !isMobile && status && status != 'all') {
                if (task.sts?.toString() != status.toString()) continue;
            }

            // Filter by dateRange
            if (isApiHistoryMode) {
                if (dateRange && dateRange !== 'all') {
                    const taskDate = task.updatedDT || task.statusDT || task.dueDT || task.createdDT;
                    if (!isRecordInDateRange(taskDate, dateRange, finYear, otherMonth, otherQuarter, otherYear)) {
                        continue;
                    }
                }
            } else if (!isMobile) {
                if (dateRange == "Future") {
                    const today = new Date();
                    today.setHours(23, 59, 59, 999);
                    const taskDueDT = task.dueDT ? new Date(task.dueDT) : null;
                    if (!taskDueDT || taskDueDT <= today) continue;
                } else if (!isRecordInDateRange(task.dueDT, dateRange, finYear, otherMonth, otherQuarter, otherYear)) {
                    continue;
                }
            }

            // Filter by search term
            if (searchTerm && searchTerm.trim()) {
                const term = searchTerm.toLowerCase().trim();
                const matchesSearch = [
                    task.ttl || '',
                    task.txt || '',
                    task.typ || '',
                    task.bizName || '',
                    getExecutiveName(task.uID) || '',
                    task.threadNames || '',
                    task.threadTypes || '',
                    task.statusNote || '',
                ].some(field => field.toLowerCase().includes(term));
                if (!matchesSearch) continue;
            }

            // Filter by category
            if (category && category != 'all') {
                const usrCID = getTaskCategoryIDForUser(task, currentUserID);
                if (Number(usrCID) != Number(category)) continue;
            }

            // Filter by taskClass
            if (taskClass && taskClass !== 'all') {
                const currentTaskClass = Number(task.class || task.Class || task.taskClass || task.TaskClass || 1);
                const allowedClasses = String(taskClass).split(',').map(c => Number(c.trim())).filter(Boolean);
                if (!allowedClasses.includes(currentTaskClass)) continue;
            }

            // Filter by agency
            if (agency && agency != 'all') {
                if (Number(task.AgencyID) != Number(agency)) continue;
            }

            filtered.push(task);
        }

        setFilteredTasks(filtered);

        if (filtered.length != filteredTasks.length) {
            setCurrentPage(1);
        } prevFiltersRef.current = { taskType, status, priority, executive, connID, dateRange, finYear, otherMonth, taskTab, otherQuarter, otherYear, taskClass };
    };

    // Apply filters when dependencies change
    useEffect(() => {
        applyFilters();
    }, [tasksData, apiHistoryTasks, selectedFilters, searchTerm]);

    const allTypesSame = useMemo(() => {
        if (!currentTasks || currentTasks.length <= 1) return true;
        const firstType = (currentTasks[0].typ || "").toString().toLowerCase().trim();
        return currentTasks.every(t => (t.typ || "").toString().toLowerCase().trim() === firstType);
    }, [currentTasks]);

    const tableHeaderCols = useMemo(() => {
        const baseColumns = [
            { key: 'actions', label: '', className: 'align-middle' },
        ];

        const conditionalColumns = [];

        // Add Checkbox column
        // conditionalColumns.push({ key: 'checkbox', label: '', className: 'w-[1vw] px-4 align-middle text-center' });

        conditionalColumns.push({ key: 'ctgDot', label: '', className: 'w-[20px] !px-0 align-middle', tooltip: 'Category' });

        conditionalColumns.push({ key: 'ttl', label: 'Task', className: 'align-middle' });

        if (selectedFilters.connID == 'all' && hasContact) {
            conditionalColumns.push({ key: 'bizName', label: 'Contact', className: 'align-middle' });
        }

        if (selectedFilters.taskType == 'all' && !allTypesSame) {
            conditionalColumns.push({ key: 'typ', label: 'Type', className: 'align-middle' });
        }

        const isHistoryMode = selectedFilters.status === '2' || selectedFilters.status === '4' || selectedFilters.status === '3';
        const label = selectedFilters.status === '4' ? 'Cancelled on' : (selectedFilters.status === '2' ? 'Completed on' : selectedFilters.status === '3' ? 'Rejected on' : 'Finish by');
        conditionalColumns.push({ key: 'dueDT', label, className: 'align-middle' });

        if (hasMobile) {
            conditionalColumns.push({ key: 'connMobile', label: 'Mobile No.', className: 'align-middle' });
        }

        if (shouldShowFromCol) {
            conditionalColumns.push({ key: 'createdUserID', label: 'From', className: 'align-middle' });
        }

        // "Assigned to me" always hides the Executive column - it'd just be you in every row.
        if (selectedFilters.executive == 'all' && selectedFilters.ownership != 'own') {
            conditionalColumns.push({ key: 'uID', label: 'Executive', className: 'align-middle' });
        }

        if (!isInqOnlyMode) {
            conditionalColumns.push({ key: 'tIDs', label: `${activeThreadTypesArr.length > 2 ? 'Threads' : currActiveThreadType.typPlr}`, className: 'align-middle' });
        }

        // Status note - last data column, right before the Actions column. Only shown if at
        // least one of the currently filtered tasks actually has a status note.
        if (hasStatusNote) {
            conditionalColumns.push({ key: 'statusNote', label: 'Notes', className: 'align-middle' });
        }

        return [
            ...conditionalColumns,
            baseColumns[0] // Actions column
        ];
    }, [selectedFilters, hasMobile, hasContact, hasAssignedFrom, hasTasksFromOthers, hasStatusNote, allTypesSame]);

    // Format thread display
    const formatThreadDisplay = (task) => {
        const threadIDs = task.tIDs;
        if (!threadIDs?.trim()) return null;

        const threadNames = task.threadNames?.split(", ") || [];
        const threadTypes = task.threadTypes?.split(", ") || [];
        const threadDueDates = task.threadDueDates?.split(", ") || [];
        const threadSinceDates = task.threadSinceDates?.split(", ") || [];
        const threadTypeIDs = task.threadTypeIDs?.split(", ") || [];
        return (
            <div className="flex flex-wrap gap-2 lg:mt-0">
                {threadIDs
                    .split(",")
                    .map((ID, index) => ID.trim())
                    .map((threadId, index) => {
                        let threadIcon = null;
                        const typeID = threadTypeIDs[index];
                        if (typeID) {
                            const threadTypeMeta = getThreadTypeMeta(Number(typeID), threadTypesObj);

                            if (threadTypeMeta) {
                                threadIcon = threadTypeMeta.Icon;
                            }
                        }

                        const displayText = threadNames[index] || `Thread #${threadId}`;
                        const threadType = threadTypes[index] || "General";
                        const hasDateInfo = threadDueDates[index] || threadSinceDates[index];
                        const sinceDT = threadSinceDates[index]
                            ? getRelativeDateText(new Date(threadSinceDates[index]), false, false)
                            : "";
                        const targetDT = threadDueDates[index]
                            ? getRelativeDateText(new Date(threadDueDates[index]), false, false)
                            : "";

                        const BadgeContent = isInqOnlyMode ? null : (
                            <Button
                                variant="ghost"
                                size="sm"
                                className="justify-start p-0 h-auto"
                            >
                                <Badge className={`justify-start h-7 ${badgeBase} px-2`}>
                                    {threadIcon && (
                                        <ThreadSahiIcon
                                            tID={Number(typeID)}
                                            className="mr-2 flex-shrink-0"
                                        />
                                    )}
                                    <span className="truncate text-xs">{displayText}</span>
                                </Badge>
                            </Button>
                        );
                        if (displayText == " " || displayText == "-") {
                            return "-";
                        }

                        if (displayText.toLowerCase().startsWith("thread")) {
                            return null;
                        }

                        return hasDateInfo ? (
                            <HoverCard key={`thread-${threadId}`}>
                                <HoverCardTrigger asChild>{BadgeContent}</HoverCardTrigger>
                                <HoverCardContent className="bg-white sahi-radius shadow-2xl p-3 w-30 text-left" side="top">
                                    <h4 className="text-sm font-bold mb-2">{threadType}</h4>
                                    <div>
                                        {targetDT && (
                                            <div>
                                                <span className="text-muted-foreground">Due on: </span>
                                                <span>{targetDT}</span>
                                            </div>
                                        )}
                                        {sinceDT && (
                                            <div>
                                                <span className="text-muted-foreground">Since: </span>
                                                <span>{sinceDT}</span>
                                            </div>
                                        )}
                                    </div>
                                </HoverCardContent>
                            </HoverCard>
                        ) : (
                            <div key={`thread-${threadId}`}>{BadgeContent}</div>
                        );
                    })}
            </div>
        );
    };

    // Handle mobile filter icon click
    const handleFilterIconClick = (key) => {
        setActiveTab(key);
        clickedTabRef.current = true;
        setTimeout(() => { clickedTabRef.current = false; }, 500);
        const el = document.getElementById(key);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    // Scroll event listener for mobile filters
    useEffect(() => {
        const waitAndAttachScroll = () => {
            const container = document.querySelector(".filter-scroll-container");
            if (!container) {
                setTimeout(waitAndAttachScroll, 50);
                return;
            }
            const handleScroll = () => {
                if (clickedTabRef.current) return;
                const scrollTop = container.scrollTop;
                const scrollHeight = container.scrollHeight;
                const clientHeight = container.clientHeight;
                const scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
                const index = Math.min(
                    Math.floor((scrollPercent / 100) * sidebarIcons.length),
                    sidebarIcons.length - 1
                );
                const key = sidebarIcons[index]?.key;
                setActiveTab((prev) => (key != prev ? key : prev));
            };
            container.addEventListener("scroll", handleScroll);
            handleScroll();
            return () => container.removeEventListener("scroll", handleScroll);
        };
        waitAndAttachScroll();
    }, [isFilterSelected]);

    // Handle filter cancellation
    const handleCancel = () => {
        setTempFilters(selectedFilters);
        setTempSortConfig(sortConfig);
        setIsDrawerOpen(false);
        setIsFilterSelected(false);
    };

    useEffect(() => {
        // Reset mobile drawer state when URL changes (filters applied via URL)
        if (isMobile) {
            setIsDrawerOpen(false);
            setIsFilterSelected(false);
        }
    }, [location.search, isMobile])

    // Reset filters
    const handleResetFilters = () => {
        const clearedFilters = {
            taskType: 'all',
            status: '1',
            priority: 'all',
            executive: 'all',
            ownership: 'all',
            dateRange: 'all',
            otherMonth: "all",
            otherQuarter: "all",  // Add this
            otherYear: "all",
            connID: 'all',
            taskTab: 'all',
            category: 'all',
            taskClass: 'all',
            agency: 'all'
        };
        setSelectedFilters(clearedFilters);
        setTempFilters(clearedFilters);
        setSortConfig({ key: null, direction: null });
        setTempSortConfig({ key: null, direction: null });
        setSearchTerm('');
        setIsDrawerOpen(false);
        setIsFilterSelected(false);
        navigate(location.pathname, { replace: true });
    };

    // Filter button
    const FilterButton = () => {

        let activeFilterClass = isFilterSelected && !isMobile ? "filter-active" : "";
        let filterIconToggleClass = "h-4 w-4 " + (isMobile ? "" : (isFilterSelected ? "text-sahi-primary-color" : "text-white group-hover:text-sahi-primary-color"));
        return (
            <Button
                className={cn("button-config sahi-primary-button flex items-center justify-center group px-2.5 py-[5px] relative", activeFilterClass)}
                onClick={() => {
                    if (isMobile) {
                        setIsDrawerOpen(true);
                        setIsFilterSelected(true);
                    } else {
                        setIsFilterSelected(!isFilterSelected);
                    }
                }} aria-label="Toggle Filter"
            >
                <div className="h-6 w-6 flex items-center justify-center transition-all">
                    <Filter className={cn(filterIconToggleClass)} />
                </div>
                {hasActiveFilters && isMobile && (
                    <span className="absolute -top-1 -right-1 h-2.5 w-2.5 bg-sahi-green rounded-full border border-sahi-white" />
                )}
            </Button>
        );
    }

    //Open Add Task model
    const handleTaskEntryOpen = () => {
        setEditingTaskID(null);
        setTaskEntryPrefillData({});
        setDialogStates(prev => ({ ...prev, taskEntry: true }));
    }

    const handleEmptySlotClick = (label) => {
        if (isSlotInPast(label)) return;
        const { hour, minute } = parseSlotLabel(label);
        const selectedDate = new Date(selectedScheduleDate);
        selectedDate.setHours(hour, minute, 0, 0);
        setEditingTaskID(null);
        setTaskEntryPrefillData({
            dueDT: format(selectedDate, 'dd-MMM-yy'),
            dueTime: format(selectedDate, 'HH:mm')
        });
        setDialogStates(prev => ({ ...prev, taskEntry: true }));
    }

    buildTaskDetailsFallback = (task) => {
        if (!task) return null;
        const taskMobile = task.mobile || task.Mobile || task.mob || task.Mob || task.CreatedMobile || task.POCMobile || task.creatorMobile || task.pocMobile || null;
        return {
            taskID: task.tskID || task.TaskID,
            title: task.title || task.Task || task.ttl || '',
            pocTask: task.pocTask || task.POCTask || '',
            description: task.txt,
            type: task.typ,
            priority: task.pri,
            status: task.sts,
            dueDT: task.dueDT,
            dueDTF: getTableDateOrWeekday(task.dueDT),
            dueDTColor: getColorClass(getTaskColor(task.dueDT)),
            pocUserID: task.pocUserID || task.uID,
            pocUserName: getExecutiveName(task.uID || task.pocUserID, task.POCMobile || taskMobile),
            connID: task.connID,
            threadIDs: task.tIDs,
            ctrcIDs: '',
            connectionData: {
                bizName: task.bizName,
                contactName: task.contactName,
                mobile: task.mobile,
                email: task.email,
                cc: '91',
            },
            linkedThreads: [],
            linkedCtrcs: [],
            scIDs: task.scIDs,
            createdUserID: task.createdUserID,
            createdDT: task.createdDT || task.CreatedDT || null,
            createdUserName: getExecutiveName(task.createdUserID, task.CreatedMobile || taskMobile),
            lastRmdrDT: task.lastRmdrDT || null,
            rmdrDT: task.rmdrDT || null,
            createdCtgID: task.createdCtgID || 0,
            pocCtgID: task.pocCtgID || 0,
            AgencyID: task.AgencyID || 0,
            canComplete: task.canComplete == true,
            statusNote: task.statusNote || '',
            statusDT: task.statusDT || null,
            updatedDT: task.updatedDT || null,
            taskClass: task.class || task.Class || task.taskClass || task.TaskClass || 1,
            options: task.options || task.Options || null,
            observerUserIDs: extractObserverUserIDs(task).join(","),
        };
    };


    //Open Add Task model
    const openTaskDetails = (taskID, isClosed = false, task = null) => {
        setOpenTaskDetail(true);
        setSelectedTaskID(taskID)
        setSelectedTaskForceClosed(isClosed)
        setSelectedTaskCompletedDT(task?.updatedDT || task?.dueDT || null)
        setSelectedTaskFallbackData(buildTaskDetailsFallback(task))
    }

    // Mobile task card
    const MobileTaskCard = ({ task, index, range }) => {
        const isOverdue = task.dueDT && new Date(task.dueDT) < new Date();
        const taskID = task.tskID;
        const isLoading = taskActionLoading[taskID];
        const myUserIDs = getMyAgenciesMappedIDs('UserID');
        const isMyCreator = myUserIDs.includes(Number(task.createdUserID)) || Number(task.createdUserID) === currentUserID;
        const isMyAssignee = myUserIDs.includes(Number(task.pocUserID)) || Number(task.pocUserID) === currentUserID;
        const canCancel = isMyCreator;

        return (
            <div key={task.TaskID || index} className="bg-sahi-white sahi-radius shadow-sm border border-zinc-200 w-full f-col justify-between" onClick={() => {
                openTaskDetails(task.tskID);
            }}>
                {/* --- Header Section (Same structure as dashboard) --- */}
                <div className="f-col gap-1 mobile-tile-header-layout-v2">
                    {/* Top Row: Type & Due Date */}
                    <div className="flex justify-between items-center mb-1">
                        <div className="flex flex-row items-center gap-2 text-xs flex-shrink-0 whitespace-nowrap">
                            <div className="flex items-center gap-1">
                                {getTaskClassIcon(task.class || task.Class || task.taskClass || task.TaskClass)}
                                <span className="text-xs font-medium text-foreground">
                                    {task.typ || "General"}
                                </span>
                            </div>
                            {task.pri && (() => {
                                const priority = getPriorityDetails(task.pri);
                                const IconComponent = priority.icon;
                                return priority.showBadge && (
                                    <span className="flex items-center" style={{ color: priority.color }}>
                                        <IconComponent className="h-4 w-4" style={{ color: priority.color }} strokeWidth={2} />
                                    </span>
                                );
                            })()}
                            {(() => {
                                const usrCID = getTaskCategoryIDForUser(task, currentUserID) || null;
                                // Read-only badge for an already-assigned category - keep showing it even
                                // if the category was since deleted (IsD); only pickers exclude those.
                                const cat = usrCID ? myTaskCtgs.find(c => c.CID == usrCID) : null;
                                if (!cat) return null;
                                return (
                                    <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: cat.Clr }} title={cat.CNm} />
                                );
                            })()}
                        </div>
                        <div className="flex flex-row items-center gap-1 text-xs flex-shrink-0 whitespace-nowrap">
                            {range == "overdue" && <Clock className="h-3 w-3 flex-shrink-0 text-sahi-red" />}

                            {range == "today" && task.rmdrDT && (
                                new Date(task.rmdrDT) < new Date() ? (
                                    <BellRing
                                        className={`h-3 w-3 mr-1 ${isOverdue
                                            ? "text-sahi-red"
                                            : "text-sahi-blue"
                                            }`}
                                    />
                                ) : (
                                    <Bell className={`h-3 w-3 mr-1 ${isOverdue ? "text-sahi-red" : "text-sahi-blue"}`} />
                                )
                            )}

                            {range == "future" && (
                                task.rmdrDT ? (
                                    new Date(task.rmdrDT) < new Date() ? (
                                        <BellRing className={`h-3 w-3 mr-1 ${isOverdue ? "text-sahi-red" : "text-sahi-blue"}`} />
                                    ) : (
                                        <Bell className={`h-3 w-3 mr-1 ${isOverdue ? "text-sahi-red" : "text-sahi-blue"}`} />
                                    )
                                ) : (
                                    <Clock className={`h-3 w-3 mr-1 ${isOverdue ? "text-sahi-red" : "text-sahi-blue"}`} />
                                )
                            )}

                            {range == "today" && !task.rmdrDT && (
                                isOverdue ? (
                                    <BsHourglassBottom className="h-3 w-3 mr-1 text-sahi-red" />
                                ) : (
                                    <BsHourglassTop className="h-3 w-3 mr-1 text-sahi-blue" />
                                )
                            )}

                            <span className={isOverdue ? "text-sahi-red" : "text-sahi-blue"}>
                                {task.dueDT
                                    ? getRelativeDateText(task.dueDT, false, true, false, false, true).replace("11:59 PM", "by EOD")
                                    : "Not set"}
                            </span>
                        </div>

                    </div>
                    {/* Task Title */}
                    <div className="flex items-start justify-between gap-2 mb-1 w-full">
                        <h4 className={`text-sm text-foreground font-medium leading-tight ${mobileTaskGroups?.[range]?.length > 10
                            ? "line-clamp-1"
                            : "break-words"
                            }`}>
                            {task.ttl || "Untitled Task"}
                        </h4>
                    </div>

                    {/* Middle Row: Contact Name */}
                    {(task.bizName || task.contactName) && (
                        <div className="flex !items-center gap-2 mb-1 text-sahi-primary-color">
                            {task.bizName ? <Building2 size={14} /> : <User size={14} />}
                            <span className="text-xs font-semibold">
                                {task.bizName || task.contactName || '-'}
                            </span>
                        </div>
                    )}

                    {/* Thread Display (if any) */}
                    {task.threadNames?.trim() && (
                        <div className="overflow-hidden transition-all duration-300 ease-in-out max-h-96 opacity-100">
                            {formatThreadDisplay(task)}
                        </div>
                    )}
                </div>

                {/* --- Footer Section (Same structure as dashboard) --- */}
                <div className="flex justify-between items-center text-xs border-t border-[#f1f1f1] w-full mobile-tile-footer-layout !px-2 py-2">
                    <div className="flex items-center gap-2">
                        {task.uID && !myUserIDs.includes(Number(task.uID)) && (
                            <div className='f-row justify-start gap-1 items-center text-sub-text-color'>
                                <User className="h-3 w-3" />
                                <span className="flex items-center gap-2.5 text-xs">
                                    {getExecutiveName(task.uID, task) || "POC: Not Assigned"}
                                    {/* {task.sts == 3 && (
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <CircleCheckBig className="h-[14px] w-[14px] text-zinc-400 flex-shrink-0" strokeWidth={2.5} />
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                {myUserIDs.includes(Number(task.uID)) ? "You" : (getExecutiveName(task.uID, task) || "This user")} marked this task as done
                                            </TooltipContent>
                                        </Tooltip>
                                    )} */}
                                </span>
                            </div>
                        )}
                    </div>
                    <div>
                        <div className="flex items-center gap-2">

                            {/* Bell icon for tasks assigned to other users */}
                            {task.pocUserID && !isMyAssignee && isMyCreator ? (
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            className={`${actionButton} hover:bg-sahi-blue-light`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAction(task, "REMIND");
                                            }}
                                        >
                                            {isLoading == 'reminding' ? (
                                                <div className={`h-3 w-3 ${loadingSpinner} border-sahi-blue border-t-transparent`} />
                                            ) : (
                                                <BsBellFill className="h-3 w-3 text-sahi-blue" />
                                            )}
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>
                                            {isReminderSentToday(task.lastRmdrDT)
                                                ? "One reminder per day allowed"
                                                : <>Remind<br />{getExecutiveName(task.uID, task)}</>
                                            }
                                        </p>
                                    </TooltipContent>
                                </Tooltip>
                            ) : null}

                            {task.mobile != "" ? (
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            className={`${actionButton} hover:bg-sahi-green-light`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const connection = connectionData.find(c => c.ConnID == task.connID);
                                                setTemplateDialogData({
                                                    connID: task.connID,
                                                    cc: connection?.CC || 91,
                                                    contactName: connection?.ContactName,
                                                    bizName: connection?.BizName,
                                                    mobile: task.mobile,
                                                });
                                                setTemplateDialogOpen(true);
                                            }}
                                        >
                                            <BsWhatsapp className="w-4.5 h-4.5 text-sahi-green" />
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>
                                            {connectionData.find(c => c.ConnID == task.connID)?.ContactName || 'Unknown'} - +{connectionData.find(c => c.ConnID == task.connID)?.CC || 91} {task.mobile}
                                        </p>
                                    </TooltipContent>
                                </Tooltip>
                            ) : null}

                            {task.mobile != "" ? (
                                // {task.mobile != "" && ["call", "dialed"].includes((task.typ || "").toLowerCase()) ? (
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            className={`${actionButton} hover:bg-sahi-blue-light`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const isDesktop = typeof window != 'undefined' && window.innerWidth > 768;
                                                handlePhoneClickAction(connectionData.find(c => c.ConnID == task.connID), isDesktop, "", task.connID);
                                            }}
                                        >
                                            <MdPhone className="w-4.5 h-4.5 text-black" />
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>
                                            {isReminderSentToday(task.lastRmdrDT)
                                                ? "One reminder per day allowed"
                                                : <>Remind<br />{getExecutiveName(task.uID)}</>
                                            }
                                        </p>
                                    </TooltipContent>
                                </Tooltip>
                            ) : null}


                            {task.sts == 1 && (isMyCreator || (isMyAssignee && task.canComplete == true)) && !(Number(task.class || task.Class || task.taskClass || task.TaskClass || 1) === 4 && isMyCreator) && (
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            className={`${actionButton} hover:bg-sahi-green-light`}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                if (!isLoading) {
                                                    handleItemAction('COMPLETE', task, 'task', e);
                                                }
                                            }}
                                            disabled={isLoading}
                                        >
                                            {isLoading == 'completing' ? (
                                                <div className={`h-3 w-3 ${loadingSpinner} border-sahi-green border-t-transparent`} />
                                            ) : (
                                                <Check className="h-3 w-3 text-sahi-green" />
                                            )}
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>Mark as complete</p>
                                    </TooltipContent>
                                </Tooltip>
                            )}

                            {/* Cancel Action */}
                            {canCancel && <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className={`${actionButton} hover:bg-sahi-red-light`}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            if (!isLoading) {
                                                handleItemAction('CANCEL', task, 'task', e);
                                            }
                                        }}
                                        disabled={isLoading}
                                    >
                                        {isLoading == 'cancelling' ? (
                                            <div className={`h-3 w-3 ${loadingSpinner} border-sahi-red border-t-transparent`} />
                                        ) : (
                                            <X className="h-3 w-3 text-sahi-red" />
                                        )}
                                    </Button>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>Cancel task</p>
                                </TooltipContent>
                            </Tooltip>
                            }

                            {/* Reject Action - Assignee declines the task (uses the Cancel action under the hood) */}
                            {!canCancel && isMyAssignee && task.sts == 1 && <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className={`${actionButton} hover:bg-sahi-red-light`}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            if (!isLoading) {
                                                handleItemAction('CANCEL', task, 'task', e);
                                            }
                                        }}
                                        disabled={isLoading}
                                    >
                                        {isLoading == 'cancelling' ? (
                                            <div className={`h-3 w-3 ${loadingSpinner} border-sahi-red border-t-transparent`} />
                                        ) : (
                                            <X className="h-3 w-3 text-sahi-red" />
                                        )}
                                    </Button>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>Reject task</p>
                                </TooltipContent>
                            </Tooltip>
                            }

                            {/* Edit Action - Always available */}
                            {canEditTask(task) && <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className={`${actionButton} hover:bg-sahi-blue-light`}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            handleItemAction('EDIT', task, 'task', e)
                                        }}
                                    >
                                        <Pencil className="h-3 w-3 text-sahi-blue" />
                                    </Button>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>Edit Task</p>
                                </TooltipContent>
                            </Tooltip>}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center h-96">
                <Loader2 className="h-8 w-8 animate-spin text-sahi-primary-color mr-3" />
                <span className="text-text-color">Loading tasks...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-6">
                <Card className="border-sahi-red bg-red-50">
                    <CardContent className="p-4">
                        <p className="text-sahi-red font-medium">{error}</p>
                    </CardContent>
                </Card>
            </div>
        );
    }

    const getScheduleTasksForDate = (date) => {
        const targetDate = format(date, 'yyyy-MM-dd');
        const dayTasks = tasksData.filter(t => t.sts === 1 && t.dueDT && format(new Date(t.dueDT), 'yyyy-MM-dd') == targetDate);

        // Group by 30-minute slot (rounded down), e.g. "4:00 PM" or "4:30 PM"
        const groups = {};
        dayTasks.forEach(task => {
            const taskDate = new Date(task.dueDT);
            const slotDate = new Date(taskDate);
            slotDate.setMinutes(taskDate.getMinutes() < 30 ? 0 : 30, 0, 0);
            const slot = format(slotDate, 'h:mm a');
            if (!groups[slot]) groups[slot] = [];
            groups[slot].push(task);
        });
        return groups;
    };

    // Parses a "h:mm a" slot label into 24-hour {hour, minute}
    const parseSlotLabel = (label) => {
        const [time, modifier] = label.split(' ');
        let [hour, minute] = time.split(':').map(Number);
        if (modifier == 'PM' && hour < 12) hour += 12;
        if (modifier == 'AM' && hour == 12) hour = 0;
        return { hour, minute };
    };

    // Builds a real Date for a given slot label, on the selected schedule date
    const dateForSlot = (label, baseDate = selectedScheduleDate) => {
        const { hour, minute } = parseSlotLabel(label);
        const d = new Date(baseDate);
        d.setHours(hour, minute, 0, 0);
        return d;
    };

    // A slot is in the past when the computed slot datetime is before now
    const isToday = format(selectedScheduleDate, 'yyyy-MM-dd') == format(now, 'yyyy-MM-dd');
    const isSlotInPast = (label) => dateForSlot(label) < now;

    // Half-hour slots across the full day: 12:00 AM -> 11:30 PM
    const hourLabels = [];
    for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 30) {
            const d = new Date();
            d.setHours(h, m, 0, 0);
            hourLabels.push(format(d, 'h:mm a'));
        }
    }

    // The slot the "now" line and auto-scroll should target
    const currentSlotLabel = format(
        new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() < 30 ? 0 : 30),
        'h:mm a'
    );

    // Progress (0-1) through the current slot, for precisely positioning the "now" line
    const currentSlotProgress = (now.getMinutes() % 30) / 30;

    return (
        <TooltipProvider>
            {isMobile && mobileView === 'list' && (
                <div
                    ref={taskListPullIndicatorRef}
                    className="fixed left-0 right-0 flex justify-center pointer-events-none z-[60]"
                    style={{ top: -56, transform: "translateY(0px)", opacity: 0, willChange: "transform, opacity" }}
                >
                    <div className="mt-2 bg-sahi-white shadow-md rounded-full p-2 flex items-center justify-center">
                        <RotateCcw ref={taskListPullIconRef} className={`h-5 w-5 text-sahi-primary-color ${isTaskListPullRefreshing ? 'animate-spin' : ''}`} />
                    </div>
                </div>
            )}
            <div className={`${mobileView == 'schedule' && isMobile ? 'space-y-0' : 'space-y-3'} lg:space-y-6`}>
                {/* Desktop Header */}
                <div className="hidden lg:block">
                    <div className="flex justify-between items-center gap-3">
                        <div className="flex items-center flex-grow">
                            <h1 className="text-3xl font-bold text-text-color mr-4 web-header-name">Tasks</h1>
                            <div className="flex items-center justify-end flex-grow">
                                {tasksData.length > 0 && (
                                    <div className="relative w-120 sahi-radius filter-border">
                                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
                                        <Input
                                            placeholder="Search tasks"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="pl-10 h-10 border-none focus:outline-none focus:ring-0 shadow-none"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="flex items-center gap-3">
                            {false && taskDeleteBulkIDs.length > 0 && (
                                String(currentUserID) == String(agencyData?.AdminUserID) ||
                                taskDeleteBulkIDs.every(id => {
                                    const task = tasksData.find(t => t.tskID == id);
                                    return task && String(task.createdUserID) == String(currentUserID);
                                })
                            ) && (
                                    <AlertDialog open={deleteAlertOpen} onOpenChange={setDeleteAlertOpen}>
                                        <AlertDialogTrigger asChild>
                                            <Button className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]">
                                                <Trash2 className="h-4 w-4" />
                                                Delete
                                            </Button>
                                        </AlertDialogTrigger>
                                        <AlertDialogContent>
                                            <AlertDialogHeader>
                                                <AlertDialogTitle>
                                                    Are you sure you wish to delete {taskDeleteBulkIDs.length}{" "}
                                                    {taskDeleteBulkIDs.length == 1 ? "task" : "tasks"}?
                                                </AlertDialogTitle>
                                                <AlertDialogDescription>
                                                    This action cannot be undone.
                                                </AlertDialogDescription>
                                            </AlertDialogHeader>
                                            <AlertDialogFooter className="!justify-start gap-3">
                                                <Button
                                                    onClick={() => { handleBulkDelete(); }}
                                                    className="sahi-primary-button flex-1 sm:flex-none sm:min-w-[120px]"
                                                >
                                                    <Check className="w-3 h-3" />
                                                    Delete {taskDeleteBulkIDs.length} {taskDeleteBulkIDs.length == 1 ? "Task" : "Tasks"}
                                                </Button>
                                                <Button
                                                    variant="outline"
                                                    onClick={() => setDeleteAlertOpen(false)}
                                                    className="sahi-secondary-button flex-1 sm:flex-none sm:min-w-[100px]"
                                                >
                                                    <X className="w-3 h-3" /> Close
                                                </Button>
                                            </AlertDialogFooter>
                                        </AlertDialogContent>
                                    </AlertDialog>
                                )}
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            variant="outline"
                                            onClick={() => setTaskTimesOpen(true)}
                                            className="sahi-secondary-button w-full sm:w-auto hidden sm:flex px-3"
                                        >
                                            <SlidersHorizontal className="h-5 w-5" />
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>Task Settings</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                            <Button
                                onClick={handleTaskEntryOpen}
                                className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
                            >
                                <Plus className="h-4 w-4" />
                                Add Task
                            </Button>
                        </div>
                        <FilterButton />
                    </div>
                </div>

                {!isMobile && (
                    isFilterSelected && (
                        <div className='flex flex-wrap gap-4'>
                            {[...filterOptions.slice(0)].map(({ key, label, options, displayValue, mobileOnly, disabled, searchEnabled, showClearButton, hideAllOption, renderOption }) => {
                                if (mobileOnly) return null;
                                return (
                                    <CommonFilter
                                        key={key}
                                        label={label}
                                        options={options}
                                        value={selectedFilters[key]}
                                        onChange={(value) => {
                                            const finalValue = (key === 'status' && (value === 'all' || !value)) ? '1' : value;
                                            setSelectedFilters((prev) => {
                                                const updated = { ...prev, [key]: finalValue };
                                                if (key === 'status' && finalValue === '1') {
                                                    updated.dateRange = 'all';
                                                    updated.otherMonth = 'all';
                                                    updated.otherQuarter = 'all';
                                                    updated.otherYear = 'all';
                                                }
                                                return updated;
                                            });
                                            setTempFilters((prev) => {
                                                const updated = { ...prev, [key]: finalValue };
                                                if (key === 'status' && finalValue === '1') {
                                                    updated.dateRange = 'all';
                                                    updated.otherMonth = 'all';
                                                    updated.otherQuarter = 'all';
                                                    updated.otherYear = 'all';
                                                }
                                                return updated;
                                            });
                                        }}
                                        displayValue={displayValue}
                                        disabled={disabled}
                                        searchEnabled={searchEnabled}
                                        showClearButton={showClearButton}
                                        hideAllOption={hideAllOption}
                                        renderOption={renderOption}
                                    />
                                );
                            })}
                        </div>
                    )
                )}


                {/* Mobile Filter Drawer */}
                {/* {isFilterSelected && isMobile && (
                    <Drawer open={isDrawerOpen} onOpenChange={(open) => {
                        setIsDrawerOpen(open);
                        if (!open) {
                            setIsFilterSelected(false);
                        }
                    }}>
                        <DrawerContent className="p-0 [&>div:first-child]:hidden">
                            <div className="flex flex-col h-[100dvh]">
                                <div className="flex plain items-center justify-between p-4 border-b-2 border-zinc-200">
                                    <div className="flex gap-4 items-center ">
                                        <DrawerClose tabIndex={-1} className="p-0 w-auto h-auto flex-shrink-0 flex justify-center">
                                            <ArrowLeft className="h-[24px] w-[24px]" onClick={handleCancel} />
                                            <span className="sr-only">Back</span>
                                        </DrawerClose>
                                        <p className="text-lg font-semibold text-sahi-primary-color">Task Filters</p>
                                    </div>
                                    <button onClick={handleResetFilters} className="group flex items-center gap-1 text-sm font-light hover:underline text-sahi-primary-color">
                                        <RiResetLeftFill className="group-hover:rotate-[-20deg] transition-transform duration-200" />
                                        <span>Reset</span>
                                    </button>
                                </div>
                                <div className="flex flex-1 overflow-hidden">
                                    <div className="flex-1 p-3 overflow-y-auto filter-scroll-container">
                                        {filterOptions.map(({ key, label, options, displayValue, type, disabled, searchEnabled, mobileDropdownText,
                                            mobileLabel, showAllOption }) => (
                                            <div key={key} id={key} className="mb-4">
                                                <DrawerFilter
                                                    id={key}
                                                    label={label}
                                                    options={options}
                                                    value={tempFilters[key]}
                                                    displayValue={displayValue}
                                                    onChange={(value) => setTempFilters(prev => ({ ...prev, [key]: value }))}
                                                    sortConfig={tempSortConfig}
                                                    sortOptionMap={mobileSortMap}
                                                    setTempsortConfig={setTempSortConfig}
                                                    tempsortConfig={tempSortConfig}
                                                    type={type}
                                                    disabled={disabled}
                                                    mobileDropdownText={mobileDropdownText}
                                                    searchEnabled={searchEnabled}
                                                    MobileLabel={mobileLabel}
                                                    showAllOption={showAllOption}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <DrawerFooter className="sticky bottom-0 border-t-2 p-3 bg-white">
                                    <DrawerClose>
                                        <div className="flex justify-start gap-2">
                                            <Button
                                                className="sahi-primary-button"
                                                onClick={() => {
                                                    setIsDrawerOpen(false);
                                                    setSelectedFilters(tempFilters);
                                                    sortData(
                                                        tempSortConfig.key,
                                                        tempSortConfig.direction
                                                    );
                                                }}
                                            >
                                                Apply
                                            </Button>
                                            <Button variant="outline" className="sahi-secondary-button" onClick={handleCancel}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </DrawerClose>
                                </DrawerFooter>
                            </div>
                        </DrawerContent>
                    </Drawer>
                )} */}

                {isFilterSelected && isMobile && (
                    <Drawer open={isDrawerOpen} onOpenChange={(open) => {
                        setIsDrawerOpen(open);
                        if (!open) {
                            setIsFilterSelected(false);
                        }
                    }}>
                        <DrawerContent className="p-0 [&>div:first-child]:hidden">
                            <div className="flex flex-col h-[100dvh]">
                                <div className="flex plain items-center justify-between p-4 border-b-2 border-zinc-200">
                                    <div className="flex gap-4 items-center ">
                                        <DrawerClose tabIndex={-1} className="p-0 w-auto h-auto flex-shrink-0 flex justify-center">
                                            <ArrowLeft className="h-[24px] w-[24px]" onClick={handleCancel} />
                                            <span className="sr-only">Back</span>
                                        </DrawerClose>
                                        <p className="text-lg font-semibold text-sahi-primary-color">Task Filters</p>
                                    </div>
                                    <button onClick={handleResetFilters} className="group flex items-center gap-1 text-sm font-light hover:underline text-sahi-primary-color">
                                        <RiResetLeftFill className="group-hover:rotate-[-20deg] transition-transform duration-200" />
                                        <span>Reset</span>
                                    </button>
                                </div>
                                <div className="flex flex-1 overflow-hidden">
                                    <div className="flex-1 p-3 overflow-y-auto filter-scroll-container">
                                        {filterOptions.filter(opt => opt.key != 'priority').map((filterOption) => {
                                            const { key, label, options, displayValue, type, disabled, searchEnabled, mobileDropdownText,
                                                mobileLabel, showAllOption, renderOption } = filterOption;

                                            if (key == 'ownership' && isMobile) {
                                                const labelClass = "text-base font-semibold mb-2 block text-zinc-800";
                                                const checkboxClass = "h-4 w-4 rounded-full border-zinc-300 text-[var(--sahi-primary-color)] focus:ring-[var(--sahi-primary-color)] accent-[var(--sahi-primary-color)]";
                                                const radioLabelClass = "ml-2 text-sm font-medium text-zinc-700 cursor-pointer";

                                                return (
                                                    <div key={key} id={key} className="mb-4">
                                                        <label className={labelClass}>{mobileLabel || label}</label>
                                                        <div className="flex flex-wrap items-center gap-4">
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="radio"
                                                                    id="ownership-all"
                                                                    name="ownership-radio"
                                                                    checked={tempFilters.ownership == 'all'}
                                                                    onChange={() => setTempFilters(prev => ({ ...prev, ownership: 'all', executive: 'all' }))}
                                                                    className={checkboxClass}
                                                                />
                                                                <label htmlFor="ownership-all" className={radioLabelClass}>All</label>
                                                            </div>

                                                            <div className="flex items-center">
                                                                <input
                                                                    type="radio"
                                                                    id="ownership-me"
                                                                    name="ownership-radio"
                                                                    checked={tempFilters.ownership == 'own'}
                                                                    onChange={() => setTempFilters(prev => ({ ...prev, ownership: 'own', executive: 'all' }))}
                                                                    className={checkboxClass}
                                                                />
                                                                <label htmlFor="ownership-me" className={radioLabelClass}>Me</label>
                                                            </div>

                                                            {!isSmartSellerMode() && usersFromRedux.length > 1 && (
                                                                <div className="flex items-center gap-2">
                                                                    <div className="flex items-center shrink-0">
                                                                        <input
                                                                            type="radio"
                                                                            id="ownership-others"
                                                                            name="ownership-radio"
                                                                            checked={tempFilters.ownership == 'others'}
                                                                            onChange={() => {
                                                                                if (tempFilters.ownership != 'others') {
                                                                                    setTempFilters(prev => ({ ...prev, ownership: 'others', executive: 'all' }));
                                                                                }
                                                                            }}
                                                                            className={checkboxClass}
                                                                        />
                                                                    </div>
                                                                    <div className="w-auto min-w-[100px]">
                                                                        <CustomSearchableDropdown
                                                                            options={[
                                                                                ...usersFromRedux
                                                                                    .filter(u => String(u.userID) != String(currentUserID))
                                                                                    .sort((a, b) => a.name.localeCompare(b.name))
                                                                                    .map(u => {
                                                                                        const trimmed = (u.name || '').trim().toLowerCase();
                                                                                        const isDup = reduxUserCounts[trimmed] > 1;
                                                                                        const agnName = isDup ? (u.agencyName || u.AgencyName || getAgencyNameByID(u.agencyID || u.AgencyID)) : '';
                                                                                        return {
                                                                                            label: u.name,
                                                                                            value: u.userID,
                                                                                            agencyName: agnName
                                                                                        };
                                                                                    }),
                                                                                {
                                                                                    label: 'All Others',
                                                                                    value: 'all'
                                                                                }
                                                                            ]}

                                                                            value={tempFilters.ownership == 'others' ? (tempFilters.executive == 'unassigned' || tempFilters.executive == 'all' ? 'all' : tempFilters.executive) : null}
                                                                            placeholder="Others"
                                                                            onSelect={(val) => setTempFilters(prev => ({ ...prev, ownership: 'others', executive: val }))}
                                                                            displayKey="label"
                                                                            valueKey="value"
                                                                            cancellable={false}
                                                                            disableMobileUI={false}
                                                                            searchEnabled={false}
                                                                            disabled={false}
                                                                            noSort={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            if (key == 'category') {
                                                return (
                                                    <div key={key} id={key} className="mb-4">
                                                        <h3 className="font-semibold text-md text-text-color mb-3">{mobileLabel || label}</h3>
                                                        <MobileFullScreenDropdown
                                                            options={[{ name: 'All Categories', ID: 'all', Clr: null }, ...(options || [])]}
                                                            value={tempFilters[key]}
                                                            onSelect={(val) => setTempFilters(prev => ({ ...prev, [key]: val }))}
                                                            displayKey="name"
                                                            valueKey="ID"
                                                            placeholder="All Categories"
                                                            mobileDropdownText="Select Category"
                                                            searchThreshold={15}
                                                            showClearButton={false}
                                                            isfilter={true}
                                                            resetButton={true}
                                                            handleReset={() => setTempFilters(prev => ({ ...prev, [key]: 'all' }))}
                                                            isSorting={false}
                                                            showAllOption={false}
                                                            renderOption={(opt) => (
                                                                <span className="flex items-center gap-2">
                                                                    {opt.Clr && <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: opt.Clr }} />}
                                                                    <span>{opt.name}</span>
                                                                </span>
                                                            )}
                                                        />
                                                    </div>
                                                );
                                            }

                                            return (
                                                <div key={key} id={key} className="mb-4">
                                                    <DrawerFilter
                                                        id={key}
                                                        label={label}
                                                        options={options}
                                                        value={tempFilters[key]}
                                                        displayValue={displayValue}
                                                        onChange={(value) => setTempFilters(prev => ({ ...prev, [key]: value }))}
                                                        sortConfig={tempSortConfig}
                                                        sortOptionMap={mobileSortMap}
                                                        setTempsortConfig={setTempSortConfig}
                                                        tempsortConfig={tempSortConfig}
                                                        type={type}
                                                        disabled={disabled}
                                                        mobileDropdownText={mobileDropdownText}
                                                        searchEnabled={searchEnabled}
                                                        MobileLabel={mobileLabel}
                                                        showAllOption={showAllOption}
                                                        searchThreshold={15}
                                                        renderOption={renderOption}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <DrawerFooter className="sticky bottom-0 border-t-2 p-3 bg-white">
                                    <DrawerClose>
                                        <div className="flex justify-start gap-2">
                                            <Button
                                                className="sahi-primary-button"
                                                onClick={() => {
                                                    setIsDrawerOpen(false);
                                                    setSelectedFilters(tempFilters);
                                                    sortData(
                                                        tempSortConfig.key,
                                                        tempSortConfig.direction
                                                    );
                                                }}
                                            >
                                                Apply
                                            </Button>
                                            <Button variant="outline" className="sahi-secondary-button" onClick={handleCancel}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </DrawerClose>
                                </DrawerFooter>
                            </div>
                        </DrawerContent>
                    </Drawer>
                )}

                {/* Tasks Table/List */}
                {(currentTasks.length > 0 || isMobile) ? (
                    <>

                        {!isMobile ? (
                            <>
                                <Card className="bg-sahi-white hidden lg:block !pt-0 overflow-hidden ">
                                    <CardContent className="px--5 !sahi-radius">
                                        <Table className="min-w-full table-auto">
                                            <TableHeader>
                                                <TableRow className="bg-sahi-white py-1.5 h-11">
                                                    {tableHeaderCols.map(({ key, label, className, tooltip }) => (
                                                        <TableHead
                                                            key={key}
                                                            className={cn("font-semibold text-sm text-black whitespace-nowrap uniform-spacing align-top", className)}
                                                            onClick={() => key != 'checkbox' && sortData(key)}
                                                        >
                                                            {key == 'checkbox' ? (
                                                                <div className="flex items-start justify-center py-1 user-select-none" style={{ userSelect: 'none' }}>
                                                                    <Checkbox
                                                                        checked={currentTasks.length > 0 && currentTasks.every(t => t.isChecked)}
                                                                        onCheckedChange={handleSelectAllCurrentPage}
                                                                        className="data-[state=checked]:bg-sahi-primary-color data-[state=checked]:border-sahi-primary-color data-[state=checked]:text-white transition-colors user-select-none"
                                                                        style={{ userSelect: 'none' }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                tooltip ? (
                                                                    <TooltipProvider>
                                                                        <Tooltip>
                                                                            <TooltipTrigger asChild>
                                                                                <div className="flex items-center cursor-pointer w-full h-full justify-center">
                                                                                    {label || <span className="inline-block w-4 h-4"></span>}
                                                                                    {!["actions", "tIDs", "checkbox", "pri"].includes(key) &&
                                                                                        sortConfig.key == key &&
                                                                                        sortConfig.direction && (
                                                                                            sortConfig.direction == "asc" ? (
                                                                                                <ArrowUp className="ml-1 h-4 w-4 text-black" />
                                                                                            ) : (
                                                                                                <ArrowDown className="ml-1 h-4 w-4 text-black" />
                                                                                            )
                                                                                        )}
                                                                                </div>
                                                                            </TooltipTrigger>
                                                                            <TooltipContent side="top">
                                                                                <p>{tooltip}</p>
                                                                            </TooltipContent>
                                                                        </Tooltip>
                                                                    </TooltipProvider>
                                                                ) : (
                                                                    <div className="flex items-center cursor-pointer">
                                                                        {label}
                                                                        {!["actions", "tIDs", "checkbox", "pri"].includes(key) &&
                                                                            sortConfig.key == key &&
                                                                            sortConfig.direction && (
                                                                                sortConfig.direction == "asc" ? (
                                                                                    <ArrowUp className="ml-1 h-4 w-4 text-black" />
                                                                                ) : (
                                                                                    <ArrowDown className="ml-1 h-4 w-4 text-black" />
                                                                                )
                                                                            )}
                                                                    </div>
                                                                )
                                                            )}
                                                        </TableHead>
                                                    ))}
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody>
                                                {currentTasks.map((task, index) => {
                                                    const isOverdue = task.dueDT && new Date(task.dueDT) < new Date();
                                                    const taskID = task.tskID;
                                                    const isLoading = taskActionLoading[taskID];
                                                    const myUserIDs = getMyAgenciesMappedIDs('UserID');
                                                    const isMyCreator = myUserIDs.includes(Number(task.createdUserID)) || Number(task.createdUserID) === currentUserID;
                                                    const isMyAssignee = myUserIDs.includes(Number(task.uID)) || Number(task.uID) === currentUserID;
                                                    const obsArr = task.observerUserIDs ? (Array.isArray(task.observerUserIDs) ? task.observerUserIDs : String(task.observerUserIDs).split(',').map(Number).filter(Boolean)) : [];
                                                    const isMyObserver = obsArr.some(id => myUserIDs.includes(Number(id)) || Number(id) === currentUserID);
                                                    const isTaskClosed = task.sts === 2 || task.sts === 4 || task.sts === 3;
                                                    const canCancel = isMyCreator && !isTaskClosed;
                                                    const showMarkDoneBtn = isMyAssignee && !isMyCreator && !isTaskClosed;
                                                    const showCompleteBtn = isMyCreator && !showMarkDoneBtn && !isTaskClosed;
                                                    const isReallyClosed = task.sts === 0 || task.sts === 2 || task.sts === 4 || task.sts === 3;
                                                    const tc = Number(task.class || task.Class || task.taskClass || task.TaskClass || 1);
                                                    const showReopenBtn = isMyCreator && isReallyClosed && tc !== 2 && tc !== 3 && tc !== 4;
                                                    return (
                                                        <TableRow key={task.TaskID || index} className="hover:bg-zinc-50 cursor-pointer" onClick={() => {
                                                            openTaskDetails(task.tskID, isTaskClosed, task);
                                                        }}>
                                                            {/* <TableCell
                                                                    className="w-[1vw] py-2 px-4 text-center align-top user-select-none cursor-pointer"
                                                                    style={{ userSelect: 'none' }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleCheckboxChange(task.tskID, !task.isChecked);
                                                                    }}
                                                                    onDoubleClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <div className="flex items-start justify-center user-select-none translate-y-0.5" style={{ userSelect: 'none' }}>
                                                                        <Checkbox
                                                                            checked={task.isChecked || false}
                                                                            onCheckedChange={(checked) => handleCheckboxChange(task.tskID, checked)}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            onDoubleClick={(e) => e.stopPropagation()}
                                                                            className="data-[state=checked]:bg-sahi-primary-color data-[state=checked]:border-sahi-primary-color data-[state=checked]:text-white transition-colors user-select-none"
                                                                            style={{ userSelect: 'none' }}
                                                                        />
                                                                    </div>
                                                                </TableCell> */}

                                                            <TableCell className="w-[30px] py-2 px-0 align-top" onClick={(e) => e.stopPropagation()}>
                                                                <div className="flex items-start justify-end translate-y-1">
                                                                    {(() => {
                                                                        const usrCID = getTaskCategoryIDForUser(task, currentUserID) || null;
                                                                        // Read-only: keep showing an already-assigned category even if deleted.
                                                                        const cat = usrCID ? myTaskCtgs.find(c => c.CID == usrCID) : null;
                                                                        if (!cat) return null;
                                                                        return (
                                                                            <TooltipProvider>
                                                                                <Tooltip>
                                                                                    <TooltipTrigger asChild>
                                                                                        <span className="w-2.5 h-2.5 rounded-full flex-shrink-0 cursor-pointer" style={{ backgroundColor: cat.Clr }} />
                                                                                    </TooltipTrigger>
                                                                                    <TooltipContent>
                                                                                        <p>{cat.CNm}</p>
                                                                                    </TooltipContent>
                                                                                </Tooltip>
                                                                            </TooltipProvider>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </TableCell>

                                                            <TableCell className="uniform-spacing pl-4 max-w-[300px]">
                                                                <div className="flex flex-col gap-1">
                                                                    <span className="text-text-color font-medium block break-words">
                                                                        <span>{getTaskTitleForUser(task, currentUserID) || 'Untitled Task'}</span>
                                                                        {task.pri == 'H' && (() => {
                                                                            const priority = getPriorityDetails('H');
                                                                            const IconComponent = priority.icon;
                                                                            return (
                                                                                <TooltipProvider>
                                                                                    <Tooltip>
                                                                                        <TooltipTrigger asChild>
                                                                                            <span className="inline-flex items-center justify-center cursor-pointer align-middle ml-1.5 shrink-0" style={{ color: priority.color }}>
                                                                                                <IconComponent className="h-4 w-4" strokeWidth={2.5} />
                                                                                            </span>
                                                                                        </TooltipTrigger>
                                                                                        <TooltipContent>
                                                                                            <p>Important</p>
                                                                                        </TooltipContent>
                                                                                    </Tooltip>
                                                                                </TooltipProvider>
                                                                            );
                                                                        })()}
                                                                    </span>
                                                                </div>
                                                            </TableCell>

                                                            {selectedFilters.connID == 'all' && hasContact && (
                                                                <TableCell className="uniform-spacing pl-4 max-w-[300px]">
                                                                    <div className="flex flex-col gap-1">
                                                                        <span className="text-text-color font-medium">
                                                                            {task.bizName?.trim() || task.contactName?.trim() || '-'}
                                                                        </span>
                                                                    </div>
                                                                </TableCell>
                                                            )}

                                                            {selectedFilters.taskType == 'all' && !allTypesSame && (
                                                                <TableCell className="uniform-spacing pl-4">
                                                                    <span className="text-text-color">
                                                                        {task.typ?.trim() || 'General'}
                                                                    </span>
                                                                </TableCell>
                                                            )}

                                                            <TableCell className="text-text-color uniform-spacing">
                                                                <div className="flex items-center gap-2">
                                                                    {task.sts === 2 || task.sts === 4 ? (
                                                                        <span className="pl-2 text-text-color">
                                                                            {(task.updatedDT || task.dueDT) ? getRelativeDateText(task.updatedDT || task.dueDT, false, true, false) : '-'}
                                                                        </span>
                                                                    ) : (
                                                                        <span className={`pl-2 ${isOverdue ? 'text-sahi-red' : getColorClass(getTaskColor(task.dueDT))}`}>
                                                                            {task.dueDT ? getRelativeDateText(task.dueDT, false, true, false).replace("11:59 PM", "by EOD") : 'Not set'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </TableCell>


                                                            {hasMobile &&
                                                                (<TableCell className="text-text-color uniform-spacing pl-4">
                                                                    {task?.mobile?.trim() ? task.mobile : '-'}
                                                                </TableCell>
                                                                )}

                                                            {shouldShowFromCol && (
                                                                <TableCell className="text-text-color uniform-spacing pl-4">
                                                                    <div className="flex items-center gap-1.5">
                                                                        {getExecutiveName(task.createdUserID, task)}
                                                                    </div>
                                                                </TableCell>
                                                            )}

                                                            {selectedFilters.executive == 'all' && selectedFilters.ownership != 'own' && (
                                                                <TableCell className="text-text-color uniform-spacing pl-4">
                                                                    <div className="flex items-center gap-3">
                                                                        {getExecutiveName(task.uID, task)}
                                                                    </div>
                                                                </TableCell>
                                                            )}

                                                            {!isInqOnlyMode && (
                                                                <TableCell className="uniform-spacing pl-4 max-w-[200px]">
                                                                    <span className="text-text-color">
                                                                        {task.threadNames?.trim() ? formatThreadDisplay(task) : '-'}
                                                                    </span>
                                                                </TableCell>
                                                            )}

                                                            {hasStatusNote && (
                                                                <TableCell className="uniform-spacing pl-4 max-w-[200px]">
                                                                    <span className="text-text-color truncate block" title={task.statusNote || ''}>
                                                                        {task.statusNote?.trim() || '-'}
                                                                    </span>
                                                                </TableCell>
                                                            )}

                                                            <TableCell className="uniform-spacing pr-4">
                                                                <div className="flex items-end justify-end gap-[2px] xl:gap-2.5">

                                                                    {/* Bell icon for tasks assigned to other users */}
                                                                    {!isTaskClosed && task.uID && !myUserIDs.includes(Number(task.uID)) && myUserIDs.includes(Number(task.createdUserID)) ? (
                                                                        <Tooltip>
                                                                            <TooltipTrigger asChild>
                                                                                <Button
                                                                                    variant="ghost"
                                                                                    size="sm"
                                                                                    className={`${actionButton} hover:bg-sahi-blue-light`}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleAction(task, "REMIND");
                                                                                    }}
                                                                                >
                                                                                    {isLoading == 'reminding' ? (
                                                                                        <div className={`h-3 w-3 ${loadingSpinner} border-sahi-blue border-t-transparent`} />
                                                                                    ) : (
                                                                                        <BsBellFill className="h-3 w-3 text-sahi-blue" />
                                                                                    )}
                                                                                </Button>
                                                                            </TooltipTrigger>
                                                                            <TooltipContent>
                                                                                <p>Remind<br />{getExecutiveName(task.uID)}</p>
                                                                            </TooltipContent>
                                                                        </Tooltip>
                                                                    ) : null}

                                                                    {/* Edit Action - Always available */}
                                                                    {canEditTask(task) && task.sts !== 2 && task.sts !== 4 && <Tooltip>
                                                                        <TooltipTrigger asChild>
                                                                            <Button
                                                                                variant="ghost"
                                                                                size="sm"
                                                                                className={`${actionButton} hover:bg-sahi-blue-light`}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    handleItemAction('EDIT', task, 'task', e)
                                                                                }}
                                                                            >
                                                                                <Pencil className="h-3 w-3 text-sahi-blue" />
                                                                            </Button>
                                                                        </TooltipTrigger>
                                                                        <TooltipContent>
                                                                            <p>Edit Task</p>
                                                                        </TooltipContent>
                                                                    </Tooltip>}

                                                                    {/* Approval Task (class === 4) actions for Assignee */}
                                                                    {tc === 4 && isMyAssignee && !isMyCreator && !isTaskClosed && (
                                                                        <>
                                                                            <Tooltip>
                                                                                <TooltipTrigger asChild>
                                                                                    <Button
                                                                                        variant="ghost"
                                                                                        size="sm"
                                                                                        className={`${actionButton} hover:bg-sahi-green-light`}
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            if (!isLoading) {
                                                                                                setCompletionDialogPrefill('Approved');
                                                                                                handleItemAction('COMPLETE', task, 'task', e);
                                                                                            }
                                                                                        }}
                                                                                        disabled={isLoading}
                                                                                    >
                                                                                        {isLoading === 'completing' ? (
                                                                                            <div className={`h-3 w-3 ${loadingSpinner} border-sahi-green border-t-transparent`} />
                                                                                        ) : (
                                                                                            <Check className="h-3 w-3 text-sahi-green" />
                                                                                        )}
                                                                                    </Button>
                                                                                </TooltipTrigger>
                                                                                <TooltipContent>
                                                                                    <p>Approve</p>
                                                                                </TooltipContent>
                                                                            </Tooltip>

                                                                            <Tooltip>
                                                                                <TooltipTrigger asChild>
                                                                                    <Button
                                                                                        variant="ghost"
                                                                                        size="sm"
                                                                                        className={`${actionButton} hover:bg-sahi-red-light`}
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            if (!isLoading) {
                                                                                                setCompletionDialogPrefill('Disapproved');
                                                                                                handleItemAction('COMPLETE', task, 'task', e);
                                                                                            }
                                                                                        }}
                                                                                        disabled={isLoading}
                                                                                    >
                                                                                        {isLoading === 'cancelling' ? (
                                                                                            <div className={`h-3 w-3 ${loadingSpinner} border-sahi-red border-t-transparent`} />
                                                                                        ) : (
                                                                                            <Ban className="h-3 w-3 text-sahi-red" />
                                                                                        )}
                                                                                    </Button>
                                                                                </TooltipTrigger>
                                                                                <TooltipContent>
                                                                                    <p>Disapprove</p>
                                                                                </TooltipContent>
                                                                            </Tooltip>
                                                                        </>
                                                                    )}

                                                                    {/* Standard Task Complete Action */}
                                                                    {task.sts == 1 && tc !== 4 && (isMyCreator || (isMyAssignee && task.canComplete == true)) && (
                                                                        <Tooltip>
                                                                            <TooltipTrigger asChild>
                                                                                <Button
                                                                                    variant="ghost"
                                                                                    size="sm"
                                                                                    className={`${actionButton} hover:bg-sahi-green-light`}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation()
                                                                                        if (!isLoading) {
                                                                                            handleItemAction('COMPLETE', task, 'task', e);
                                                                                        }
                                                                                    }}
                                                                                    disabled={isLoading}
                                                                                >
                                                                                    {isLoading == 'completing' ? (
                                                                                        <div className={`h-3 w-3 ${loadingSpinner} border-sahi-green border-t-transparent`} />
                                                                                    ) : (
                                                                                        <Check className="h-3 w-3 text-sahi-green" />
                                                                                    )}
                                                                                </Button>
                                                                            </TooltipTrigger>
                                                                            <TooltipContent>
                                                                                <p>Mark as complete</p>
                                                                            </TooltipContent>
                                                                        </Tooltip>
                                                                    )}

                                                                    {canCancel &&
                                                                        < Tooltip >
                                                                            <TooltipTrigger asChild>
                                                                                <Button
                                                                                    variant="ghost"
                                                                                    size="sm"
                                                                                    className={`${actionButton} hover:bg-sahi-red-light`}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation()
                                                                                        if (!isLoading) {
                                                                                            handleItemAction('CANCEL', task, 'task', e);
                                                                                        }
                                                                                    }}
                                                                                    disabled={isLoading}
                                                                                >
                                                                                    {isLoading == 'cancelling' ? (
                                                                                        <div className={`h-3 w-3 ${loadingSpinner} border-sahi-red border-t-transparent`} />
                                                                                    ) : (
                                                                                        <X className="h-3 w-3 text-sahi-red" />
                                                                                    )}
                                                                                </Button>
                                                                            </TooltipTrigger>
                                                                            <TooltipContent>
                                                                                <p>Cancel task</p>
                                                                            </TooltipContent>
                                                                        </Tooltip>}

                                                                    {/* Reject Action - Assignee or Observer declines standard task/meeting */}
                                                                    {!canCancel && tc !== 4 && (isMyAssignee || isMyObserver) && !isTaskClosed &&
                                                                        < Tooltip >
                                                                            <TooltipTrigger asChild>
                                                                                <Button
                                                                                    variant="ghost"
                                                                                    size="sm"
                                                                                    className={`${actionButton} hover:bg-sahi-red-light`}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation()
                                                                                        if (!isLoading) {
                                                                                            handleItemAction('CANCEL', task, 'task', e);
                                                                                        }
                                                                                    }}
                                                                                    disabled={isLoading}
                                                                                >
                                                                                    {isLoading == 'cancelling' ? (
                                                                                        <div className={`h-3 w-3 ${loadingSpinner} border-sahi-red border-t-transparent`} />
                                                                                    ) : (
                                                                                        <X className="h-3 w-3 text-sahi-red" />
                                                                                    )}
                                                                                </Button>
                                                                            </TooltipTrigger>
                                                                            <TooltipContent>
                                                                                <p>Reject task</p>
                                                                            </TooltipContent>
                                                                        </Tooltip>}

                                                                    {showReopenBtn &&
                                                                        <Tooltip>
                                                                            <TooltipTrigger asChild>
                                                                                <Button
                                                                                    variant="ghost"
                                                                                    size="sm"
                                                                                    className={`${actionButton} hover:bg-sahi-blue-light`}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation()
                                                                                        if (!isLoading) {
                                                                                            handleItemAction('REOPEN', task, 'task', e);
                                                                                        }
                                                                                    }}
                                                                                    disabled={isLoading}
                                                                                >
                                                                                    {isLoading == 'reopening' ? (
                                                                                        <div className={`h-3 w-3 ${loadingSpinner} border-sahi-dark-blue border-t-transparent`} />
                                                                                    ) : (
                                                                                        <RotateCcw className="h-3 w-3 text-sahi-dark-blue" />
                                                                                    )}
                                                                                </Button>
                                                                            </TooltipTrigger>
                                                                            <TooltipContent>
                                                                                <p>Reopen task</p>
                                                                            </TooltipContent>
                                                                        </Tooltip>}

                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={(size) => setRowsPerPage(size)}
                                    onPageChange={(page) => setCurrentPage(page)}
                                />
                            </>

                        ) : (
                            mobileView == 'list' ? (
                                <Tabs value={mobileTab} onValueChange={(val) => {
                                    if (val === 'calendar') {
                                        setCalendarDrawerOpen(true);
                                    }
                                    setMobileTab(val);
                                }} className="w-full space-y-3">
                                    {showMobileSearch && (
                                        <div className="w-full flex items-center gap-2">
                                            <div className="relative flex-grow">
                                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
                                                <Input
                                                    value={searchTerm}
                                                    placeholder="Search tasks"
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    className="pl-10 h-10 w-full"
                                                    autoFocus
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="flex flex-col gap-2 w-full">
                                        {/* Top box full width */}
                                        <div className="bg-white rounded-[10px] p-[10px] w-full border border-zinc-200/80 flex flex-col justify-center hidden">
                                            <h2 className="text-zinc-500 text-xs font-medium">Hi, {authData?.UserName?.split(' ')[0] || 'User'}! You have</h2>
                                            <h1 className="text-gray-900 text-[16px] font-semibold">{mobileTaskGroups.due.length === 0 ? '0' : mobileTaskGroups.due.length} Tasks today</h1>
                                        </div>

                                        {new URLSearchParams(location.search).get('o') !== '1' && (
                                            <div
                                                className="grid gap-1.5 w-full"
                                                style={{
                                                    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))'
                                                }}
                                            >
                                                {(mobileTab === 'history' ? [
                                                    { id: 'important', label: 'Important', count: mobileTaskGroups.historyStats.important, color: 'var(--sahi-orange)', lightColor: 'var(--sahi-orange-light)' },
                                                    { id: 'due', label: 'Completed', count: mobileTaskGroups.historyStats.due, color: 'var(--sahi-red)', lightColor: 'var(--sahi-red-light)' },
                                                    { id: 'upcoming', label: 'Cancelled', count: mobileTaskGroups.historyStats.upcoming, color: 'var(--sahi-green)', lightColor: 'var(--sahi-green-light)' },
                                                    { id: 'all', label: 'All', count: mobileTaskGroups.historyStats.all, color: 'var(--sahi-blue)', lightColor: 'var(--sahi-blue-light)' }
                                                ] : [
                                                    { id: 'important', label: 'Important', count: mobileTaskGroups.important.length, color: 'var(--sahi-orange)', lightColor: 'var(--sahi-orange-light)' },
                                                    { id: 'due', label: isTodayMobileSelected ? 'Today' : isTmrwMobileSelected ? 'Tmrw' : format(new Date(selectedMobileDate), 'dd-MMM'), count: mobileTaskGroups.due.length, color: 'var(--sahi-red)', lightColor: 'var(--sahi-red-light)' },
                                                    { id: 'upcoming', label: 'Next 7 Days', count: mobileTaskGroups.upcoming.length, color: 'var(--sahi-green)', lightColor: 'var(--sahi-green-light)' },
                                                    { id: 'all', label: 'All', count: mobileTaskGroups.all.length, color: 'var(--sahi-blue)', lightColor: 'var(--sahi-blue-light)' }
                                                ]).map((box) => {
                                                    const isActive = mobileTab === 'history'
                                                        ? (box.id === 'important' ? selectedFilters.priority === 'H'
                                                            : box.id === 'due' ? selectedFilters.status === '2'
                                                                : box.id === 'upcoming' ? selectedFilters.status === '4'
                                                                    : box.id === 'all' ? (selectedFilters.status !== '2' && selectedFilters.status !== '4' && selectedFilters.priority !== 'H')
                                                                        : false)
                                                        : mobileTab === box.id;
                                                    const handleBoxClick = () => {
                                                        if (mobileTab !== 'history') {
                                                            if (box.id === 'due' && mobileTab === 'due') {
                                                                setCalendarDrawerOpen(true);
                                                            } else {
                                                                if (mobileTab !== box.id) {
                                                                    triggerHaptic("selection");
                                                                }
                                                                setMobileTab(box.id);
                                                            }
                                                            return;
                                                        }
                                                        triggerHaptic("selection");
                                                        if (box.id === 'important') {
                                                            setSelectedFilters((prev) => ({ ...prev, priority: prev.priority === 'H' ? 'all' : 'H', status: 'all' }));
                                                        } else if (box.id === 'due') {
                                                            setSelectedFilters((prev) => ({ ...prev, status: prev.status === '2' ? 'all' : '2', priority: 'all' }));
                                                        } else if (box.id === 'upcoming') {
                                                            setSelectedFilters((prev) => ({ ...prev, status: prev.status === '4' ? 'all' : '4', priority: 'all' }));
                                                        } else if (box.id === 'all') {
                                                            setSelectedFilters((prev) => ({ ...prev, status: 'all', priority: 'all' }));
                                                        }
                                                    };
                                                    return (
                                                        <button
                                                            key={box.id}
                                                            type="button"
                                                            onClick={handleBoxClick}
                                                            className={cn(
                                                                "flex flex-col items-start justify-start gap-[10px] rounded-[7px] border bg-white text-left w-full transition-all duration-200 active:scale-95",
                                                                mobileTab === 'history' ? "p-[10px]" : "p-[6px] min-[360px]:p-[8px] min-[390px]:p-[10px]",
                                                                isActive ? 'text-[var(--sahi-green)] pb-[5px]' : 'text-[#333333] pb-[7px]'
                                                            )}
                                                            style={{
                                                                borderTop: '1px solid var(--zinc-200, #e4e4e7)',
                                                                borderLeft: '1px solid var(--zinc-200, #e4e4e7)',
                                                                borderRight: '1px solid var(--zinc-200, #e4e4e7)',
                                                                borderBottom: isActive ? '3px solid var(--sahi-green)' : '1px solid var(--zinc-200, #e4e4e7)',
                                                                backgroundColor: '#ffffff'
                                                            }}
                                                        >
                                                            <span className="text-[11px] leading-tight font-semibold tracking-tight w-full text-left">
                                                                {box.id === 'important' && box.label === 'Important' ? (<><span className="hidden min-[370px]:inline">Important</span><span className="inline min-[370px]:hidden">Imp</span></>) : box.id === 'upcoming' && box.label === 'Next 7 Days' ? (
                                                                    <>
                                                                        <span className="hidden min-[370px]:inline">Next 7 Days</span>
                                                                        <span className="inline min-[370px]:hidden">Next 7D</span>
                                                                    </>
                                                                ) : (
                                                                    box.id === 'due' ? (
                                                                        <span className="flex items-start justify-between w-full">
                                                                            <span>{box.label}</span>
                                                                            {mobileTab === 'history' ? null : (<Calendar className="h-3 w-3 text-zinc-500 shrink-0 ml-1" />)}
                                                                        </span>
                                                                    ) : box.label
                                                                )}
                                                            </span>
                                                            <span className="text-[18px] font-extrabold text-left leading-normal">
                                                                {box.count === 0 ? '0' : box.count}
                                                            </span>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>

                                    {/* Welcome Onboarding Banner */}
                                    {isMobile && new URLSearchParams(location.search).get('o') === '1' && (
                                        <div className="p-4.5 mb-3.5 relative shadow-xs animate-fade-in-up">
                                            <style>{`
                                                @keyframes fadeInUp {
                                                    from {
                                                        opacity: 0;
                                                        transform: translateY(8px);
                                                    }
                                                    to {
                                                        opacity: 1;
                                                        transform: translateY(0);
                                                    }
                                                }
                                                .animate-fade-in-up {
                                                    animation: fadeInUp 350ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
                                                }
                                            `}</style>

                                            {/* <div className="flex flex-col gap-2 w-full pb-3 mb-3 px-4 pt-2">
                                                <div className="flex gap-2 w-full">
                                                    <div className="h-1.5 flex-1 rounded-full bg-sahi-primary-color" />
                                                    <div className="h-1.5 flex-1 rounded-full bg-sahi-primary-color" />
                                                    <div className="h-1.5 flex-1 rounded-full bg-sahi-primary-color" />
                                                </div>
                                            </div> */}

                                            <div className="space-y-1 text-left px-4 pb-2">
                                                <span className="text-[11px] font-bold text-sahi-primary-color tracking-wider uppercase">Step 4 of 4</span>
                                                <h2 className="text-2xl font-bold text-zinc-800 mt-0.5 leading-tight">
                                                    Plan your Day
                                                </h2>
                                                <p className="text-sm text-zinc-500 mt-1.5 leading-relaxed max-w-[340px]">
                                                    List & Categorize your tasks. You can later add Users from Settings and delegate tasks to your Team.
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    {[
                                        { key: 'all', label: 'All Tasks' },
                                        { key: 'important', label: 'Important' },
                                        { key: 'due', label: 'Today' },
                                        { key: 'upcoming', label: 'Next 7 Days' },
                                        { key: 'overdue', label: 'Overdue' },
                                        { key: 'today', label: 'Today' },
                                        { key: 'tmrw', label: 'Tomorrow' },
                                        { key: 'future', label: 'Future' },
                                        { key: 'calendar', label: selectedMobileDate ? `Tasks for ${formatMobileDateTabLabel(selectedMobileDate)}` : 'Select Date' },
                                        { key: 'history', label: 'Completed' }
                                    ].map(({ key, label }) => (
                                        <TabsContent key={key} value={key} className="mt-0 space-y-2">
                                            {(() => {
                                                const groupTasks = mobileTaskGroups[key] || [];
                                                if (groupTasks.length === 0) {
                                                    const showQuickAddForEmpty = ['due', 'today', 'tmrw', 'calendar'].includes(key) && !isPastMobileDate;
                                                    const hasFilters = hasActiveFilters && tasksData.length > 0;
                                                    return (
                                                        <div className={showQuickAddForEmpty ? 'pt-0 pb-4' : hasFilters ? 'pt-2' : 'flex flex-col h-[calc(100vh-266px)] justify-center'}>
                                                            {hasFilters ? (
                                                                <div>
                                                                    <p className="no-records border border-zinc-200 shadow-sm sahi-radius text-left p-4">
                                                                        <span>No tasks found for selected filters.</span>
                                                                        <span
                                                                            onClick={handleResetFilters}
                                                                            className="text-sahi-primary-color underline hover:text-sahi-primary-color/80 cursor-pointer ml-2"
                                                                        >
                                                                            Clear filter.
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {!showQuickAddForEmpty ? (
                                                                        <div className="text-center items-center flex flex-col justify-center flex-1">
                                                                            <div className="w-14 h-14 rounded-full mx-auto mb-3 flex items-center justify-center bg-white shadow-sm">
                                                                                <CheckCircle className="text-sahi-green" size={28} />
                                                                            </div>
                                                                            <h4 className={`font-semibold ${isMobile ? 'text-md' : 'text-lg'} text-text-color`}>
                                                                                {"All caught up!"}
                                                                            </h4>
                                                                            <p className="text-sm text-sahi-grey mt-1">
                                                                                {key === 'all' && "No tasks found."}
                                                                                {key === 'overdue' && "No overdue tasks."}
                                                                                {key === 'today' && "No tasks for today."}
                                                                                {key === 'tmrw' && "No tasks for tomorrow."}
                                                                                {key === 'future' && "No future tasks."}
                                                                                {key === 'calendar' && "No tasks for this day."}
                                                                                {key === 'due' && "No pending tasks."}
                                                                                {key === 'history' && "No completed tasks."}
                                                                            </p>
                                                                            <Button
                                                                                onClick={handleTaskEntryOpen}
                                                                                className="mt-6"
                                                                            >
                                                                                <Plus className="h-4 w-4" />
                                                                                Add Task
                                                                            </Button>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="mt-1">
                                                                            <QuickAddTaskCard
                                                                                onAdd={handleQuickAddTask}
                                                                                isAdding={isQuickAdding}
                                                                                myTaskCtgs={myTaskCtgs}
                                                                                defaultDate={selectedMobileDate || new Date()}
                                                                                hasCompletedTasksToday={key === 'due' && isTodayMobileSelected && todayClosedTasksFiltered.length > 0}
                                                                            />
                                                                            {isMobile && searchParams.get('o') === '1' && tasksData.length > 0 && (
                                                                                <div className="pt-3 pb-2 flex flex-col gap-2.5 w-full">
                                                                                    <Button
                                                                                        type="button"
                                                                                        className="w-full bg-sahi-primary-color hover:bg-sahi-primary-color/90 text-white font-medium py-2.5 h-10 shadow-xs"
                                                                                        onClick={() => setDialogStates(prev => ({ ...prev, userEntry: true }))}
                                                                                    >
                                                                                        Invite your Team
                                                                                    </Button>
                                                                                    <Button
                                                                                        type="button"
                                                                                        variant="outline"
                                                                                        className="w-full border-zinc-200 text-zinc-800 hover:bg-zinc-50 font-medium py-2.5 h-10 shadow-xs"
                                                                                        onClick={() => navigate('/web')}
                                                                                    >
                                                                                        Go to Dashboard
                                                                                    </Button>
                                                                                </div>
                                                                            )}
                                                                            {key === 'calendar' && <div className="h-16 w-full" />}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    );
                                                }

                                                let content = null;
                                                if (viewMode === "category") {
                                                    content = groupMobileTasksByCategory(groupTasks).map((group) => {
                                                        const groupKey = `${key}-category-${group.CID}`;
                                                        const isCollapsed = !!collapsedGroups[groupKey];
                                                        return (
                                                            <div key={group.CID} className="space-y-2">
                                                                <div
                                                                    onClick={() => {
                                                                        setCollapsedGroups(prev => ({ ...prev, [groupKey]: !prev[groupKey] }));
                                                                    }}
                                                                    className="flex items-center justify-between py-1.5 px-2 mt-3 first:mt-0 cursor-pointer select-none active:bg-zinc-100 rounded-md transition-colors"
                                                                >
                                                                    <div className="flex items-center gap-2">
                                                                        <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: group.Clr }} />
                                                                        <span className="text-[14px] font-bold text-zinc-600">{group.CNm} ({group.tasks.length})</span>
                                                                    </div>
                                                                    <ChevronDown
                                                                        className={cn(
                                                                            "h-4 w-4 text-zinc-500 shrink-0 transition-transform duration-200",
                                                                            !isCollapsed && "rotate-180"
                                                                        )}
                                                                    />
                                                                </div>
                                                                {!isCollapsed && group.tasks.map((task, index) => (
                                                                    <SwipeableTaskCard
                                                                        key={task.TaskID || index}
                                                                        task={task}
                                                                        index={index}
                                                                        range={key}
                                                                        length={group.tasks.length}
                                                                        currentUserID={currentUserID}
                                                                        currentUser={currentUser}
                                                                        connectionData={connectionData}
                                                                        taskActionLoading={taskActionLoading}
                                                                        myTaskCtgs={myTaskCtgs}
                                                                        getExecutiveName={getExecutiveName}
                                                                        handleAction={handleAction}
                                                                        handleItemAction={handleItemAction}
                                                                        setTemplateDialogData={setTemplateDialogData}
                                                                        setTemplateDialogOpen={setTemplateDialogOpen}
                                                                        formatThreadDisplay={formatThreadDisplay}
                                                                        openTaskDetails={openTaskDetails}
                                                                        showTimeAlways={key === 'due' ? (!isTodayMobileSelected && !isTmrwMobileSelected) : false}
                                                                    />
                                                                ))}
                                                            </div>
                                                        );
                                                    });
                                                } else if (viewMode === "class") {
                                                    content = groupMobileTasksByClass(groupTasks).map((group) => {
                                                        const groupKey = `${key}-class-${group.CLID}`;
                                                        const isCollapsed = !!collapsedGroups[groupKey];
                                                        const iconMap = {
                                                            SquareCheckBig,
                                                            Calendar,
                                                            GitFork,
                                                            ShieldCheck
                                                        };
                                                        const ClassIcon = iconMap[group.IconName] || SquareCheckBig;
                                                        return (
                                                            <div key={group.CLID} className="space-y-2">
                                                                <div
                                                                    onClick={() => {
                                                                        setCollapsedGroups(prev => ({ ...prev, [groupKey]: !prev[groupKey] }));
                                                                    }}
                                                                    className="flex items-center justify-between py-1.5 px-2 mt-3 first:mt-0 cursor-pointer select-none active:bg-zinc-100 rounded-md transition-colors"
                                                                >
                                                                    <div className="flex items-center gap-2">
                                                                        <ClassIcon className="h-4 w-4 shrink-0" style={{ color: 'var(--sahi-green)' }} />
                                                                        <span className="text-[14px] font-bold text-zinc-600">{group.CLNm} ({group.tasks.length})</span>
                                                                    </div>
                                                                    <ChevronDown
                                                                        className={cn(
                                                                            "h-4 w-4 text-zinc-500 shrink-0 transition-transform duration-200",
                                                                            !isCollapsed && "rotate-180"
                                                                        )}
                                                                    />
                                                                </div>
                                                                {!isCollapsed && group.tasks.map((task, index) => (
                                                                    <SwipeableTaskCard
                                                                        key={task.TaskID || index}
                                                                        task={task}
                                                                        index={index}
                                                                        range={key}
                                                                        length={group.tasks.length}
                                                                        currentUserID={currentUserID}
                                                                        currentUser={currentUser}
                                                                        connectionData={connectionData}
                                                                        taskActionLoading={taskActionLoading}
                                                                        myTaskCtgs={myTaskCtgs}
                                                                        getExecutiveName={getExecutiveName}
                                                                        handleAction={handleAction}
                                                                        handleItemAction={handleItemAction}
                                                                        setTemplateDialogData={setTemplateDialogData}
                                                                        setTemplateDialogOpen={setTemplateDialogOpen}
                                                                        formatThreadDisplay={formatThreadDisplay}
                                                                        openTaskDetails={openTaskDetails}
                                                                        showTimeAlways={key === 'due' ? (!isTodayMobileSelected && !isTmrwMobileSelected) : false}
                                                                    />
                                                                ))}
                                                            </div>
                                                        );
                                                    });
                                                } else {
                                                    content = groupTasks.map((task, index) => (
                                                        <SwipeableTaskCard
                                                            key={task.TaskID || index}
                                                            task={task}
                                                            index={index}
                                                            range={key}
                                                            length={groupTasks.length}
                                                            currentUserID={currentUserID}
                                                            currentUser={currentUser}
                                                            connectionData={connectionData}
                                                            taskActionLoading={taskActionLoading}
                                                            myTaskCtgs={myTaskCtgs}
                                                            getExecutiveName={getExecutiveName}
                                                            handleAction={handleAction}
                                                            handleItemAction={handleItemAction}
                                                            setTemplateDialogData={setTemplateDialogData}
                                                            setTemplateDialogOpen={setTemplateDialogOpen}
                                                            formatThreadDisplay={formatThreadDisplay}
                                                            openTaskDetails={openTaskDetails}
                                                            showTimeAlways={key === 'due' ? (!isTodayMobileSelected && !isTmrwMobileSelected) : false}
                                                        />
                                                    ));
                                                }

                                                return (
                                                    <>
                                                        {content}
                                                        {['due', 'today', 'tmrw', 'calendar'].includes(key) && !isPastMobileDate && (
                                                            <>
                                                                <QuickAddTaskCard
                                                                    onAdd={handleQuickAddTask}
                                                                    isAdding={isQuickAdding}
                                                                    myTaskCtgs={myTaskCtgs}
                                                                    defaultDate={selectedMobileDate || new Date()}
                                                                    hasCompletedTasksToday={key === 'due' && isTodayMobileSelected && todayClosedTasksFiltered.length > 0}
                                                                />
                                                                {isMobile && searchParams.get('o') === '1' && tasksData.length > 0 && (
                                                                    <div className="pt-3 pb-16 flex flex-col gap-2.5 w-full">
                                                                        <Button
                                                                            type="button"
                                                                            className="w-full bg-sahi-primary-color hover:bg-sahi-primary-color/90 text-white font-medium py-2.5 h-10 shadow-xs"
                                                                            onClick={() => setDialogStates(prev => ({ ...prev, userEntry: true }))}
                                                                        >
                                                                            Invite your Team
                                                                        </Button>
                                                                        <Button
                                                                            type="button"
                                                                            variant="outline"
                                                                            className="w-full border-zinc-300 bg-white text-zinc-800 hover:bg-zinc-50 font-medium py-2.5 h-10 shadow-xs"
                                                                            onClick={() => navigate('/web')}
                                                                        >
                                                                            Go to Dashboard
                                                                        </Button>
                                                                    </div>
                                                                )}
                                                                {key === 'calendar' && <div className="h-16 w-full" />}
                                                            </>
                                                        )}
                                                    </>
                                                );
                                            })()}

                                            {key === 'due' && isTodayMobileSelected && todayClosedTasksFiltered.length > 0 && (
                                                <div>
                                                    <div className="flex items-center gap-3 py-2 pb-3">
                                                        <div className="flex-1 h-px bg-zinc-200" />
                                                        <span className="text-xs font-medium text-sahi-grey whitespace-nowrap">
                                                            {todayClosedTasksFiltered.length} {todayClosedTasksFiltered.length === 1 ? 'Task' : 'Tasks'} closed today
                                                        </span>
                                                        <div className="flex-1 h-px bg-zinc-200" />
                                                    </div>
                                                    <div className="space-y-2">
                                                        {todayClosedTasksFiltered.map((task, index) => (
                                                            <SwipeableTaskCard
                                                                key={task.TaskID || index}
                                                                task={task}
                                                                index={index}
                                                                range="history"
                                                                length={todayClosedTasksFiltered.length}
                                                                currentUserID={currentUserID}
                                                                currentUser={currentUser}
                                                                connectionData={connectionData}
                                                                taskActionLoading={taskActionLoading}
                                                                myTaskCtgs={myTaskCtgs}
                                                                getExecutiveName={getExecutiveName}
                                                                handleAction={handleAction}
                                                                handleItemAction={handleItemAction}
                                                                setTemplateDialogData={setTemplateDialogData}
                                                                setTemplateDialogOpen={setTemplateDialogOpen}
                                                                formatThreadDisplay={formatThreadDisplay}
                                                                openTaskDetails={openTaskDetails}
                                                            />
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </TabsContent>
                                    ))}
                                </Tabs>
                            ) : (
                                <div className="flex flex-col -mx-4 -mt-3 -mb-24 h-[calc(100dvh-134px)] relative overflow-hidden overscroll-none">
                                    <style>{`
                                        .no-scrollbar::-webkit-scrollbar { display: none; }
                                        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                                    `}</style>

                                    {/* Scrollable Date Picker */}
                                    <div className="shrink-0 bg-white shadow-[0_2px_6px_rgba(15,23,42,0.06)]">
                                        <div className="relative">
                                            <div className="pointer-events-none absolute left-0 inset-y-0 w-6 bg-gradient-to-r from-white to-transparent z-10" />
                                            <div className="pointer-events-none absolute right-0 inset-y-0 w-6 bg-gradient-to-l from-white to-transparent z-10" />
                                            <div
                                                ref={dateScrollRef}
                                                className="flex gap-2 overflow-x-auto no-scrollbar px-4 py-3 snap-x snap-mandatory scroll-smooth touch-pan-x overscroll-x-contain select-none"
                                            >
                                                {scheduleDates.map((date, i) => {
                                                    const isSelected = format(date, 'yyyy-MM-dd') == format(selectedScheduleDate, 'yyyy-MM-dd');
                                                    const isTodayDate = format(date, 'yyyy-MM-dd') == format(now, 'yyyy-MM-dd');
                                                    return (
                                                        <button
                                                            key={i}
                                                            data-today={isTodayDate}
                                                            onClick={() => setSelectedScheduleDate(date)}
                                                            className={cn(
                                                                "flex flex-col items-center justify-center shrink-0 w-12 py-2 rounded-xl transition-all duration-200 ease-out snap-center",
                                                                isSelected
                                                                    ? "bg-sahi-primary-color text-white shadow-md shadow-sahi-primary-color/30"
                                                                    : "bg-zinc-100/70 text-zinc-500 active:scale-95"
                                                            )}
                                                        >
                                                            <span className="text-[9px] font-bold uppercase tracking-wide opacity-80">{format(date, 'EEE')}</span>
                                                            <span className="text-[15px] font-bold leading-tight">{format(date, 'd')}</span>
                                                            {isTodayDate && !isSelected && <div className="w-1 h-1 bg-sahi-primary-color rounded-full mt-0.5" />}
                                                            {isTodayDate && isSelected && <div className="w-1 h-1 bg-white rounded-full mt-0.5" />}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Timeline UI */}
                                    <div ref={timelineScrollRef} className="flex-1 min-h-0 overflow-y-auto relative px-4 pt-4 pb-24 scroll-smooth touch-pan-y overscroll-y-contain">
                                        <div
                                            ref={taskPullIndicatorRef}
                                            className="absolute left-0 right-0 flex justify-center pointer-events-none z-10"
                                            style={{ top: -56, transform: "translateY(0px)", opacity: 0, willChange: "transform, opacity" }}
                                        >
                                            <div className="mt-2 bg-sahi-white shadow-md rounded-full p-2 flex items-center justify-center">
                                                <RotateCcw ref={taskPullIconRef} className={`h-5 w-5 text-sahi-primary-color ${isTaskPullRefreshing ? 'animate-spin' : ''}`} />
                                            </div>
                                        </div>

                                        {(() => {
                                            const groupedTasks = getScheduleTasksForDate(selectedScheduleDate);
                                            return hourLabels.map((label, idx) => {
                                                const tasksInSlot = groupedTasks[label] || [];
                                                const { minute } = parseSlotLabel(label);
                                                const isHourMark = minute == 0;
                                                const isPast = false; //isSlotInPast(label);
                                                const isCurrentSlot = label == currentSlotLabel;
                                                const isCurrent = isToday && isCurrentSlot;
                                                const isOver = dragOverHour == label;

                                                return (
                                                    <div
                                                        key={label}
                                                        data-current-hour={isCurrentSlot}
                                                        className={cn("flex gap-6 relative min-h-[45px]")}
                                                    >
                                                        {/* Time Label */}
                                                        <div className="w-10 text-right pt-2 shrink-0 select-none">
                                                            {isHourMark ? (
                                                                <>
                                                                    <span className={cn(
                                                                        "text-[10px] font-semibold uppercase tabular-nums",
                                                                        isCurrent ? "text-sahi-primary-color" : isPast ? "text-zinc-600" : "text-zinc-600"
                                                                    )}>
                                                                        {label.split(':')[0]} {label.split(' ')[1]}
                                                                    </span>
                                                                    {/* <span className={cn(
                                                                        "text-[8px] block -mt-1",
                                                                        isCurrent ? "text-sahi-primary-color" : isPast ? "text-zinc-600" : "text-zinc-600"
                                                                    )}>
                                                                        {label.split(' ')[1]}
                                                                    </span> */}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <span className={cn(
                                                                        "text-[9px] font-semibold uppercase tabular-nums opacity-80",
                                                                        isCurrent ? "text-sahi-primary-color" : isPast ? "text-zinc-600" : "text-zinc-600"
                                                                    )}>
                                                                        {label.split(' ')[0]}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>

                                                        {/* Grid Cell / Drop Target */}
                                                        <div
                                                            data-hour-slot={label}
                                                            className={cn(
                                                                "flex-1 relative p-2 rounded-xl transition-colors duration-150 -mx-2 px-2 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-sahi-primary-color/30",
                                                                isPast && "opacity-40",
                                                                isOver && "bg-sahi-primary-color/[0.06] ring-1 ring-inset ring-zinc-300",
                                                                isCurrent && !isOver && "bg-sahi-primary-color/[0.04]"
                                                            )}
                                                        >
                                                            {/* Connector Dot */}
                                                            <div className={cn(
                                                                "absolute -left-[10px] top-[15px] w-[12px] h-[12px] rounded-full border-2 border-white z-10",
                                                                isCurrent ? "bg-sahi-primary-color animate-pulse" : isPast ? "bg-zinc-200" : "bg-zinc-300"
                                                            )} />

                                                            {/* "Now" line, positioned by progress through this slot */}
                                                            {isCurrent && (
                                                                <div
                                                                    className="absolute left-0 right-0 z-20 flex items-center pointer-events-none"
                                                                    style={{ top: `${currentSlotProgress * 100}%` }}
                                                                >
                                                                    <span className="w-[12px] h-[12px] rounded-full border-2 border-white  bg-sahi-red -ml-[10px] shadow-sm" />
                                                                    <span className="flex-1 h-[1.5px] bg-sahi-red" />
                                                                </div>
                                                            )}

                                                            <div className="space-y-1.5">
                                                                {tasksInSlot.length > 0 ? (
                                                                    tasksInSlot.map((task) => (
                                                                        <div
                                                                            key={task.tskID}
                                                                            onPointerDown={(e) => handleTaskPointerDown(e, task)}
                                                                            onPointerMove={handleTaskPointerMove}
                                                                            onPointerUp={handleTaskPointerUp}
                                                                            onPointerCancel={handleTaskPointerUp}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                if (justDraggedRef.current) { justDraggedRef.current = false; return; }
                                                                                openTaskDetails(task.tskID, task.sts === 2 || task.sts === 4, task);
                                                                            }}
                                                                            style={{
                                                                                touchAction: 'pan-y',
                                                                                opacity: draggingTask?.tskID == task.tskID ? 0.3 : 1,
                                                                                borderLeftColor: getTaskColor(task.dueDT) == 'red' ? '#ef4444' : '#0B5D1E'
                                                                            }}
                                                                            className="bg-white p-2.5 rounded-xl border border-zinc-100 shadow-sm transition-transform duration-150 border-l-4 cursor-grab select-none"
                                                                        >
                                                                            <div className="flex justify-between items-center mb-0.5">
                                                                                <span className="text-[11px] font-semibold opacity-60">{format(new Date(task.dueDT), 'h:mm a')}</span>
                                                                                <div className="scale-90 origin-right">{getTaskClassIcon(task.class || task.Class || task.taskClass || task.TaskClass)}</div>
                                                                            </div>
                                                                            <h4 className="text-[13px] font-semibold text-zinc-800 line-clamp-1 tracking-0">{task.ttl}</h4>
                                                                            <p className="text-[11px] text-sahi-primary-color font-medium truncate mt-0.5">
                                                                                {task.bizName || task.contactName}
                                                                            </p>
                                                                        </div>
                                                                    ))
                                                                ) : !isPast ? (
                                                                    <div
                                                                        onClick={() => handleEmptySlotClick(label)}
                                                                        className={cn(
                                                                            "w-full border-2 bg-white/20 border-dotted h-10 rounded-lg flex items-center justify-center transition-colors border-zinc-200",
                                                                            !isPast && "cursor-pointer hover:border-sahi-primary-color hover:bg-sahi-primary-color/5"
                                                                        )}
                                                                    >
                                                                        {/* <Plus className={cn("h-3 w-3", isOver ? "text-sahi-primary-color" : "text-zinc-200")} /> */}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            });
                                        })()}
                                    </div>

                                    {/* Floating drag preview, follows the pointer */}
                                    {draggingTask && dragPointer && (
                                        <div
                                            className={cn(
                                                "fixed z-50 pointer-events-none px-3 py-2 rounded-xl bg-white shadow-2xl border-2 transition-colors",
                                                dragOverInvalid ? "border-sahi-red" : "border-sahi-primary-color"
                                            )}
                                            style={{
                                                left: dragPointer.x - 90,
                                                top: dragPointer.y - 34,
                                                width: 180,
                                                transform: 'rotate(-2deg) scale(1.03)'
                                            }}
                                        >
                                            <p className="text-[12px] font-semibold text-zinc-800 line-clamp-1">{draggingTask.ttl}</p>
                                            <p className={cn("text-[10px] mt-0.5 font-medium", dragOverInvalid ? "text-sahi-red" : "text-sahi-primary-color")}>
                                                {dragOverInvalid ? "Can't schedule a task in the past" : dragOverHour ? `Move to ${dragOverHour}` : 'Drag to a time slot'}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            )
                        )}

                    </>
                ) : (
                    <div className="flex flex-col items-start gap-5">
                        {isMobile && tasksData.length > 0 && (
                            <div className="w-full flex items-center gap-2">
                                <div className="relative flex-grow">
                                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
                                    <Input
                                        value={searchTerm}
                                        placeholder="Search tasks"
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="pl-10 h-10 w-full"
                                    />
                                </div>
                                <FilterButton />
                            </div>
                        )}
                        <p className="no-records border border-zinc-200 shadow-sm sahi-radius">
                            <span>
                                No tasks found{hasActiveFilters && tasksData.length > 0 ? ' for selected filters.' : '.'}
                            </span>
                            {hasActiveFilters && tasksData.length > 0 && (
                                <span
                                    onClick={handleResetFilters}
                                    className="text-sahi-primary-color underline hover:text-sahi-primary-color/80 cursor-pointer ml-2"
                                >
                                    Clear filter.
                                </span>
                            )}
                        </p>
                        <Button
                            onClick={handleTaskEntryOpen}
                            className={`button-config ${isMobile ? '' : 'text-base'} sahi-primary-button flex items-center py-[6px] px-2`}
                        >
                            <Plus className="h-4 w-4" />
                            Add Task
                        </Button>
                    </div>
                )}


                {/* Complete Warning - assignee hasn't marked done */}
                {/* <AlertBox
                    open={dialogStates.confirmCompleteWarning}
                    onOpenChange={(open) => setDialogStates(prev => ({ ...prev, confirmCompleteWarning: open }))}
                    title="Complete Task"
                    content={
                        <div>
                            <p className="my-2"><span className="font-bold text-md">{selectedTaskForRecord?.ttl}</span></p>
                            <p className="mt-2 mb-1 text-text-color text-sm">The assignee has not yet marked this task as done. Do you still wish to complete it?</p>
                        </div>
                    }
                    className="md:w-[400px]"
                    actions={[
                        { label: "No", value: 'no', variant: 'cancel', icon: <X className="h-4 w-4" /> },
                        { label: "Yes, Complete", value: 'yes', icon: <Check className="h-4 w-4" /> }
                    ]}
                    onAction={(val) => {
                        if (val == 'yes') {
                            setDialogStates(prev => ({ ...prev, confirmCompleteWarning: false }));
                            // No contact linked - nothing extra to ask (e.g. adding a record), so complete right away
                            // instead of showing a second, effectively duplicate "Complete this task?" prompt.
                            if (selectedTaskForRecord?.connID == 0) {
                                handleAction(selectedTaskForRecord, 'DONE');
                            } else {
                                setDialogStates(prev => ({ ...prev, confirmCompleteAlert: true }));
                            }
                        } else {
                            setSelectedTaskForRecord(null);
                        }
                    }}
                /> */}

                {/* Task Complete Alert */}
                <TaskCompleteDialog
                    open={dialogStates.confirmCompleteAlert}
                    onOpenChange={(open) => {
                        setDialogStates(prev => ({ ...prev, confirmCompleteAlert: open }));
                        if (!open) setCompletionDialogPrefill("");
                    }}
                    task={selectedTaskForRecord}
                    initialStatusNote={completionDialogPrefill}
                    forceShowNoteField={completionDialogPrefill !== ""}
                    shareByWhatsApp={shareActionByWhatsApp}
                    onWhatsAppShareChange={setShareActionByWhatsApp}
                    onAction={(actionValue, repeat, statusNote) => {
                        if (actionValue === "complete") {
                            handleAction(selectedTaskForRecord, 'DONE', repeat, statusNote);
                        } else if (actionValue === "record") {
                            pendingRepeatAfterRecordRef.current = repeat;
                            pendingStatusNoteAfterRecordRef.current = statusNote;
                            handleItemAction('RECORD_AND_COMPLETE', selectedTaskForRecord, 'task');
                        } else {
                            setSelectedTaskForRecord(null);
                        }
                    }}
                />

                {/* Task Cancel/Reject Alert */}
                <TaskCompleteDialog
                    mode={(() => {
                        if (!selectedTaskForRecord) return "cancel";
                        const myUserIDs = getMyAgenciesMappedIDs('UserID');
                        const isMyCreator = myUserIDs.includes(Number(selectedTaskForRecord.createdUserID)) || Number(selectedTaskForRecord.createdUserID) === currentUserID;
                        const isMyAssignee = myUserIDs.includes(Number(selectedTaskForRecord.uID)) || Number(selectedTaskForRecord.uID) === currentUserID;
                        const obsArr = selectedTaskForRecord.observerUserIDs ? (Array.isArray(selectedTaskForRecord.observerUserIDs) ? selectedTaskForRecord.observerUserIDs : String(selectedTaskForRecord.observerUserIDs).split(',').map(Number).filter(Boolean)) : [];
                        const isMyObserver = obsArr.some(id => myUserIDs.includes(Number(id)) || Number(id) === currentUserID);
                        return ((isMyAssignee || isMyObserver) && !isMyCreator) ? "reject" : "cancel";
                    })()}
                    open={dialogStates.confirmCancelAlert}
                    onOpenChange={(open) => setDialogStates(prev => ({ ...prev, confirmCancelAlert: open }))}
                    task={selectedTaskForRecord}
                    shareByWhatsApp={shareActionByWhatsApp}
                    onWhatsAppShareChange={setShareActionByWhatsApp}
                    className="md:w-[400px]"
                    onAction={(actionValue, statusNote) => {
                        if (actionValue === "yes") {
                            handleAction(selectedTaskForRecord, 'CANCEL', false, statusNote);
                        } else {
                            setSelectedTaskForRecord(null);
                        }
                    }}
                />

                {/* Task Reopen Alert */}
                <AlertBox
                    open={dialogStates.confirmReopenAlert}
                    onOpenChange={(open) => setDialogStates(prev => ({ ...prev, confirmReopenAlert: open }))}
                    title="Reopen Task"
                    content={(() => {
                        const myUserIDs = getMyAgenciesMappedIDs('UserID').map(Number);
                        const isOwn = selectedTaskForRecord?.uID && myUserIDs.includes(Number(selectedTaskForRecord.uID));
                        const isSelf = isOwn || Number(selectedTaskForRecord?.uID || 0) === currentUserID;
                        const showWhatsAppOption = !isSelf;
                        const name = getExecutiveName ? getExecutiveName(selectedTaskForRecord?.uID, selectedTaskForRecord) : '';
                        return (
                            <div className="space-y-3">
                                <p className="mb-2"><span className="font-medium text-sahi-primary-color">{selectedTaskForRecord?.ttl}</span></p>
                                {!isOwn && name && name !== 'Not Assigned' && (
                                    <p className="text-sm text-sub-text-color">This will reopen the task and notify {name}.</p>
                                )}
                                {showWhatsAppOption && (
                                    <label className="flex items-center gap-2 mt-2 cursor-pointer select-none text-left w-full justify-start">
                                        <input
                                            type="checkbox"
                                            checked={shareActionByWhatsApp}
                                            onChange={(e) => setShareActionByWhatsApp(e.target.checked)}
                                            className="h-4 w-4 rounded border-gray-300 text-sahi-primary-color focus:ring-sahi-primary-color cursor-pointer accent-sahi-primary-color flex-shrink-0"
                                        />
                                        <span className="text-sm text-text-color font-medium">Send by WhatsApp</span>
                                    </label>
                                )}
                            </div>
                        );
                    })()}
                    className="md:w-[400px]"
                    actions={[
                        { label: "No", value: 'no', variant: 'cancel', icon: <X className="h-4 w-4" /> },
                        { label: "Reopen", value: 'yes', icon: <RotateCcw className="h-4 w-4" /> }
                    ]}
                    onAction={(actionValue) => {
                        if (actionValue === "yes") {
                            handleAction(selectedTaskForRecord, 'REOPEN');
                        } else {
                            setSelectedTaskForRecord(null);
                        }
                    }}
                />

                {/* Record Entry */}
                <RecordEntry
                    triggerButton={false}
                    open={dialogStates.recordEntry}
                    onOpenChange={(open) => {
                        setDialogStates((prev) => ({ ...prev, recordEntry: open }))
                        if (!open) {
                            setSelectedTaskForRecord(null)
                        }
                    }}
                    onRecordAdded={(data) => {
                        setDialogStates(prev => ({ ...prev, recordEntry: false }));
                        if (selectedTaskForRecord) {
                            handleAction(selectedTaskForRecord, 'DONE', pendingRepeatAfterRecordRef.current, pendingStatusNoteAfterRecordRef.current);
                            pendingRepeatAfterRecordRef.current = false;
                            pendingStatusNoteAfterRecordRef.current = "";
                        }
                    }}
                    prefilledData={{
                        connID: selectedTaskForRecord?.connID,
                        connectionLocked: true,
                        bizName: selectedTaskForRecord?.bizName || '',
                        contactName: selectedTaskForRecord?.contactName || '',
                        mobile: selectedTaskForRecord?.mobile || '',
                        email: selectedTaskForRecord?.email || '',
                        connectionType: selectedTaskForRecord?.connType || '',
                        threadIDs: selectedTaskForRecord ? (selectedTaskForRecord.tIDs ? selectedTaskForRecord.tIDs.split(",") : []) : [],
                    }}
                    selectedTaskForRecord={selectedTaskForRecord ? { ...formatTaskData(selectedTaskForRecord), repeatTask: pendingRepeatAfterRecordRef.current, statusNote: pendingStatusNoteAfterRecordRef.current } : null}
                    shouldOpenTaskEntry={true}
                />

                <TaskEntry
                    key="tasks-module-task-entry"
                    dialogTitle={editingTaskID ? 'Edit Task' : 'Add Task'}
                    triggerButton={false}
                    open={dialogStates.taskEntry}
                    onOpenChange={(open) => {
                        setDialogStates((prev) => ({ ...prev, taskEntry: open }));
                        if (!open) {
                            setEditingTaskID(null);
                            setTaskEntryPrefillData({});
                        }
                    }}
                    prefilledData={editingTaskID ? (() => {
                        const task = tasksData.find(t => t.tskID == editingTaskID);
                        return task ? {
                            ...formatTaskData(task),
                            connID: task?.connID,
                            connectionLocked: true,
                            connectionLabel: 'Contact',
                            bizName: task?.bizName || '',
                            contactName: task?.contactName || '',
                            threads: task.tIDs ? task.tIDs.split(',') : '',
                            secConnIDs: task?.scIDs?.split(",").map(id => Number(id)).filter(Boolean),
                            rmdrDT: task?.rmdrDT,
                            AgencyID: task.AgencyID,
                            observerUserIDs: extractObserverUserIDs(task)
                        } : {};
                    })() : taskEntryPrefillData}
                    onTaskAdded={() => {
                        if (!editingTaskID) {
                            if (isMobile) {
                                if (mobileTab === 'history') {
                                    setMobileTab('due');
                                }
                            } else {
                                const isHistoryMode = selectedFilters.status === '2' || selectedFilters.status === '4' || selectedFilters.status === '3';
                                if (isHistoryMode) {
                                    setSelectedFilters(prev => ({
                                        ...prev,
                                        status: 'all'
                                    }));
                                }
                            }
                        }
                    }}
                />

                <UserEntry
                    isOpen={dialogStates.userEntry}
                    setIsOpen={(open) => setDialogStates((prev) => ({ ...prev, userEntry: open }))}
                    userData={null}
                />

                <TemplateDialog
                    isOpen={templateDialogOpen}
                    onClose={() => {
                        setTemplateDialogOpen(false);
                    }}
                    connectionData={templateDialogData}
                    onRecordAdded={null}
                    connID={null}
                />

                <TaskDetails
                    isOpen={openTaskDetail}
                    onClose={() => setOpenTaskDetail(false)}
                    taskID={selectedTaskID}
                    forceTaskClosed={selectedTaskForceClosed}
                    forceCompletedDT={selectedTaskCompletedDT}
                    fallbackTaskData={selectedTaskFallbackData}
                    onTaskUpdate={(action) => {
                        fetchTodayClosedTasks();
                        // Also drop it from the desktop status-filter (Completed/Cancelled/Rejected)
                        // history list in case it was reopened/updated from there.
                        setApiHistoryTasks(prev => prev.filter(t => t.tskID != selectedTaskID));
                        if (action === 'repeat') {
                            if (isMobile) {
                                if (mobileTab === 'history') {
                                    setMobileTab('due');
                                }
                            } else {
                                const isHistoryMode = selectedFilters.status === '2' || selectedFilters.status === '4' || selectedFilters.status === '3';
                                if (isHistoryMode) {
                                    setSelectedFilters(prev => ({
                                        ...prev,
                                        status: 'all'
                                    }));
                                }
                            }
                        } else if (action === 'reopen') {
                            setEditingTaskID(selectedTaskID);
                            setDialogStates(prev => ({ ...prev, taskEntry: true }));
                        }
                    }}
                    mobileActiveTasks={resolvedMobileActiveTasks}
                    onNavigateTask={(nextID) => {
                        setSelectedTaskID(nextID);
                        const nTask = resolvedMobileActiveTasks.find(t => String(t.taskID || t.tskID || t.TaskID) === String(nextID))
                            || tasksData.find(t => String(t.tskID || t.TaskID) === String(nextID))
                            || apiMobileHistoryTasks.find(t => String(t.tskID || t.TaskID) === String(nextID));
                        if (nTask) {
                            const sts = nTask.status !== undefined ? nTask.status : nTask.sts;
                            setSelectedTaskForceClosed(sts === 2 || sts === 4 || sts === 0 || sts === 3);
                            setSelectedTaskCompletedDT(nTask.statusDT || nTask.updatedDT || nTask.dueDT || null);
                            setSelectedTaskFallbackData(nTask.taskID ? nTask : buildTaskDetailsFallback(nTask));
                        }
                    }}
                />

                <Drawer open={calendarDrawerOpen} onOpenChange={setCalendarDrawerOpen}>
                    <DrawerContent className="p-0 [&>div:first-child]:hidden top-auto !h-auto rounded-t-[22px] max-h-[85dvh]">
                        <div className="flex flex-col bg-white rounded-t-[22px] select-none">
                            <div className="flex items-center justify-between p-4 border-b border-zinc-100">
                                <div className="flex items-center gap-4 min-w-0">
                                    <button
                                        type="button"
                                        className="p-0 w-auto h-auto flex-shrink-0 flex justify-center text-gray-500"
                                        onClick={() => setCalendarDrawerOpen(false)}
                                    >
                                        <ArrowLeft className="h-[24px] w-[24px]" />
                                    </button>
                                    <span className="text-lg font-semibold text-gray-900 truncate">Select Date</span>
                                </div>
                                <div className="flex items-center gap-2 shrink-0">
                                    {!(() => {
                                        if (!tempMobileDate) return false;
                                        const today = new Date();
                                        return tempMobileDate.getDate() === today.getDate() &&
                                            tempMobileDate.getMonth() === today.getMonth() &&
                                            tempMobileDate.getFullYear() === today.getFullYear();
                                    })() && (
                                            <SmallButton
                                                onClick={() => {
                                                    const today = new Date();
                                                    setTempMobileDate(today);
                                                    setSelectedMobileDate(today);
                                                    setMobileTab('due');
                                                    setCalendarDrawerOpen(false);
                                                }}
                                            >
                                                Today
                                            </SmallButton>
                                        )}
                                    {!(() => {
                                        if (!tempMobileDate) return false;
                                        const tomorrow = new Date();
                                        tomorrow.setDate(tomorrow.getDate() + 1);
                                        return tempMobileDate.getDate() === tomorrow.getDate() &&
                                            tempMobileDate.getMonth() === tomorrow.getMonth() &&
                                            tempMobileDate.getFullYear() === tomorrow.getFullYear();
                                    })() && (
                                            <SmallButton
                                                onClick={() => {
                                                    const tomorrow = new Date();
                                                    tomorrow.setDate(tomorrow.getDate() + 1);
                                                    setTempMobileDate(tomorrow);
                                                    setSelectedMobileDate(tomorrow);
                                                    setMobileTab('due');
                                                    setCalendarDrawerOpen(false);
                                                }}
                                            >
                                                Tomorrow
                                            </SmallButton>
                                        )}
                                </div>
                            </div>

                            <div className="flex justify-center p-4">
                                <UICalendar
                                    mode="single"
                                    selected={tempMobileDate || new Date()}
                                    onSelect={(date) => {
                                        if (date) {
                                            setTempMobileDate(date);
                                            setSelectedMobileDate(date);
                                            setMobileTab('due');
                                            setCalendarDrawerOpen(false);
                                        }
                                    }}
                                    month={calendarMonth}
                                    onMonthChange={setCalendarMonth}
                                    className="rounded-md border shadow-sm"
                                />
                            </div>

                            <DrawerFooter className="border-t border-zinc-200 p-3 bg-white flex flex-row gap-2">
                                <Button
                                    onClick={() => {
                                        if (tempMobileDate) {
                                            setSelectedMobileDate(tempMobileDate);
                                            setMobileTab('due');
                                        }
                                        setCalendarDrawerOpen(false);
                                    }}
                                    className="sahi-primary-button flex-1"
                                >
                                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                                    Select
                                </Button>
                                <DrawerClose asChild>
                                    <Button
                                        variant="outline"
                                        className="sahi-secondary-button flex-1"
                                        onClick={() => setCalendarDrawerOpen(false)}
                                    >
                                        <X className="h-3.5 w-3.5" />
                                        Cancel
                                    </Button>
                                </DrawerClose>
                            </DrawerFooter>
                        </div>
                    </DrawerContent>
                </Drawer>
                <TaskTimesManager
                    open={taskTimesOpen}
                    onOpenChange={setTaskTimesOpen}
                />

                <Drawer open={viewModeModalOpen} onOpenChange={setViewModeModalOpen}>
                    <DrawerContent className="p-0 [&>div:first-child]:hidden top-auto !h-auto rounded-t-[22px] max-h-[85dvh] border-t border-zinc-100 z-[10002]">
                        <div className="flex flex-col bg-zinc-50 rounded-t-[22px] select-none pb-4">
                            <div className="flex items-center justify-between px-4 h-16 shrink-0 rounded-t-[22px]">
                                <div className="flex gap-4 items-center">
                                    <button
                                        type="button"
                                        tabIndex={-1}
                                        className="p-0 w-auto h-auto flex-shrink-0 flex justify-center text-gray-500 cursor-pointer"
                                        onClick={() => setViewModeModalOpen(false)}
                                    >
                                        <ArrowLeft className="h-[24px] w-[24px]" />
                                    </button>
                                    <p className="text-lg font-semibold text-gray-900">Select View</p>
                                </div>
                            </div>

                            <div className="overflow-y-auto custom-scroll flex-1 px-4 pt-0 pb-0 space-y-3">
                                {[
                                    { key: "category", label: "Category", desc: "Group your tasks by task categories", Icon: Palette, color: "#bf5700" },
                                    { key: "class", label: "Class", desc: "Group by task, meeting, decision and approval.", Icon: Layers, color: "#0D1F2D" },
                                    { key: "watch", label: "Schedule", desc: "View tasks sorted by due dates and timelines.", Icon: Clock, color: "#0B5D1E" }
                                ].map(({ key, label, desc, Icon, color }) => (
                                    <button
                                        key={key}
                                        onClick={() => {
                                            setViewMode(key);
                                            localStorage.setItem("TasksViewMode", key);
                                            window.dispatchEvent(new CustomEvent("tasks-view-mode-changed", { detail: key }));
                                            setViewModeModalOpen(false);
                                        }}
                                        className="w-full flex items-center gap-4 p-3.5 bg-white border border-zinc-200 rounded-[12px] hover:bg-zinc-50 transition-all text-left cursor-pointer group active:bg-zinc-100"
                                    >
                                        <div
                                            className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 text-white transition-transform group-active:scale-95"
                                            style={{ backgroundColor: color }}
                                        >
                                            <Icon className="w-5 h-5" />
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <h4 className="text-sm font-semibold text-gray-900 transition-colors">
                                                {label}
                                            </h4>
                                            <p className="text-xs text-gray-500 mt-0.5 truncate">
                                                {desc}
                                            </p>
                                        </div>
                                        {viewMode === key && (
                                            <CheckCircle className="w-5 h-5 text-sahi-green shrink-0" />
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </DrawerContent>
                </Drawer>
            </div>
        </TooltipProvider >
    );
};

export default Tasks;